import moment$3 from 'moment';
import * as _ from 'lodash';
import { isNumber, isObject } from 'lodash';
import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpParams, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Subject, map, share, catchError, throwError, of, retry, forkJoin, timeout, EMPTY, BehaviorSubject, from, tap as tap$1, shareReplay } from 'rxjs';
import { map as map$1, share as share$1, retry as retry$1, catchError as catchError$1, retryWhen, delay, take, switchMap, finalize, tap } from 'rxjs/operators';
import * as converter from 'xml-js';
import { Guid } from 'guid-typescript';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as Sentry from '@sentry/browser';
import * as i4 from '@angular/router';

class ApiResource {
    getApiDateFields() {
        return [];
    }
    getApiDatetimeFields() {
        return [];
    }
    getApiNumericFields() {
        return [];
    }
    getApiBooleanFields() {
        return [];
    }
    getApiDurationFields() {
        return [];
    }
    fromApi(apiData) {
        const dateFields = this.getApiDateFields();
        const datetimeFields = this.getApiDatetimeFields();
        const numericFields = this.getApiNumericFields();
        const booleanFields = this.getApiBooleanFields();
        const durationFields = this.getApiDurationFields();
        for (let key in apiData) {
            if (!_.isObject(apiData[key])) {
                if (dateFields.includes(key) && !!apiData[key]) {
                    this[key] = moment$3(apiData[key], moment$3.HTML5_FMT.DATETIME_LOCAL);
                }
                else if (datetimeFields.includes(key) && !!apiData[key]) {
                    this[key] = moment$3(apiData[key], moment$3.HTML5_FMT.DATETIME_LOCAL_SECONDS);
                }
                else if (numericFields.includes(key) && !!apiData[key]) {
                    this[key] = Number(apiData[key]);
                }
                else if (booleanFields.includes(key) && !!apiData[key]) {
                    this[key] = this._convertToBoolean(apiData[key]);
                }
                else if (durationFields.includes(key) && !!apiData[key]) {
                    this[key] = moment$3.duration(apiData[key]);
                }
                else {
                    this[key] = apiData[key];
                }
            }
        }
    }
    initObject(apiData, key, obj) {
        if (apiData[key]) {
            obj.fromApi(apiData[key]);
            return obj;
        }
    }
    _convertToBoolean(value) {
        if ((_.isString(value) && value.toLocaleLowerCase() == 'false') || value == "0" || value == 0) {
            return false;
        }
        if (_.isNull(value)) {
            return null;
        }
        else {
            return Boolean(value);
        }
    }
}

class Passenger extends ApiResource {
}

class MinorPassenger extends Passenger {
    getApiNumericFields() {
        return ['fee', 'feeValue', 'markup', 'markupValue', 'serviceStatus', 'serviceValue', 'value'];
    }
    getApiBooleanFields() {
        return ['isMinor'];
    }
}

var AerialSourceEnum;
(function (AerialSourceEnum) {
    AerialSourceEnum["Gol"] = "G3";
    AerialSourceEnum["Azul"] = "AD";
    AerialSourceEnum["Latam"] = "LA";
    AerialSourceEnum["Passaredo"] = "2Z";
    AerialSourceEnum["Sabre"] = "Sabre";
})(AerialSourceEnum || (AerialSourceEnum = {}));
const COMBINED_SOURCES = [
    `${AerialSourceEnum.Gol}.${AerialSourceEnum.Azul}`,
    `${AerialSourceEnum.Gol}.${AerialSourceEnum.Latam}`,
    `${AerialSourceEnum.Azul}.${AerialSourceEnum.Latam}`,
    `${AerialSourceEnum.Azul}.${AerialSourceEnum.Gol}`,
    `${AerialSourceEnum.Latam}.${AerialSourceEnum.Gol}`,
    `${AerialSourceEnum.Latam}.${AerialSourceEnum.Azul}`,
];

class AirlineModel {
    constructor(name, iataCode) {
        this._name = name;
        this._iataCode = iataCode;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get iataCode() {
        return this._iataCode;
    }
    set iataCode(value) {
        this._iataCode = value;
    }
}

class AirportModel {
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get timezone() {
        return this._timezone;
    }
    set timezone(value) {
        this._timezone = value;
    }
    get region() {
        return this._region;
    }
    set region(value) {
        this._region = value;
    }
    get description() {
        return this._description;
    }
    set description(value) {
        this._description = value;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get airportCode() {
        return this._airportCode;
    }
    set airportCode(value) {
        this._airportCode = value;
    }
    get city() {
        return this._city;
    }
    set city(value) {
        this._city = value;
    }
    get country() {
        return this._country;
    }
    set country(value) {
        this._country = value;
    }
    get latitude() {
        return this._latitude;
    }
    set latitude(value) {
        this._latitude = value;
    }
    get longitude() {
        return this._longitude;
    }
    set longitude(value) {
        this._longitude = value;
    }
    get altitude() {
        return this._altitude;
    }
    set altitude(value) {
        this._altitude = value;
    }
    get countryISO() {
        return this._countryISO;
    }
    set countryISO(value) {
        this._countryISO = value;
    }
    get dsgCode() {
        return this._dsgCode;
    }
    set dsgCode(value) {
        this._dsgCode = value;
    }
    static fromData(data) {
        const model = new this();
        model.airportCode = data['IATACode'];
        model.city = data['city'];
        model.country = data['country'];
        model.altitude = data['altitude'];
        model.latitude = data['latitude'];
        model.longitude = data['longitude'];
        model.timezone = data['timezone'];
        model.name = data.hasOwnProperty('name') ? data['name'] : null;
        model.countryISO = data.hasOwnProperty('countries_iso') ? data['countries_iso'] : null;
        model.dsgCode = data.hasOwnProperty('dsgCode') ? data['dsgCode'] : null;
        return model;
    }
    getLocationDescription() {
        return this.city + ', ' + this.region + ', ' + this.country;
    }
    getFullLocationDescription() {
        if (this.description !== null && this.description !== '') {
            return this.description + ', ' + this.getLocationDescription();
        }
        else {
            return this.getLocationDescription();
        }
    }
}

class ApiBaseModel {
}

var ApiFlightType;
(function (ApiFlightType) {
    ApiFlightType["RoundTrip"] = "roundTrip";
    ApiFlightType["OneWay"] = "oneWay";
    ApiFlightType["MultiSlice"] = "multiSlice";
})(ApiFlightType || (ApiFlightType = {}));

class LoginModel extends ApiBaseModel {
}

var ApiFlightDirectionEnum;
(function (ApiFlightDirectionEnum) {
    ApiFlightDirectionEnum["Going"] = "going";
    ApiFlightDirectionEnum["Return"] = "return";
})(ApiFlightDirectionEnum || (ApiFlightDirectionEnum = {}));

class TestimonialModel {
}

class ZupperBlogEntry {
    getImageStyle() {
        if (this.imageUrl) {
            return { backgroundImage: 'url(\'' + this.imageUrl + '\')' };
        }
        else {
            return { backgroundColor: '#ddd' };
        }
    }
}

class BannerModel {
    getImageStyle() {
        if (this.fullPath) {
            return { 'background-image': 'url(\'' + this.fullPath + '\')' };
        }
        else {
            return { 'background-color': '#DDD' };
        }
    }
}

class GroupedFlightBasefare {
    get baggageAllowance() {
        return this._baggageAllowance;
    }
    set baggageAllowance(value) {
        this._baggageAllowance = value;
    }
    get baggageDescription() {
        return this._baggageDescription;
    }
    set baggageDescription(value) {
        this._baggageDescription = value;
    }
    get baseCurrency() {
        return this._baseCurrency;
    }
    set baseCurrency(value) {
        this._baseCurrency = value;
    }
    get baseDuValue() {
        return this._baseDuValue;
    }
    set baseDuValue(value) {
        this._baseDuValue = value;
    }
    get baseFareValue() {
        return this._baseFareValue;
    }
    set baseFareValue(value) {
        this._baseFareValue = value;
    }
    get baseTaxValue() {
        return this._baseTaxValue;
    }
    set baseTaxValue(value) {
        this._baseTaxValue = value;
    }
    get currency() {
        return this._currency;
    }
    set currency(value) {
        this._currency = value;
    }
    get discount() {
        return this._discount;
    }
    set discount(value) {
        this._discount = value;
    }
    get du2Value() {
        return this._du2Value;
    }
    set du2Value(value) {
        this._du2Value = value;
    }
    get duValue() {
        return this._duValue;
    }
    set duValue(value) {
        this._duValue = value;
    }
    get exchangeRate() {
        return this._exchangeRate;
    }
    set exchangeRate(value) {
        this._exchangeRate = value;
    }
    get family() {
        return this._family;
    }
    set family(value) {
        this._family = value;
    }
    get fareValue() {
        return this._fareValue;
    }
    set fareValue(value) {
        this._fareValue = value;
    }
    get freeText() {
        return this._freeText;
    }
    set freeText(value) {
        this._freeText = value;
    }
    get incentiveValue() {
        return this._incentiveValue;
    }
    set incentiveValue(value) {
        this._incentiveValue = value;
    }
    get paxType() {
        return this._paxType;
    }
    set paxType(value) {
        this._paxType = value;
    }
    get rule() {
        return this._rule;
    }
    set rule(value) {
        this._rule = value;
    }
    get ruleCode() {
        return this._ruleCode;
    }
    set ruleCode(value) {
        this._ruleCode = value;
    }
    get taxValue() {
        return this._taxValue;
    }
    set taxValue(value) {
        this._taxValue = value;
    }
}

class GroupedFlightMapper {
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    get credentialName() {
        return this._credentialName;
    }
    set credentialName(value) {
        this._credentialName = value;
    }
    get international() {
        return this._international;
    }
    set international(value) {
        this._international = value;
    }
    get totalAirportTaxesPrice() {
        return this._totalAirportTaxesPrice;
    }
    set totalAirportTaxesPrice(value) {
        this._totalAirportTaxesPrice = value;
    }
    get totalDuPrice() {
        return this._totalDuPrice;
    }
    set totalDuPrice(value) {
        this._totalDuPrice = value;
    }
    get totalDu2Price() {
        return this._totalDu2Price;
    }
    set totalDu2Price(value) {
        this._totalDu2Price = value;
    }
    get totalFarePrice() {
        return this._totalFarePrice;
    }
    set totalFarePrice(value) {
        this._totalFarePrice = value;
    }
    get totalIncentiveValue() {
        return this._totalIncentiveValue;
    }
    set totalIncentiveValue(value) {
        this._totalIncentiveValue = value;
    }
    get totalPrice() {
        return this._totalPrice;
    }
    set totalPrice(value) {
        this._totalPrice = value;
    }
    get groupedSlicesByDirection() {
        return this._groupedSlicesByDirection;
    }
    set groupedSlicesByDirection(value) {
        this._groupedSlicesByDirection = value;
    }
    get families() {
        return this._families;
    }
    set families(value) {
        this._families = value;
    }
    addGroupedSliceByDirection(slice) {
        if (!_.isArray(this._groupedSlicesByDirection)) {
            this.groupedSlicesByDirection = [slice];
        }
        else {
            this._groupedSlicesByDirection.push(slice);
        }
    }
    get origin() {
        return this._origin;
    }
    set origin(value) {
        this._origin = value;
    }
    get destination() {
        return this._destination;
    }
    set destination(value) {
        this._destination = value;
    }
    get issuingAirline() {
        return this._issuingAirline;
    }
    set issuingAirline(value) {
        this._issuingAirline = value;
    }
    get departureDate() {
        return this._departureDate;
    }
    set departureDate(value) {
        this._departureDate = value;
    }
    get returnDate() {
        return this._returnDate;
    }
    set returnDate(value) {
        this._returnDate = value;
    }
    get departureWeekDay() {
        return this._departureWeekDay;
    }
    set departureWeekDay(value) {
        this._departureWeekDay = value;
    }
    get returnWeekDay() {
        return this._returnWeekDay;
    }
    set returnWeekDay(value) {
        this._returnWeekDay = value;
    }
    get airlineName() {
        return this._airlineName;
    }
    set airlineName(value) {
        this._airlineName = value;
    }
    toJSON() {
        return {
            type: this.type,
            credentialName: this.credentialName,
            origin: this.origin,
            destination: this.destination,
            departureDate: this.departureDate,
            departureWeekDay: this.departureWeekDay,
            returnDate: this.returnDate,
            returnWeekDay: this.returnWeekDay,
            issuingAirline: this.issuingAirline,
            airlineName: this.airlineName,
            international: this.international,
            totalAirportTaxesPrice: this.totalAirportTaxesPrice,
            totalDuPrice: this.totalDuPrice,
            totalDu2Price: this.totalDu2Price,
            totalFarePrice: this.totalFarePrice,
            totalIncentiveValue: this.totalIncentiveValue,
            totalPrice: this.totalPrice,
            groupedSlicesByDirection: this.groupedSlicesByDirection,
            families: this.families
        };
    }
}

class GroupedFlightSegment {
    get aircraft() {
        return this._aircraft;
    }
    set aircraft(value) {
        this._aircraft = value;
    }
    get arrivalDate() {
        return this._arrivalDate;
    }
    set arrivalDate(value) {
        this._arrivalDate = value;
    }
    get cabin() {
        return this._cabin;
    }
    set cabin(value) {
        this._cabin = value;
    }
    get carrierAirline() {
        return this._carrierAirline;
    }
    set carrierAirline(value) {
        this._carrierAirline = value;
    }
    get class() {
        return this._class;
    }
    set class(value) {
        this._class = value;
    }
    get departureDate() {
        return this._departureDate;
    }
    set departureDate(value) {
        this._departureDate = value;
    }
    get destinationAirport() {
        return this._destinationAirport;
    }
    set destinationAirport(value) {
        this._destinationAirport = value;
    }
    get flightNumber() {
        return this._flightNumber;
    }
    set flightNumber(value) {
        this._flightNumber = value;
    }
    get flightTime() {
        return this._flightTime;
    }
    set flightTime(value) {
        this._flightTime = value;
    }
    get freeText() {
        return this._freeText;
    }
    set freeText(value) {
        this._freeText = value;
    }
    get originAirport() {
        return this._originAirport;
    }
    set originAirport(value) {
        this._originAirport = value;
    }
    get scaleCount() {
        return this._scaleCount;
    }
    set scaleCount(value) {
        this._scaleCount = value;
    }
    get sellerAirline() {
        return this._sellerAirline;
    }
    set sellerAirline(value) {
        this._sellerAirline = value;
    }
}

class GroupedFlightSlice {
    constructor() {
        this._visible = true;
    }
    get showDetails() {
        return this._showDetails;
    }
    set showDetails(value) {
        this._showDetails = value;
    }
    get baggageAllowance() {
        return this._baseFares[0].baggageAllowance;
    }
    get arrivalDate() {
        return this._arrivalDate;
    }
    set arrivalDate(value) {
        this._arrivalDate = value;
    }
    get baseFares() {
        return this._baseFares;
    }
    set baseFares(value) {
        this._baseFares = value;
    }
    addBaseFare(basefare) {
        if (!_.isArray(this._baseFares)) {
            this.baseFares = [basefare];
        }
        else {
            this._baseFares.push(basefare);
        }
    }
    get departureDate() {
        return this._departureDate;
    }
    set departureDate(value) {
        this._departureDate = value;
    }
    get destination() {
        return this._destination;
    }
    set destination(value) {
        this._destination = value;
    }
    get direction() {
        return this._direction;
    }
    set direction(value) {
        this._direction = value;
    }
    get du2Price() {
        return this._du2Price;
    }
    set du2Price(value) {
        this._du2Price = value;
    }
    get duPrice() {
        return this._duPrice;
    }
    set duPrice(value) {
        this._duPrice = value;
    }
    get flightTime() {
        return this._flightTime;
    }
    set flightTime(value) {
        this._flightTime = value;
    }
    get freeText() {
        return this._freeText;
    }
    set freeText(value) {
        this._freeText = value;
    }
    get incentivePrice() {
        return this._incentivePrice;
    }
    set incentivePrice(value) {
        this._incentivePrice = value;
    }
    get issuingAirline() {
        return this._issuingAirline;
    }
    set issuingAirline(value) {
        this._issuingAirline = value;
    }
    get origin() {
        return this._origin;
    }
    set origin(value) {
        this._origin = value;
    }
    get segments() {
        return this._segments;
    }
    set segments(value) {
        this._segments = value;
    }
    addSegment(segment) {
        if (!_.isArray(this._segments)) {
            this.segments = [segment];
        }
        else {
            this._segments.push(segment);
        }
    }
    get source() {
        return this._source;
    }
    set source(value) {
        this._source = value;
    }
    get taxPrice() {
        return this._taxPrice;
    }
    set taxPrice(value) {
        this._taxPrice = value;
    }
    get visible() {
        return this._visible;
    }
    set visible(value) {
        this._visible = value;
    }
}

class GroupedFlightSliceDirection {
    get direction() {
        return this._direction;
    }
    set direction(value) {
        this._direction = value;
    }
    get slices() {
        return this._slices;
    }
    set slices(value) {
        this._slices = value;
    }
    addSlice(value) {
        if (!_.isArray(this._slices)) {
            this.slices = [value];
        }
        else {
            this._slices.push(value);
        }
    }
    toJSON() {
        return {
            direction: this.direction,
            slices: this.slices
        };
    }
}

class GroupedFamiliesBasefare {
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
    }
    get airline() {
        return this._airline;
    }
    set airline(value) {
        this._airline = value;
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        this._enabled = value;
    }
    get logoUrl() {
        return this._logoUrl;
    }
    set logoUrl(value) {
        this._logoUrl = value;
    }
    get details() {
        return this._details;
    }
    set details(value) {
        this._details = value;
    }
    addDetails(basefare) {
        if (!_.isArray(this._details)) {
            this.details = [basefare];
        }
        else {
            this._details.push(basefare);
        }
    }
    toJSON() {
        return {
            name: this.name,
            order: this.order,
            airline: this.airline,
            details: this.details,
            logoUrl: this.logoUrl
        };
    }
}

class GroupedFamiliesDetails {
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
    }
    get notes() {
        return this._notes;
    }
    set notes(value) {
        this._notes = value;
    }
    toJSON() {
        return {
            name: this.name,
            value: this.value,
            order: this.order,
            notes: this.notes,
        };
    }
}

class ApiFlightRequest {
    constructor() {
        this._credentialName = null;
        this._adultQty = 1;
        this._childrenQty = 0;
        this._infantQty = 0;
        this._onlyEconomicClass = true;
        this._onlyBusinessClass = false;
        this._forceCacheRefresh = true;
        this._groupedByOptions = false;
        this._grouped = true;
        this._type = ApiFlightType.OneWay;
        this._credentialName = null;
    }
    toParams() {
        const model = {};
        model["type"] = this.type.toString();
        model["adultQty"] = this.adultQty;
        model["childrenQty"] = this.childrenQty;
        model["infantQty"] = this.infantQty;
        model["onlyBusinessClass"] = this.onlyBusinessClass;
        model["onlyEconomicClass"] = this.onlyEconomicClass;
        model["grouped"] = this.grouped;
        model["forceCacheRefresh"] = this.forceCacheRefresh;
        model["groupedByOptions"] = this.groupedByOptions;
        model["minPrice"] = this.minPrice;
        model["maxPrice"] = this.maxPrice;
        model["airlines"] = this.airlines;
        model["credentialName"] = this._credentialName;
        if (this.slices) {
            for (let i = 0; i < this.slices.length; i++) {
                model["slices[" + i + "][originAirport]"] =
                    this.slices[i].originAirport;
                model["slices[" + i + "][destinationAirport]"] =
                    this.slices[i].destinationAirport;
                model["slices[" + i + "][departureDate]"] =
                    this.slices[i].departureDate;
            }
        }
        return model;
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    get slices() {
        return this._slices;
    }
    set slices(value) {
        this._slices = value;
    }
    get airlines() {
        return this._airlines;
    }
    set airlines(value) {
        this._airlines = value;
    }
    get minPrice() {
        return this._minPrice;
    }
    set minPrice(value) {
        this._minPrice = value;
    }
    get maxPrice() {
        return this._maxPrice;
    }
    set maxPrice(value) {
        this._maxPrice = value;
    }
    get grouped() {
        return this._grouped;
    }
    set grouped(value) {
        this._grouped = value;
    }
    get forceCacheRefresh() {
        return this._forceCacheRefresh;
    }
    set forceCacheRefresh(value) {
        this._forceCacheRefresh = value;
    }
    get groupedByOptions() {
        return this._groupedByOptions;
    }
    set groupedByOptions(value) {
        this._groupedByOptions = value;
    }
    set adultQty(adultQty) {
        this._adultQty = adultQty;
    }
    get adultQty() {
        if (this._adultQty === null ||
            this._adultQty === undefined ||
            this._adultQty <= 1) {
            return 1;
        }
        return this._adultQty;
    }
    set childrenQty(childrenQty) {
        this._childrenQty = childrenQty;
    }
    get childrenQty() {
        if (this._childrenQty === null ||
            this._childrenQty === undefined ||
            this._childrenQty <= 0) {
            return 0;
        }
        return this._childrenQty;
    }
    set infantQty(infantQty) {
        this._infantQty = infantQty;
    }
    get infantQty() {
        if (this._infantQty === null ||
            this._infantQty === undefined ||
            this._infantQty <= 0) {
            return 0;
        }
        return this._infantQty;
    }
    get onlyBusinessClass() {
        return this._onlyBusinessClass;
    }
    set onlyBusinessClass(value) {
        this._onlyBusinessClass = value;
    }
    get onlyEconomicClass() {
        return this._onlyEconomicClass;
    }
    set onlyEconomicClass(value) {
        this._onlyEconomicClass = value;
    }
    set credentialName(value) {
        this._credentialName = value;
    }
    get credentialName() {
        return this._credentialName;
    }
    addSlice(slice) {
        if (!_.isArray(this._slices)) {
            this.slices = [slice];
        }
        else {
            this._slices.push(slice);
        }
    }
    toJSON() {
        return {
            type: this.type,
            adultQty: this.adultQty,
            childrenQty: this.childrenQty,
            infantQty: this.infantQty,
            slices: this.slices,
            airlines: this.airlines,
            minPrice: this.minPrice,
            maxPrice: this.maxPrice,
            grouped: this.grouped,
            forceCacheRefresh: this.forceCacheRefresh,
            groupedByOptions: this.groupedByOptions,
            credentialName: this.credentialName
        };
    }
}

class ApiFlightSlice {
}

class ApiHotelRequest {
    constructor() {
        this.starRatings = [];
        this.billingMethods = [];
        this.hotelChains = [];
        this.minPrice = 0;
        this.maxPrice = 0;
        this.forceCacheRefresh = false;
    }
    toParams() {
        const model = {};
        model['cityId'] = this.cityId;
        model['adultQty'] = this.adultQty;
        model['childrenQty'] = this.childrenQty;
        model['roomQty'] = this.roomQty;
        model['checkInDate'] = this.checkInDate.format(moment$3.HTML5_FMT.DATE);
        model['checkOutDate'] = this.checkOutDate.format(moment$3.HTML5_FMT.DATE);
        model['credentialName'] = this.credentialName;
        model['starRatings'] = this.starRatings;
        model['hotelChains'] = this.hotelChains;
        model['billingMethods'] = this.billingMethods;
        model['minPrice'] = this.minPrice;
        model['maxPrice'] = this.maxPrice;
        model['forceCacheRefresh'] = this.forceCacheRefresh;
        return model;
    }
}
var HotelBillingMethodEnum;
(function (HotelBillingMethodEnum) {
    HotelBillingMethodEnum["DAILY_ONLY"] = "DailyOnly";
    HotelBillingMethodEnum["DAILY_EXTRA"] = "DailyExtra";
    HotelBillingMethodEnum["DAILY_EXTRA_NO_ALCOHOL"] = "DailyExtraNoAlcohol";
    HotelBillingMethodEnum["DAILY_LAUNDRY"] = "DailyLaundry";
    HotelBillingMethodEnum["DAILY_BREAKFAST_PHONE"] = "DailyBreakfastPhone";
    HotelBillingMethodEnum["DAILY_BREAKFAST_LAUNDRY"] = "DailyBreakfastLaundry";
    HotelBillingMethodEnum["DAILY_BREAKFAST"] = "DailyBreakfast";
    HotelBillingMethodEnum["UNDEFINED"] = "Undefined";
})(HotelBillingMethodEnum || (HotelBillingMethodEnum = {}));
var HotelGuaranteeMethodEnum;
(function (HotelGuaranteeMethodEnum) {
    HotelGuaranteeMethodEnum["UNDEFINED"] = "Undefined";
    HotelGuaranteeMethodEnum["CREDIT_CARD"] = "CreditCard";
    HotelGuaranteeMethodEnum["AGENCY"] = "Agency";
})(HotelGuaranteeMethodEnum || (HotelGuaranteeMethodEnum = {}));
var HotelPaymentMethodEnum;
(function (HotelPaymentMethodEnum) {
    HotelPaymentMethodEnum["AGENCY"] = "Agency";
    HotelPaymentMethodEnum["CREDIT_CARD"] = "CreditCard";
    HotelPaymentMethodEnum["UNDEFINED"] = "Undefined";
    HotelPaymentMethodEnum["DIRECT"] = "Direct";
})(HotelPaymentMethodEnum || (HotelPaymentMethodEnum = {}));
var HotelPensionTypeEnum;
(function (HotelPensionTypeEnum) {
    HotelPensionTypeEnum["UNDEFINED"] = "Undefined";
    HotelPensionTypeEnum["ACCOMODATION_ONLY"] = "AccomodationOnly";
    HotelPensionTypeEnum["BED_AND_BREAKFAST"] = "BedAndBreakfast";
    HotelPensionTypeEnum["BREAKFAST"] = "Breakfast";
    HotelPensionTypeEnum["HALF_BOARD"] = "Half-Board";
    HotelPensionTypeEnum["FULL_BOARD"] = "Full-Board";
})(HotelPensionTypeEnum || (HotelPensionTypeEnum = {}));

class ApiPackagePriceRequest {
}

class ApiPackageBookRequest {
    toApi() {
        const obj = JSON.parse(JSON.stringify(this));
        obj['aerial'] = this.aerial.toApi();
        obj['hotel'] = this.hotel.toApi();
        return obj;
    }
}

class FlightResultModel {
}

class AppSettings {
}

class HotelValue {
    loadFromApi(data) {
        this.originalCurrency = data['original']['currencyCode'];
        this.originalValue = data['original']['value'];
        this.convertedCurrency = data['converted']['currencyCode'];
        this.convertedValue = data['converted']['value'];
        this.exchange = data['exchange'];
    }
}

class CreditCardPaymentModel extends ApiResource {
    getApiNumericFields() {
        return ['cardExpirationMonth', 'cardExpirationYear', 'firstInstallmentValue', 'installmentCount', 'remainingInstallmentValue', 'taxValue', 'totalValue'];
    }
}

var MOMENT_FORMATS;
(function (MOMENT_FORMATS) {
    MOMENT_FORMATS["API_DATE"] = "YYYY-MM-DD";
    MOMENT_FORMATS["API_DATETIME"] = "YYYY-MM-DD HH:mm";
    MOMENT_FORMATS["API_DATETIME_SECONDS"] = "YYYY-MM-DD HH:mm:ss";
    MOMENT_FORMATS["API_FULL_DATETIME"] = "YYYY-MM-DDTHH:mm";
    MOMENT_FORMATS["API_FULL_DATETIME_SECONDS"] = "YYYY-MM-DDTHH:mm:ss";
    MOMENT_FORMATS["API_FULL_DATETIME_TIMEZONE"] = "YYYY-MM-DDTHH:mm:ssZ";
})(MOMENT_FORMATS || (MOMENT_FORMATS = {}));

class HotelImages extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
        if (!this.description) {
            this.description = apiData['type'];
        }
    }
}
const HOTEL_IMAGE_TYPES$1 = ['BIG', 'TBH', 'PAN'];
class HotelRoomModel extends ApiResource {
    constructor() {
        super(...arguments);
        this.images = [];
        this.quotations = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['images'])) {
            this.images = apiData['images'].map(x => {
                const model = new HotelImages();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['quotations'])) {
            this.quotations = apiData['quotations'].map(x => {
                const model = new HotelQuotationsModel();
                model.fromApi(x);
                return model;
            });
        }
    }
    getApiNumericFields() {
        return ['capacity'];
    }
}
class HotelQuotationsModel extends ApiResource {
    constructor() {
        super(...arguments);
        this.availableBillingMethods = [];
        this.availableGuaranteeMethods = [];
        this.availablePaymentMethods = [];
        this.qty = 0;
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        this.roomQuotation = new HotelRoomQuotationModel();
        this.roomQuotation.fromApi(apiData['roomQuotation']);
    }
    getApiBooleanFields() {
        return ['demandsNoShowGuarantee'];
    }
    getApiNumericFields() {
        return ['qty'];
    }
    static hasBreakfast(quotation) {
        return [
            "Breakfast",
            "BedAndBreakfast",
            PENSION_TYPES_AND_DESCRIPTION$2.AD
        ].includes(quotation?.roomQuotation?.pensionType?.description);
    }
}
class HotelRoomQuotationModel extends ApiResource {
    constructor() {
        super(...arguments);
        this.features = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        this.cancellingPolicy = new HotelCancellingPolicyModel();
        if (apiData['cancellingPolicy'] !== null) {
            this.cancellingPolicy.fromApi(apiData['cancellingPolicy']);
        }
        this.dailyFare = new HotelFareModel();
        this.dailyFare.fromApi(apiData['dailyFare']);
        this.fare = new HotelFareModel();
        this.fare.fromApi(apiData['fare']);
        this.taxes = new HotelFareModel();
        this.taxes.fromApi(apiData['taxes']);
        this.totalValue = new HotelFareModel();
        this.totalValue.fromApi(apiData['totalValue']);
        this.resortTax = new HotelFareModel();
        this.resortTax.fromApi(apiData['resortTax']);
        this.pensionType = new PensionType();
        this.pensionType.fromApi(apiData['pensionType']);
        this.features = apiData['features'];
    }
    toApi() {
        const obj = JSON.parse(JSON.stringify(this));
        obj['checkIn'] = this.checkIn.format(MOMENT_FORMATS.API_FULL_DATETIME_SECONDS);
        obj['checkOut'] = this.checkOut.format(MOMENT_FORMATS.API_FULL_DATETIME_SECONDS);
        if (this.cancellingPolicy) {
            obj['cancellingPolicy'] = this.cancellingPolicy.toApi();
        }
        return obj;
    }
    getApiNumericFields() {
        return ['adultQty', 'childrenQty', 'fee', 'capacity'];
    }
    getApiDatetimeFields() {
        return ['checkIn', 'checkOut'];
    }
}
const PensionTypeCodes$2 = ['SA', 'TI', 'AD', 'PC', 'MP', 'DYS'];
const PENSION_TYPES_AND_DESCRIPTION$2 = {
    SA: 'Accommodation only',
    TI: 'All inclusive',
    AD: 'Bed & Breakfast',
    PC: 'Full board',
    MP: 'Half board',
    DYS: 'Room + Ticket',
};
class PensionType extends ApiResource {
}
class HotelCancellingPolicyModel extends ApiResource {
    constructor() {
        super(...arguments);
        this.apiDateFormat = MOMENT_FORMATS.API_FULL_DATETIME_SECONDS;
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        this.start = (apiData['Inicio'] || apiData['start'])
            ? moment$3(apiData['start'] ?? apiData['Inicio'], this.apiDateFormat)
            : null;
        this.end = (apiData['Fim'] || apiData['end'])
            ? moment$3(apiData['end'] ?? apiData['Fim'], this.apiDateFormat)
            : null;
        this.value = new HotelFareModel();
        if (!!apiData['Valor']) {
            this.value.fromApi(apiData['Valor'], true);
        }
        else if (!!apiData['value']) {
            this.value.fromApi(apiData['value']);
        }
    }
    toApi(isBooking = false) {
        if (!isBooking) {
            return {
                Inicio: this.start?.format(this.apiDateFormat),
                Fim: this.end?.format(this.apiDateFormat),
                Valor: this.value?.toApi(true)
            };
        }
        else {
            return {
                start: this.start?.format(this.apiDateFormat),
                end: this.end?.format(this.apiDateFormat),
                value: this.value?.toApi(false)
            };
        }
    }
}
class HotelFareModel extends ApiResource {
    fromApi(apiData, legacy = false) {
        if (!!apiData) {
            super.fromApi(apiData);
            const convertedField = legacy ? 'Convertido' : 'converted';
            this.converted = new HotelCurrencyModel();
            this.converted.fromApi(isNumber(apiData) ? apiData : apiData[convertedField], legacy);
            const originalField = legacy ? 'Original' : 'original';
            this.original = new HotelCurrencyModel();
            this.original.fromApi(apiData[originalField], legacy);
            const exchangeField = legacy ? 'Cambio' : 'exchange';
            this.exchange = Number(apiData[exchangeField]);
        }
    }
    static fromNumberValue(value, currencyCode = 'BRL') {
        const result = new HotelFareModel();
        result.exchange = 1;
        result.converted = HotelCurrencyModel.fromNumberValue(value);
        result.original = HotelCurrencyModel.fromNumberValue(value);
        return result;
    }
    toApi(legacy = false) {
        if (legacy) {
            return {
                Cambio: this.exchange,
                Convertido: this.converted.toApi(true),
                Original: this.original.toApi(true)
            };
        }
        else {
            return JSON.parse(JSON.stringify(this));
        }
    }
}
class HotelCurrencyModel extends ApiResource {
    fromApi(apiData, legacy = false) {
        super.fromApi(apiData);
        if (legacy) {
            this.currencyCode = apiData['SiglaMoeda'] ?? '';
            this.value = Number(apiData['Valor'] ?? apiData);
        }
        if (isNumber(apiData)) {
            this.value = Number(apiData);
        }
    }
    static fromNumberValue(value, currencyCode = 'BRL') {
        const result = new HotelCurrencyModel();
        result.currencyCode = currencyCode;
        result.value = value;
        return result;
    }
    getApiNumericFields() {
        return ['value'];
    }
    toApi(legacy = false) {
        if (legacy) {
            return {
                SiglaMoeda: this.currencyCode,
                Valor: this.value
            };
        }
        else {
            return JSON.parse(JSON.stringify(this));
        }
    }
}
class HotelMainImage extends HotelImages {
}
const HOTEL_FEATURES = [
    "WIFI",
    "Pool",
    "Restaurant",
    "Aditional Info Test",
    "Hair dryer",
    "Safe"
];
class HotelContactsModel extends ApiResource {
}
const HOTEL_CONTACT_TYPES = ["PHONE", "FAX", "EMAIL"];
class HotelBestPriceModel extends HotelFareModel {
}
class HotelAddressModel extends ApiResource {
    getApiNumericFields() {
        return ['latitude', 'longitude'];
    }
}
class HotelInterestPoint extends ApiResource {
    getApiNumericFields() {
        return ['distancia'];
    }
}
class HotelChainModel extends ApiResource {
    getApiBooleanFields() {
        return ['active'];
    }
}
class PricedHotelModel extends ApiResource {
    constructor() {
        super(...arguments);
        this.guests = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['guests'])) {
            this.guests = apiData['guests'].map(x => {
                const model = new GuestPriceResponse();
                model.fromApi(x);
                return model;
            });
        }
        this.payment = this.initObject(apiData, 'payment', new CreditCardPaymentModel());
        this.quotation = this.initObject(apiData, 'quotation', new HotelRoomQuotationModel());
    }
    getApiBooleanFields() {
        return ['demandsNoShowGuarantee'];
    }
    getApiNumericFields() {
        return ['starRating'];
    }
}
class GuestPriceResponse extends ApiResource {
    getApiDateFields() {
        return ['birthDate'];
    }
    getApiNumericFields() {
        return ['age'];
    }
}

class HotelRoomGuestModel {
    constructor() {
        this.adultQty = 2;
        this.infantQty = 0;
        this.childrenQty = 0;
        this.childAges = [];
        this.maxAdultQty = 4;
        this.maxChildrenQty = 3;
    }
    addAdult() {
        if (this.adultQty < this.maxAdultQty) {
            this.adultQty += 1;
        }
    }
    removeAdult() {
        if (this.adultQty <= 1) {
            this.adultQty = 1;
        }
        else {
            this.adultQty -= 1;
        }
    }
    addInfant() {
        if (this.adultQty + this.childrenQty + this.infantQty <= 5) {
            this.infantQty += 1;
        }
    }
    removeInfant() {
        if (this.infantQty <= 0) {
            this.infantQty = 0;
        }
        else {
            this.infantQty -= 1;
        }
    }
    addChild() {
        if (this.adultQty + this.childrenQty + this.infantQty <= 5) {
            this.childrenQty += 1;
        }
    }
    removeChild() {
        if (this.childrenQty <= 0) {
            this.childrenQty = 0;
        }
        else {
            this.childrenQty -= 1;
            this.childAges.pop();
        }
    }
    setChildAge(childIndex, age) {
        this.childAges[childIndex] = age;
    }
}
class RoomSearchModel {
    constructor() {
        this.rooms = [];
        this.credentialName = 'Default';
        this.cityId = null;
        this.checkInDate = null;
        this.checkOutDate = null;
        this.credentialName = null;
        this.quotationText = null;
        this.limit = null;
        this.offset = null;
        this.sourceCode = null;
    }
    toApiRequest() {
        return {
            cityId: this.cityId,
            rooms: this.rooms,
            checkInDate: this.checkInDate.format(MOMENT_FORMATS.API_DATE),
            checkOutDate: this.checkOutDate.format(MOMENT_FORMATS.API_DATE),
            credentialName: this.credentialName,
            quotationText: this.quotationText,
            limit: this.limit,
            offset: this.offset
        };
    }
}
class HotelRoomsSearchRequestModel {
    constructor(initialData = null) {
        this.districts = [];
        this.interestPoints = [];
        this.rooms = [];
        this.starRatings = [];
        if (initialData !== null) {
            this.amountDays = initialData.amountDays;
            this.checkInDate = initialData.checkInDate;
            this.checkOutDate = initialData.checkOutDate;
            this.cityId = initialData.cityId;
            this.destination = initialData.destination;
            initialData.rooms.forEach((room => {
                let newRoom = new HotelRoomGuestModel();
                newRoom.adultQty = room.adultQty;
                newRoom.childrenQty = room.childrenQty;
                newRoom.childAges = room.childAges;
                newRoom.infantQty = room.infantQty;
                this.rooms.push(newRoom);
            }));
        }
    }
    getDiffBetweenDates() {
        let initDate = new Date(this.checkInDate);
        let finalDate = new Date(this.checkOutDate);
        return ((finalDate.getTime() - initDate.getTime()) / (1000 * 60 * 60 * 24));
    }
    getAdultQty() {
        let totalAdults = 0;
        this.rooms.forEach(room => {
            totalAdults += room.adultQty;
        });
        return totalAdults;
    }
    getChildrenQty() {
        let totalChildren = 0;
        this.rooms.forEach(room => {
            totalChildren += room.childrenQty;
        });
        return totalChildren;
    }
    getRoomQty() {
        return this.rooms.length;
    }
}
class AvailableCitiesModel extends ApiResource {
    constructor() {
        super(...arguments);
        this.airports = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['airports'])) {
            this.airports = apiData['airports'].map(x => AirportModel.fromData(x));
        }
    }
    getApiBooleanFields() {
        return ['isAirport'];
    }
}
class HotelResultFilters {
    constructor() {
        this.filterData = new HotelFilterData();
    }
}
class HotelFilterData {
    constructor() {
        this.maxPrice = 100000;
        this.minPrice = 0;
    }
}
class RoomOptions extends ApiResource {
    constructor() {
        super(...arguments);
        this.quotations = [];
        this.selected = false;
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['images'])) {
            this.images = apiData['images'].map((x) => {
                const model = new HotelImages();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['quotations'])) {
            this.quotations = apiData['quotations'].map((x) => {
                const model = new HotelQuotationsModel();
                model.fromApi(x);
                return model;
            });
        }
        this.mainImage = this.initObject(apiData, 'mainImage', new HotelImages());
    }
    getApiBooleanFields() {
        return ['selected'];
    }
}
class HotelGuestModel {
    constructor() {
        this.firstName = null;
        this.lastName = null;
        this.type = "Adult";
        this.gender = null;
        this.email = null;
        this.birthDate = null;
        this.document = null;
        this.rg = null;
        this.surname = null;
    }
}
class HotelPricingModel {
    constructor() {
        this.billingMethod = 'Undefined';
        this.credentialName = "Default";
        this.demandsNoShowGuarantee = false;
        this.features = [];
        this.guaranteeMethod = 'Undefined';
        this.guests = [];
        this.paymentMethod = 'Undefined';
        this.quotations = [];
    }
    toApi() {
        const jsonObj = JSON.parse(JSON.stringify(this));
        this.quotations.forEach((q, i) => {
            jsonObj['quotations'][i] = q.toApi();
            if (!!q.cancellingPolicy) {
                const cancellingPolicy = q.cancellingPolicy.toApi();
                jsonObj['quotations'][i]['cancellingPolicy'] = cancellingPolicy;
            }
        });
        return jsonObj;
    }
}
class BookingConfirmation extends ApiResource {
    constructor() {
        super(...arguments);
        this.bookings = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['bookings'])) {
            this.bookings = apiData['bookings'].map(x => {
                const model = new BookingDetails();
                model.fromApi(x);
                return model;
            });
        }
    }
}
class HotelBookingHotelInfo extends ApiResource {
}
class HotelBookingRoomInfo extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
        this.quotation = new HotelRoomQuotationModel();
        this.quotation.fromApi(apiData['quotation']);
        if (Array.isArray(apiData['guests'])) {
            this.guests = apiData['guests'].map(x => {
                const model = new GuestPriceResponse();
                model.fromApi(x);
                return model;
            });
        }
    }
}
class BookingDetails extends ApiResource {
    constructor() {
        super(...arguments);
        this.rooms = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['rooms'])) {
            this.rooms = apiData['rooms'].map(x => {
                const model = new HotelBookingRoomInfo();
                model.fromApi(x);
                return model;
            });
        }
    }
}
class InstallmentsModel {
    constructor() {
        this.installmentsValues = [];
    }
}
class BookingResume {
}
class BookRequestHotelModel extends PricedHotelModel {
}
class HotelBookingConfirmation extends BookingConfirmation {
}
class HotelDistrict {
}

class ApiJuniperHotelRoomSearchResponseModel extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
        this.pensionType = new JuniperHotelRoomPensionType();
        this.pensionType.fromApi(apiData['pensionType']);
        this.price = new JuniperHotelRoomPrice();
        this.price.fromApi(apiData['price']);
        if (Array.isArray(apiData['rooms'])) {
            this.rooms = apiData['rooms'].map(x => {
                const model = new JuniperHotelRoom();
                model.fromApi(x);
                return model;
            });
        }
        else if (!apiData['rooms']) {
            this.rooms = [];
        }
        if (apiData['cancellationPolicy']) {
            this.cancellationPolicy = new JuniperHotelRoomCancellationPolicy();
            this.cancellationPolicy.fromApi(apiData['cancellationPolicy']);
        }
    }
    static hasBreakfast(room) {
        return [
            "Breakfast",
            "BedAndBreakfast",
            PENSION_TYPES_AND_DESCRIPTION$1.AD
        ].includes(room?.pensionType?.description);
    }
}
const PensionTypeCodes$1 = ['SA', 'TI', 'AD', 'PC', 'MP', 'DYS'];
const PENSION_TYPES_AND_DESCRIPTION$1 = {
    SA: 'Accommodation only',
    TI: 'All inclusive',
    AD: 'Bed & Breakfast',
    PC: 'Full board',
    MP: 'Half board',
    DYS: 'Room + Ticket',
};
class JuniperHotelRoomPensionType extends ApiResource {
}
class JuniperHotelRoomPrice extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
    getApiNumericFields() {
        return ['total', 'fare', 'tax', 'fee', 'fareAveragePerRoom'];
    }
}
class JuniperHotelRoomOccupancy extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
    getApiNumericFields() {
        return ['occupancy', 'maxOccupancy', 'adults', 'children'];
    }
}
class JuniperHotelRoom extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
        this.occupancy = new JuniperHotelRoomOccupancy();
        this.occupancy.fromApi(apiData['occupancy']);
        if (Array.isArray(apiData['images'])) {
            this.images = apiData['images'].map(x => {
                const model = new JuniperRoomImages();
                model.fromApi(x);
                return model;
            });
        }
        else if (!apiData['images']) {
            this.images = [];
        }
        this.features = apiData['features'];
        this.price = new JuniperHotelRoomPrice();
        this.price.fromApi(apiData['price']);
        if (Array.isArray(apiData['guests'])) {
            this.guests = apiData['guests'].map(x => {
                const model = new JuniperHotelGuest();
                model.fromApi(x);
                return model;
            });
        }
        else if (!apiData['guests']) {
            this.guests = [];
        }
    }
    getApiNumericFields() {
        return ['units', 'availQty', 'tax'];
    }
}
class JuniperHotelRoomPolicyRules extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
    getApiNumericFields() {
        return ['amount', 'percent'];
    }
}
class JuniperHotelRoomCancellationPolicy extends ApiResource {
    constructor() {
        super(...arguments);
        this.policyRules = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['policyRules'])) {
            this.policyRules = apiData['policyRules'].map(x => {
                const model = new JuniperHotelRoomPolicyRules();
                model.fromApi(x);
                return model;
            });
        }
        else if (!apiData['policyRules']) {
            this.policyRules = [];
        }
    }
    getApiNumericFields() {
        return ['units', 'availQty', 'tax'];
    }
}
class JuniperHotelGuest extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
    getApiNumericFields() {
        return ['age'];
    }
    getApiDatetimeFields() {
        return ['birthDate'];
    }
}
class JuniperRoomImages extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
}

class JuniperHotelResponseModel extends ApiResource {
    constructor() {
        super(...arguments);
        this.descriptions = [];
        this.categories = [];
        this.images = [];
        this.interestPoints = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        this.address = new AddressJuniper();
        this.address.fromApi(apiData['address']);
        if (Array.isArray(apiData['descriptions'])) {
            this.descriptions = apiData['descriptions'].map(x => {
                const model = new DescriptionHotelJuniper();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['images'])) {
            this.images = apiData['images'].map(x => {
                const model = new ImagesHotelJuniper();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['categories'])) {
            this.categories = apiData['categories'].map(x => {
                const model = new HotelCategories();
                model.fromApi(x);
                return model;
            });
        }
        this.mainImage = new MainImageJuniper();
        this.mainImage.fromApi(apiData['mainImage']);
        if (Array.isArray(apiData['interestPoints'])) {
            this.interestPoints = apiData['interestPoints'].map(x => {
                const model = new InterestPointsHotelJuniper();
                model.fromApi(x);
                return model;
            });
        }
    }
}
class AddressJuniper extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
    getApiNumericFields() {
        return ['latitude', 'longitude'];
    }
}
class DescriptionHotelJuniper extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
}
class ImagesHotelJuniper extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
}
const HOTEL_IMAGE_TYPES = ['BIG', 'TBH', 'PAN'];
class InterestPointsHotelJuniper extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
}
class MainImageJuniper extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
}
class HotelCategories extends ApiResource {
    constructor() {
        super(...arguments);
        this.features = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['features'])) {
            this.features = apiData['features'];
        }
    }
}

class HotelResponseModel extends ApiResource {
    constructor() {
        super(...arguments);
        this.categories = [];
        this.interestPoints = [];
        this.pensionTypes = [];
        this.rooms = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['interestPoints'])) {
            this.interestPoints = apiData['interestPoints'].map(x => {
                const model = new HotelInterestPoint();
                model.fromApi(x);
                return model;
            });
        }
        else if (!apiData['interestPoints']) {
            this.interestPoints = [];
        }
        if (Array.isArray(apiData['images'])) {
            this.images = apiData['images'].map(x => {
                const model = new HotelImages();
                model.fromApi(x);
                return model;
            });
        }
        else if (!apiData['images']) {
            this.images = [];
        }
        if (Array.isArray(apiData['rooms'])) {
            this.rooms = apiData['rooms'].map(x => {
                const model = new HotelRoomModel();
                model.fromApi(x);
                return model;
            });
        }
        else if (!apiData['rooms']) {
            this.rooms = [];
        }
        if (Array.isArray(apiData['categories'])) {
            this.categories = apiData['categories'].map(x => {
                const model = new HotelCategories();
                model.fromApi(x);
                return model;
            });
        }
        else if (!apiData['categories']) {
            this.categories = [];
        }
        this.address = this.initObject(apiData, 'address', new HotelAddressModel());
        this.bestPrice = this.initObject(apiData, 'bestPrice', new HotelBestPriceModel());
        this.contacts = this.initObject(apiData, 'contacts', new HotelContactsModel());
        this.hotelChain = this.initObject(apiData, 'hotelChain', new HotelChainModel());
        this.mainImage = this.initObject(apiData, 'mainImage', new HotelMainImage());
        this.pensionTypeJuniper = new JuniperHotelPensionType();
        this.pensionTypeJuniper.fromApi(apiData['pensionType']);
        this.price = new JuniperHotelRoomPrice();
        this.price.fromApi(apiData['price']);
    }
    getApiNumericFields() {
        return ['bestPriceFee', 'starRating'];
    }
}
class HotelRoomResponseModel extends ApiResource {
    constructor() {
        super(...arguments);
        this.roomOptions = [];
    }
    fromApi(apiData) {
        if (Array.isArray(apiData['roomOptions'])) {
            this.roomOptions = apiData['roomOptions'].map(x => {
                const model = new RoomOptions();
                model.fromApi(x);
                return model;
            });
        }
    }
}
class HotelPriceResponseModel extends ApiResource {
    constructor() {
        super(...arguments);
        this.pricedHotels = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['pricedHotels'])) {
            this.pricedHotels = apiData['pricedHotels'].map(x => {
                const model = new PricedHotelModel();
                model.fromApi(x);
                return model;
            });
        }
    }
}
class HotelBookRequestModel extends HotelPriceResponseModel {
    toApi() {
        const obj = JSON.parse(JSON.stringify(this));
        this.pricedHotels.forEach((ph, i) => {
            obj['pricedHotels'][i]['quotation']['checkIn'] = ph.quotation.checkIn.format(MOMENT_FORMATS.API_FULL_DATETIME_SECONDS);
            obj['pricedHotels'][i]['quotation']['checkOut'] = ph.quotation.checkOut.format(MOMENT_FORMATS.API_FULL_DATETIME_SECONDS);
            obj['pricedHotels'][i]['payment'] = null;
            obj['pricedHotels'][i]['quotation']['cancellingPolicy'] = ph.quotation.cancellingPolicy.toApi(true);
            ph.guests.forEach((g, j) => {
                switch (g.type) {
                    case 'CHD':
                        obj['pricedHotels'][i]['guests'][j]['type'] = 'Child';
                        break;
                    case 'INF':
                        obj['pricedHotels'][i]['guests'][j]['type'] = 'Child';
                        break;
                    default:
                        obj['pricedHotels'][i]['guests'][j]['type'] = 'Adult';
                        break;
                }
                obj['pricedHotels'][i]['guests'][j]['birthDate'] = g.birthDate.format(MOMENT_FORMATS.API_DATE);
            });
        });
        return obj;
    }
}
class ApiHotelBookErrorSentryRequest {
}
const PensionTypeCodes = ['SA', 'TI', 'AD', 'PC', 'MP', 'DYS'];
const PENSION_TYPES_AND_DESCRIPTION = {
    SA: 'Accommodation only',
    TI: 'All inclusive',
    AD: 'Bed & Breakfast',
    PC: 'Full board',
    MP: 'Half board',
    DYS: 'Room + Ticket',
};
class JuniperHotelPensionType extends ApiResource {
}
const pensionTypesText = {
    'SA': 'Sem Pensão',
    'TI': 'All inclusive',
    'AD': 'Café da Manhã',
    'PC': 'Pensão completa',
    'MP': 'Meia Pensão'
};

//import { Passenger } from './price-passenger.model';
class Price {
    constructor(content) {
        this.success = content['success'] ? content['success'] : false;
        this.meta = content['meta'] ? content['meta'] : false;
        this.result = content['result'] ? content['result'] : false;
        this.error = content['error'] ? content['error'] : false;
    }
}
class PriceResult extends ApiResource {
    constructor() {
        super(...arguments);
        this.minors = [];
        this.passengers = [];
        this.slices = [];
        this.nothingPending = false;
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['passengers'])) {
            this.passengers = apiData['passengers'].map(x => {
                const model = new Passenger();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['minors'])) {
            this.minors = apiData['minors'].map(x => {
                const model = new MinorPassenger();
                model.fromApi(x);
                return model;
            });
        }
    }
    getApiNumericFields() {
        return ['duValue', 'du2Value', 'totalAirportTaxesPrice', 'totalCreditCardFee', 'totalFarePrice', 'totalIncentiveValue', 'totalPrice', 'totalWithTax', 'totalPaid', 'totalToBePaid'];
    }
    getApiBooleanFields() {
        return ['fareChanged', 'international'];
    }
    getApiDatetimeFields() {
        return ['expireDate'];
    }
}
class AirlineRules {
}
class Airport {
}
class Airlines {
}
class BaseFare {
}
class Segments {
}
class Slices {
}

class AutoInitializable {
    constructor(data = null) {
        if (data !== null) {
            Object.assign(this, data);
        }
    }
}

class ApiImage extends AutoInitializable {
    loadFromApi(data) {
        this.description = data['description'];
        this.imageUrl = data['imageUrl'];
        this.originalImageUrl = data['originalImageUrl'];
    }
}

class WithGuid {
    get guid() {
        return this._guid;
    }
    set guid(value) {
        this._guid = value;
    }
}

class ApiAerialPromo extends WithGuid {
    getImageStyle() {
        if (this.imageUrl) {
            return { 'background-image': 'url(\'' + this.imageUrl + '\')' };
        }
        else {
            return { 'background-image': '\'none\'' };
        }
    }
    constructor() {
        super();
        this.slices = [];
    }
}
class ApiAerialPromoSlice {
}

class ApiAerialGeolocation {
    getResult() {
        return this.result;
    }
}

var ApiFlightClass;
(function (ApiFlightClass) {
    ApiFlightClass["Economic"] = "Economic Class";
    ApiFlightClass["Business"] = "Business Class";
    ApiFlightClass["First"] = "First Class";
})(ApiFlightClass || (ApiFlightClass = {}));

class ApiCampaignModel {
}

class ApiCorporateLoginModel {
    constructor(document) {
        this.customerSessionId = document.customerSessionId;
        this.branding = new ApiCorporateModel(document.branding);
        if (document.hasOwnProperty('expirationDate') && !!document['expirationDate']) {
            this.expirationDate = moment$3(document['expirationDate']['date'], moment$3.HTML5_FMT.DATETIME_LOCAL_MS);
        }
        else {
            this.expirationDate = moment$3().add(7, 'days');
        }
    }
}
class ApiCorporateModel {
    constructor(document) {
        if (document) {
            this.corporateId = document.corporateId;
            this.companyName = document.companyName;
            this.logoUrl = document.logoUrl;
            this.primaryColor = document.primaryColor;
            this.secondaryColor = document.secondaryColor;
            this.brandingType = document.brandingType;
            this.userPassword = document.userPassword;
            this.credentialName = document.credentialName;
            this.path = document.path;
        }
    }
}

class RdstationNewsletterModel {
    constructor() {
        this.event_type = "CONVERSION";
        this.event_family = "CDP";
        this.payload = new RdstationNewsletterPayload();
    }
}
class RdstationNewsletterPayload {
    constructor() {
        this.conversion_identifier = "Newsletter-Site";
        this.name = "";
        this.email = "";
        this.traffic_source = "";
        this.traffic_medium = "";
        this.traffic_campaign = "";
    }
}

class ApiPackageRequest {
    constructor() {
        this.includeCar = false;
    }
    toParams() {
        const params = {};
        params['originAirport'] = this.originAirport;
        params['destinationAirport'] = this.destinationAirport;
        params['departureDate'] = this.departureDate;
        params['returnDate'] = this.returnDate;
        params['rooms'] = this.rooms;
        params['includeCar'] = this.includeCar;
        params['bestHotelOnly'] = this.bestHotelOnly;
        params['bestAerialOnly'] = this.bestAerialOnly;
        params['bestCarOnly'] = this.bestCarOnly;
        params['customerSessionId'] = this.customerSessionId;
        params['onlyEconomicClass'] = this.onlyEconomicClass;
        params['onlyBusinessClass'] = this.onlyBusinessClass;
        params['credentialName'] = this.credentialName;
        if (this.checkIn) {
            params['checkIn'] = this.checkIn;
        }
        if (this.checkOut) {
            params['checkOut'] = this.checkOut;
        }
        if (this.aerialCredentialName) {
            params['aerialCredentialName'] = this.aerialCredentialName;
        }
        if (this.hotelCredentialName) {
            params['hotelCredentialName'] = this.hotelCredentialName;
        }
        if (this.carRentalCredentialName) {
            params['carRentalCredentialName'] = this.carRentalCredentialName;
        }
        if (this.flightClass) {
            params['flightClass'] = this.flightClass.toString();
        }
        return params;
    }
    toJSON() {
        let json = {
            originAirport: this.originAirport,
            destinationAirport: this.destinationAirport,
            departureDate: this.departureDate,
            returnDate: this.returnDate,
            rooms: this.rooms,
            includeCar: this.includeCar,
            bestHotelOnly: this.bestHotelOnly,
            bestAerialOnly: this.bestAerialOnly,
            bestCarOnly: this.bestCarOnly,
            customerSessionId: this.customerSessionId,
            onlyEconomicClass: this.onlyEconomicClass,
            onlyBusinessClass: this.onlyBusinessClass,
            credentialName: this.credentialName,
        };
        if (this.checkIn)
            json['checkIn'] = this.checkIn;
        if (this.checkOut)
            json['checkOut'] = this.checkOut;
        return json;
    }
}

class InvoiceDataRequest {
}

class ApiCustomerLoginRequest {
}

class ApiAerialFamiliesBaseFareRequest {
}

class ApiCustomer {
    get name() {
        return this.firstName
            ? `${this.firstName} ${this.lastName ? this.lastName : ''}`
            : this.email;
    }
    fromApi(data) {
        this.id = data['id'] ?? null;
        this.email = data['email'];
        this.cpf = data['cpf'];
        this.firstName = data['firstName'];
        this.lastName = data['lastName'];
        this.activated = data['activated'];
        this.photo = data['urlImage'] ?? null;
        this.addressProfile = data['addresses'].find(_address => _address.isProfile == true);
        this.addressBilling = data['addresses'].find(_address => _address.isBilling == true);
        this.creditCards = data['creditCards'];
        this.lastAccesses = data['lastAccesses'];
        this.provider = data['provider'];
        this.branding = data['branding'];
    }
}
class ApiAddress {
}
class CreditCard {
}
class LastAccess {
}
class Branding {
}

var PAYMENT_FORM;
(function (PAYMENT_FORM) {
    PAYMENT_FORM[PAYMENT_FORM["NONE"] = 1] = "NONE";
    PAYMENT_FORM[PAYMENT_FORM["CREDIT_CARD"] = 2] = "CREDIT_CARD";
    PAYMENT_FORM[PAYMENT_FORM["DEPOSIT"] = 3] = "DEPOSIT";
    PAYMENT_FORM[PAYMENT_FORM["TRANSFER"] = 4] = "TRANSFER";
    PAYMENT_FORM[PAYMENT_FORM["SAFETYPAY_TRANSFER"] = 5] = "SAFETYPAY_TRANSFER";
    PAYMENT_FORM[PAYMENT_FORM["SAFETYPAY_LOTTERY"] = 6] = "SAFETYPAY_LOTTERY";
    PAYMENT_FORM[PAYMENT_FORM["PAYMEE_PIX"] = 9] = "PAYMEE_PIX";
})(PAYMENT_FORM || (PAYMENT_FORM = {}));

class ApiCustomerOrdersResponse {
    constructor() {
        this.airports = [];
        this.airlines = [];
        this.destinations = [];
        this.orders = [];
    }
}
class CustomerOrders extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
        this.chargeAttemptInsurance = apiData['chargeAttemptInsurance'];
        this.policyInsurance = apiData['policyInsurance'];
        this.reservations = new OrderReservations();
        this.reservations.fromApi(apiData['reservations']);
        if (apiData.hasOwnProperty('paymentInstructions') && _.isObject(apiData['paymentInstructions'])) {
            this.paymentInstructions = new PaymentInstructions();
            this.paymentInstructions.fromApi(apiData['paymentInstructions']);
        }
        else {
            this.paymentInstructions = null;
        }
        if (apiData.hasOwnProperty('creditCard') && _.isObject(apiData['creditCard'])) {
            this.creditCard = new CustomerOrderCreditCard();
            this.creditCard.fromApi(apiData['creditCard']);
        }
        else {
            this.creditCard = null;
        }
        if (apiData.hasOwnProperty('situation') && _.isObject(apiData['situation'])) {
            this.situation = new Situation();
            this.situation.fromApi(apiData['situation']);
        }
        else {
            this.situation = null;
        }
        if (apiData.hasOwnProperty('changePaymentMethod') && _.isObject(apiData['changePaymentMethod'])) {
            this.changePaymentMethod = new ChangePaymentMethod();
            this.changePaymentMethod.fromApi(apiData['changePaymentMethod']);
        }
        else {
            this.changePaymentMethod = null;
        }
    }
    getApiDatetimeFields() {
        return ['createdDate', 'modifiedDate'];
    }
}
class OrderReservations extends ApiResource {
    constructor() {
        super(...arguments);
        this.aerial = [];
        this.hotel = [];
        this.aerialSummary = new AerialPriceSummary();
        this.hotelSummary = new HotelPriceSummary();
        this.packageSummary = new PackagePriceSummary();
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (apiData['aerial']) {
            apiData['aerial'].forEach(a => {
                const x = new AerialOrder();
                x.fromApi(a);
                this.aerial.push(x);
            });
            this.aerialSummary.fromAerialOrders(this.aerial);
        }
        else {
            this.aerial = [];
        }
        if (apiData['hotel']) {
            apiData['hotel'].forEach(a => {
                const x = new HotelOrder();
                x.fromApi(a);
                this.hotel.push(x);
            });
            this.hotelSummary.fromHotelOrders(this.hotel);
        }
        else {
            this.hotel = [];
        }
        if (this.aerial.length > 0 && this.hotel.length > 0) {
            this.packageSummary.fromSummaries(this.aerialSummary, this.hotelSummary);
        }
    }
}
class AerialOrder extends ApiResource {
    constructor() {
        super(...arguments);
        this.eticket = null;
        this.flightSegments = [];
        this.passengers = [];
        this.minors = [];
        this.pricing = [];
        this.slices = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        apiData['slices'].forEach(a => {
            const x = new AerialOrderSlice();
            x.fromApi(a);
            this.slices.push(x);
        });
        apiData['passengers'].forEach(a => {
            const x = new AerialOrderPassenger();
            x.fromApi(a);
            this.passengers.push(x);
        });
        if (apiData.hasOwnProperty('minors') && Array.isArray(apiData['minors'])) {
            this.minors = apiData['minors'].map(a => {
                const x = new MinorPassenger();
                x.fromApi(a);
                return x;
            });
        }
        apiData['pricing'].forEach(a => {
            const x = new AerialOrderPricing();
            x.fromApi(a);
            this.pricing.push(x);
        });
        this.direction = apiData.hasOwnProperty('direction') && !!apiData['direction'] ? apiData['direction'] : this.setAerialOrderDirection();
    }
    getApiNumericFields() {
        return ['status', 'fraudStatusId', 'paymentStatusId', 'paymentFormId'];
    }
    getApiDatetimeFields() {
        return ['transactionExpirationDate'];
    }
    setAerialOrderDirection() {
        if (this.slices.length === 1) {
            return ApiFlightType.OneWay;
        }
        else if (this.slices.length === 2) {
            return ApiFlightType.RoundTrip;
        }
        return ApiFlightType.MultiSlice;
    }
}
class AerialPriceSummary {
    constructor() {
        this.totalAdultFare = 0;
        this.totalChildFare = 0;
        this.totalInfantFare = 0;
        this.totalTaxes = 0;
        this.totalFees = 0;
        this.totalMinorService = 0;
        this.tripTotals = 0;
        this.cardFee = 0;
    }
    fromAerialOrders(aerialOrders) {
        this.totalAdultFare = aerialOrders.reduce((t, x) => t + x.pricing.reduce((tt, p) => tt + (p.adultPrice * p.adultQty), 0), 0);
        this.totalChildFare = aerialOrders.reduce((t, x) => t + x.pricing.reduce((tt, p) => tt + (p.childrenPrice * p.childrenQty), 0), 0);
        this.totalInfantFare = aerialOrders.reduce((t, x) => t + x.pricing.reduce((tt, p) => tt + (p.infantPrice * p.infantQty), 0), 0);
        this.totalTaxes = aerialOrders.reduce((t, x) => t + x.pricing.reduce((tt, p) => tt + p.taxes, 0), 0);
        this.totalFees = aerialOrders.reduce((t, x) => t + x.pricing.reduce((tt, p) => tt + p.duTax, 0), 0);
        this.totalMinorService = aerialOrders.reduce((t, x) => t + (x.minors ?? []).reduce((tt, p) => tt + (p.serviceValue ?? p.value ?? 0), 0), 0);
        this.cardFee = aerialOrders.reduce((t, x) => (x.pricing.reduce((tt, p) => tt + p.cardFee, 0) + t), 0);
        this.tripTotals = aerialOrders.reduce((t, x) => t + x.pricing.reduce((tt, p) => tt + p.totalFare, 0), 0);
    }
}
class HotelPriceSummary {
    constructor() {
        this.totalDailyFareSum = 0;
        this.totalFareSum = 0;
        this.totalFeeSum = 0;
        this.totalTaxesSum = 0;
        this.tripTotals = 0;
        this.cardFee = 0;
    }
    fromHotelOrders(hotelOrders) {
        this.totalDailyFareSum += hotelOrders.reduce((t, x) => x.quotation.dailyFareValue + t, 0);
        this.totalFareSum += hotelOrders.reduce((t, x) => x.quotation.fareValue + t, 0);
        this.totalFeeSum += hotelOrders.reduce((t, x) => x.quotation.feeValue + t, 0);
        this.totalTaxesSum += hotelOrders.reduce((t, x) => x.quotation.taxesValue + t, 0);
        this.tripTotals += hotelOrders.reduce((t, x) => x.quotation.totalValue + t, 0);
        this.tripTotals += this.totalFeeSum;
        this.cardFee = hotelOrders.reduce((t, x) => x.quotation.cardFee + t, 0);
    }
}
class PackagePriceSummary {
    constructor() {
        this.totalAdultFare = 0;
        this.totalChildFare = 0;
        this.totalInfantFare = 0;
        this.totalTaxes = 0;
        this.totalFees = 0;
        this.tripTotals = 0;
        this.cardFee = 0;
    }
    fromSummaries(aerialSummary, hotelSummary) {
        this.totalAdultFare = aerialSummary.totalAdultFare + hotelSummary.totalFareSum;
        this.totalChildFare = aerialSummary.totalChildFare;
        this.totalInfantFare = aerialSummary.totalInfantFare;
        this.totalTaxes = aerialSummary.totalTaxes + hotelSummary.totalTaxesSum;
        this.totalFees = aerialSummary.totalFees + hotelSummary.totalFeeSum;
        this.cardFee = aerialSummary.cardFee + hotelSummary.cardFee;
        this.tripTotals = aerialSummary.tripTotals + hotelSummary.tripTotals;
    }
}
class AerialOrderSlice extends ApiResource {
    constructor() {
        super(...arguments);
        this.duPrice = 0;
        this.du2Price = 0;
        this.incentivePrice = 0;
        this.creditCardFee = 0;
        this.segments = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        apiData['segments'].forEach(a => {
            const x = new AerialOrderFlightSegment();
            x.fromApi(a);
            this.segments.push(x);
        });
        this.expirationDate = apiData['expirationDate'].date;
        if (!this.issuingAirline) {
            this.issuingAirline = this.segments[0].operatingAirline;
        }
    }
}
class ChangePaymentMethod extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
        this.availabilityPayments = apiData['availabilityPayments'];
        this.ctaRules = apiData['ctaRules'];
    }
    getApiBooleanFields() {
        return ['ctaRules.showPaymentOnOrderDetail', 'ctaRules.isAvailable', 'ctaRules.allowPaymentChange'];
    }
    getApiStringFields() {
        return ['ctaRules.showCtaButtonFrom', 'ctaRules.showCtaButtonUntil'];
    }
}
class PaymentOption extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
        this.available = apiData['available'];
        this.displayOnCheckoutFrom = apiData['displayOnCheckoutFrom'];
        this.displayOnCheckoutUntil = apiData['displayOnCheckoutUntil'];
        this.payUntil = apiData['payUntil'];
    }
    getApiBooleanFields() {
        return ['available'];
    }
    getApiStringFields() {
        return ['displayOnCheckoutFrom', 'displayOnCheckoutUntil', 'payUntil'];
    }
}
class AerialOrderFlightSegment extends ApiResource {
    getApiDatetimeFields() {
        return ['departureTime', 'arrivalTime'];
    }
    getApiNumericFields() {
        return ['rph', 'numberInParty'];
    }
    getApiDurationFields() {
        return ['flightTime', 'flightDuration'];
    }
    getApiBooleanFields() {
        return ['baggageAllowance'];
    }
}
class AerialOrderPassenger extends ApiResource {
    constructor() {
        super(...arguments);
        this.birthday = null;
    }
    getApiBooleanFields() {
        return ['primary'];
    }
    getApiDateFields() {
        return ['birthday'];
    }
}
class AerialOrderPricing extends ApiResource {
    getApiNumericFields() {
        return [
            'adultQty',
            'adultPrice',
            'childrenQty',
            'childrenPrice',
            'infantQty',
            'infantPrice',
            'baseFare',
            'equivFare',
            'taxes',
            'duTax',
            'totalFare',
            'installments',
            'firstPayment',
            'nextPayment',
            'discount',
            'cardFee',
            'totalPaid',
            'totalToBePaid'
        ];
    }
    getApiBooleanFields() {
        return ['hasCardFee'];
    }
}
class HotelOrder extends ApiResource {
    constructor() {
        super(...arguments);
        this.guests = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        // we need to convert the returned payment form notation into our own enum
        if (Object.keys(PAYMENT_FORM).includes(apiData['paymentForm'])) {
            this.paymentForm = PAYMENT_FORM[apiData['paymentForm']];
        }
        this.quotation = new HotelOrderQuotation();
        this.quotation.fromApi(apiData['quotation']);
        apiData['guests'].forEach(a => {
            const x = new HotelOrderGuest();
            x.fromApi(a);
            this.guests.push(x);
        });
    }
    getApiBooleanFields() {
        return ['wantPrivateParking'];
    }
    getApiDatetimeFields() {
        return ['arrivalTime', 'createdDate', 'modifiedDate'];
    }
    getApiNumericFields() {
        return ['status', 'discount', 'fraudStatusId'];
    }
}
class HotelOrderQuotation extends ApiResource {
    getApiNumericFields() {
        return [
            'adultQty',
            'childrenQty',
            'exchange',
            'fareValue',
            'baseFareValue',
            'dailyFareValue',
            'baseDailyFareValue',
            'taxesValue',
            'baseTaxesValue',
            'feeValue',
            'totalValue',
            'baseTotalValue',
            'cancellingPolicyValue',
            'cancellingPolicyBaseValue',
            'installments',
            'firstInstallment',
            'nextInstallment',
            'cardFee'
        ];
    }
    getApiDatetimeFields() {
        return ['checkIn', 'checkOut', 'cancellingPolicyStart', 'cancellingPolicyEnd'];
    }
    getApiBooleanFields() {
        return ['hasCardFee'];
    }
}
class HotelOrderGuest extends ApiResource {
    getApiDateFields() {
        return ['birthdate'];
    }
    getApiNumericFields() {
        return ['age'];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (!this.fullName) {
            this.fullName = `${this.firstName} ${this.lastName}`;
        }
    }
}
class CustomerOrderCreditCard extends ApiResource {
}
class PaymentInstructions extends ApiResource {
}
class Situation extends ApiResource {
}
class MinorData extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
}

class CustomerOrdersFilters {
    constructor() {
        this.situation = [];
    }
}

class ApiTravelPackageModel {
    getResult() {
        return this.result;
    }
    constructor(requestTravel) {
        this.success = requestTravel['success'] ? requestTravel['success'] : false;
        this.result = requestTravel['result'] ? requestTravel['result'] : false;
        this.error = requestTravel['error'] ? requestTravel['error'] : false;
    }
}

class DefaultResponseModel {
    getResult() {
        return this.result;
    }
}

class PaginatedResource {
    constructor(data = []) {
        this.totalResults = data['totalResults'] ?? 0;
        this.filteredResults = data['filteredResults'] ?? 0;
        this.pageNumber = data['pageNumber'] ?? 0;
        this.totalPages = data['totalPages'] ?? 0;
        this.resources = [];
    }
    addResource(item) {
        this.resources.push(item);
    }
}

var SITUATION;
(function (SITUATION) {
    SITUATION["ONGOING"] = "ongoing";
    SITUATION["ISSUED"] = "issued";
    SITUATION["CANCELLED"] = "cancelled";
    SITUATION["PARTIAL"] = "null";
})(SITUATION || (SITUATION = {}));
var SITUATION_KEY;
(function (SITUATION_KEY) {
    SITUATION_KEY["ANALYSIS_DECLINED"] = "analysis_declined";
    SITUATION_KEY["ANALYZING_DATA"] = "analyzing_data";
    SITUATION_KEY["WAIVER"] = "waiver";
    SITUATION_KEY["AWAITING_CONFIRMATION"] = "awaiting_confirmation";
    SITUATION_KEY["CARD_DECLINED"] = "card_declined";
})(SITUATION_KEY || (SITUATION_KEY = {}));

class ApiAirline extends ApiResource {
    getApiBooleanFields() {
        return ['acceptsMinor'];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (apiData.minor) {
            this.minor = Object.assign(new ApiAirlineMinor(), apiData.minor);
        }
    }
    fromStorage(storageData) {
        if (storageData.minor) {
            this.minor = Object.assign(new ApiAirlineMinor(), storageData.minor);
        }
        return storageData;
    }
    mergeAirlines(airline) {
        this.name = airline.name ?? this.name;
        this.iataCode = airline.iataCode ?? this.iataCode;
        this.logoUrl = airline.logoUrl ?? this.logoUrl;
        this.color = airline.color ?? this.color;
        this.acceptsMinor = airline.acceptsMinor ?? this.acceptsMinor;
        this.minor = Object.assign(new ApiAirlineMinor(), this.minor ?? {}, airline.minor ?? {});
    }
}
class ApiAirlineMinor {
    totalValue(slicesQty) {
        return this.value * slicesQty;
    }
}

class ApiAirport extends ApiResource {
    getApiNumericFields() {
        return ['longitude', 'latitude', 'altitude', 'timezone'];
    }
    fromApi(apiData) {
        const data = {
            airportCode: apiData.airportCode ?? apiData.airport_code,
            city: apiData.city,
            region: apiData.region,
            country: apiData.country,
            countriesISO: apiData.countryISO ?? apiData.countries_iso,
            description: apiData.description,
            name: apiData.name,
            longitude: apiData.longitude,
            latitude: apiData.latitude,
            altitude: apiData.altitude,
            timezone: apiData.timezone,
            dsgCode: !!apiData.dsgCode ? apiData.dsgCode : null,
        };
        super.fromApi(data);
        if (!apiData['name']) {
            this.name = this.description;
        }
    }
}

class ApiAerialPriceRequest {
    constructor() {
        this.currency = 'BRL';
        this.slices = [];
        this.totalAirportTaxesPrice = 0;
        this.totalDu2Price = 0;
        this.totalDuPrice = 0;
        this.totalFarePrice = 0;
        this.totalIncentiveValue = 0;
        this.totalPrice = 0;
        this.customerSessionId = null;
        this.passengers = [];
    }
    addPassenger(paxType) {
        if (!this.passengers) {
            this.passengers = [];
        }
        const item = new ApiAerialPricePassengerRequest();
        item.type = paxType;
        this.passengers.push(item);
    }
}
class ApiAerialPricePassengerRequest {
    constructor() {
        this.firstName = null;
        this.lastName = null;
        this.type = 'ADT';
        this.gender = null;
        this.birthDate = null;
        this.email = null;
        this.cpf = null;
        this.rg = null;
        this.document = null;
    }
}
class ApiAerialPassenger extends ApiAerialPricePassengerRequest {
    constructor() {
        super(...arguments);
        this.phoneAreaCode = null;
        this.phoneNumber = null;
        this.zipCode = null;
        this.streetName = null;
        this.streetNumber = null;
        this.complement = null;
        this.district = null;
        this.city = null;
        this.state = null;
        this.country = null;
    }
}
class ApiAerialSlice {
}
class ApiAerialSegment {
}
class ApiAerialBaseFares {
}
class ApiAerialFamilyItem {
}

class ApiAerialBookRequest {
    constructor() {
        this.hasInsurance = false;
    }
    static fromPriceResult(priceResult) {
        const apiAerialBookRequest = new ApiAerialBookRequest();
        apiAerialBookRequest.airline = priceResult.airline;
        apiAerialBookRequest.credentialName = priceResult.credentialName;
        apiAerialBookRequest.currency = priceResult.currency;
        apiAerialBookRequest.customerSessionId = priceResult.customerSessionId;
        apiAerialBookRequest.du2Value = priceResult.du2Value;
        apiAerialBookRequest.duValue = priceResult.duValue;
        apiAerialBookRequest.fareChanged = priceResult.fareChanged;
        apiAerialBookRequest.international = priceResult.international;
        apiAerialBookRequest.totalAirportTaxesPrice = priceResult.totalAirportTaxesPrice;
        apiAerialBookRequest.totalCreditCardFee = priceResult.totalCreditCardFee;
        apiAerialBookRequest.totalFarePrice = priceResult.totalFarePrice;
        apiAerialBookRequest.totalIncentiveValue = priceResult.totalIncentiveValue;
        apiAerialBookRequest.totalPrice = priceResult.totalPrice;
        apiAerialBookRequest.totalWithTax = priceResult.totalWithTax;
        apiAerialBookRequest.type = priceResult.type;
        apiAerialBookRequest.slices = priceResult.slices.map(s => {
            const slice = new ApiAerialSliceBook();
            Object.assign(slice, s);
            return slice;
        });
        return apiAerialBookRequest;
    }
    toApi() {
        const obj = JSON.parse(JSON.stringify(this));
        obj['passengers'] = this.passengers.map((p) => p.toApi());
        return obj;
    }
    fromPriceResult(priceResult) {
        this.airline = priceResult.airline;
        this.credentialName = priceResult.credentialName;
        this.currency = priceResult.currency;
        this.customerSessionId = priceResult.customerSessionId;
        this.du2Value = priceResult.du2Value;
        this.duValue = priceResult.duValue;
        this.fareChanged = priceResult.fareChanged;
        this.international = priceResult.international;
        this.slices = priceResult.slices.map((s) => {
            const slice = new ApiAerialSliceBook();
            Object.assign(slice, s);
            return slice;
        });
        this.totalAirportTaxesPrice = priceResult.totalAirportTaxesPrice;
        this.totalCreditCardFee = priceResult.totalCreditCardFee;
        this.totalFarePrice = priceResult.totalFarePrice;
        this.totalIncentiveValue = priceResult.totalIncentiveValue;
        this.totalPrice = priceResult.totalPrice;
        this.totalWithTax = priceResult.totalWithTax;
        this.type = priceResult.type;
    }
}
class ApiAerialPassengerBook extends ApiResource {
    toApi() {
        const obj = JSON.parse(JSON.stringify(this));
        obj['birthDate'] = moment$3(this.birthDate).format(moment$3.HTML5_FMT.DATE);
        return obj;
    }
    formToBook(dataForm) {
        const obj = new ApiAerialPassengerBook();
        obj.birthDate = dataForm['birthDate'];
        obj.cpf = dataForm['cpf'];
        obj.document = dataForm['cpf'];
        obj.firstName = dataForm['firstName'];
        obj.lastName = dataForm['lastName'];
        obj.gender = dataForm['gender'];
        obj.type = dataForm['type'];
        obj.serviceStatusMinor = dataForm['unaccompaniedMinorExtraService'] ? (dataForm['unaccompaniedMinorExtraService'] == UnaccompaniedMinorExtraServiceEnum.HIRED ? true : false) : null;
        obj.altPhoneAreaCode = '';
        obj.altPhoneNumber = '';
        obj.city = '';
        obj.complement = '';
        obj.country = '';
        obj.district = '';
        obj.email = '';
        obj.phoneAreaCode = '';
        obj.phoneNumber = '';
        obj.state = '';
        obj.streetName = '';
        obj.streetNumber = '';
        obj.zipCode = '';
        return obj;
    }
}
class ApiAerialSliceBook extends ApiResource {
    constructor() {
        super(...arguments);
        this.baseFares = [];
        this.segments = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['baseFares'])) {
            this.baseFares = apiData['baseFares'].map((x) => {
                const model = new ApiAerialBaseFaresBook();
                model.fromApi(x);
                return model;
            });
        }
        else {
            const model = new ApiAerialBaseFaresBook();
            model.fromApi(apiData['baseFares']);
            this.baseFares.push(model);
        }
        if (Array.isArray(apiData['segments'])) {
            this.segments = apiData['segments'].map((x) => {
                const model = new ApiAerialSegmentBook();
                model.fromApi(x);
                return model;
            });
        }
    }
    getApiNumericFields() {
        return ['creditCardFee', 'duValue', 'du2Value', 'incentiveValue', 'taxValue'];
    }
    getApiDurationFields() {
        return ['flightTime', 'flightDuration'];
    }
}
class ApiAerialSegmentBook extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
    getApiDatetimeFields() {
        return ['arrivalDate', 'departureDate'];
    }
    getApiBooleanFields() {
        return ['baggageAllowance'];
    }
    getApiNumericFields() {
        return ['rph', 'scaleCount', 'stopCount'];
    }
}
class ApiAerialBaseFaresBook extends ApiResource {
    getApiBooleanFields() {
        return ['baggageAllowance'];
    }
    getApiNumericFields() {
        return [
            'baseFareValue',
            'baseTaxValue',
            'creditCardFee',
            'discount',
            'du2Value',
            'duValue',
            'exchangeRate',
            'fareValue',
            'incentiveValue',
            'taxValue',
        ];
    }
}
class ApiAerialBookErrorSentryRequest {
    fromApiAerialBookRequest(apiAerialBookRequest) {
        this.totalAirportTaxesPrice = apiAerialBookRequest.totalAirportTaxesPrice;
        this.totalCreditCardFee = apiAerialBookRequest.totalCreditCardFee;
        this.totalFarePrice = apiAerialBookRequest.totalFarePrice;
        this.totalIncentiveValue = apiAerialBookRequest.totalIncentiveValue;
        this.totalPrice = apiAerialBookRequest.totalPrice;
        this.totalWithTax = apiAerialBookRequest.totalWithTax;
    }
}
class ApiAerialBookSentry {
}
var UnaccompaniedMinorExtraServiceEnum;
(function (UnaccompaniedMinorExtraServiceEnum) {
    UnaccompaniedMinorExtraServiceEnum["HIRED"] = "HIRED";
    UnaccompaniedMinorExtraServiceEnum["FOR_LATER"] = "FOR_LATER";
})(UnaccompaniedMinorExtraServiceEnum || (UnaccompaniedMinorExtraServiceEnum = {}));

class ApiDestination extends ApiResource {
}

class OrderVoucherAerial {
}
class OrderVoucherAerialSegment {
}
class OrderVoucherAerialAirport {
}
class OrderVoucherPassenger {
}

class OrderVoucherHotel {
}
class OrderVoucherHotelInformation {
}
class OrderVoucherRoom {
}
class OrderVoucherHotelGuest {
}
class OrderVoucherPayment {
}

class OrderVoucher {
    fromApi(apiData) {
        if (apiData['goingSegments'] && !apiData['hotelData']) {
            this.product = OrderVoucherProduct.AERIAL;
            this.voucherAerial = apiData;
            this.orderId = this.voucherAerial.orderId;
            this.customerName = this.voucherAerial.customerName;
            this.destiny = this.voucherAerial.destiny;
            this.qtdPassengers = this.voucherAerial.qntPassengers;
            this.adultFareTotal = this.voucherAerial.adultFareTotal;
            this.totalTaxes = this.voucherAerial.taxes;
            this.serviceTax = this.voucherAerial.serviceTax;
            this.total = this.voucherAerial.total;
            this.totalMinor = this.voucherAerial.totalMinor;
        }
        else if (apiData['hotel']) {
            this.product = OrderVoucherProduct.HOTEL;
            this.voucherHotel = apiData;
            this.orderId = this.voucherHotel.orderId;
            this.customerName = this.voucherHotel.customerName;
            this.destiny = this.voucherHotel.hotel.city;
            this.qtdPassengers = this.voucherHotel.adultQty;
            this.adultFareTotal = this.voucherHotel.totalFare;
            this.totalTaxes = this.voucherHotel.totalTaxes;
            this.serviceTax = this.voucherHotel.totalFee;
            this.total = this.voucherHotel.totalWithTaxes;
        }
        else if (apiData['goingSegments'] && apiData['hotelData']) {
            this.product = OrderVoucherProduct.PACKAGE;
            this.voucherAerial = apiData;
            this.voucherHotel = apiData['hotelData'];
            delete this.voucherAerial['hotelData'];
            this.orderId = apiData['orderId'];
            this.customerName = apiData['customerName'];
            this.destiny = apiData['destiny'];
            this.qtdPassengers = apiData['qntPassengers'];
            this.adultFareTotal = apiData['adultFareTotal'];
            this.totalTaxes = apiData['taxes'];
            this.serviceTax = apiData['serviceTax'];
            this.total = apiData['total'];
        }
    }
    get isAerial() {
        return this.product == OrderVoucherProduct.AERIAL;
    }
    get isHotel() {
        return this.product == OrderVoucherProduct.HOTEL;
    }
    get isPackage() {
        return this.product == OrderVoucherProduct.PACKAGE;
    }
    get paymentForm() {
        if (this.voucherAerial?.paymentFormId === "2" ||
            this.voucherHotel?.paymentForm === OrderVoucherPaymentForm.CREDIT_CARD) {
            return OrderVoucherPaymentForm.CREDIT_CARD;
        }
        else if (this.voucherAerial?.paymentFormId === "9" ||
            this.voucherHotel?.paymentForm === OrderVoucherPaymentForm.PAYMEE_PIX) {
            return OrderVoucherPaymentForm.PAYMEE_PIX;
        }
        else if (this.voucherAerial?.paymentFormId === "5" ||
            this.voucherHotel?.paymentForm === OrderVoucherPaymentForm.SAFETYPAY_TRANSFER) {
            return OrderVoucherPaymentForm.SAFETYPAY_TRANSFER;
        }
        else if (this.voucherAerial?.paymentFormId === "6" ||
            this.voucherHotel?.paymentForm === OrderVoucherPaymentForm.SAFETYPAY_LOTTERY) {
            return OrderVoucherPaymentForm.SAFETYPAY_LOTTERY;
        }
    }
    get paymentCreditCard() {
        let creditCard = new OrderVoucherCreditCard();
        if (this.isAerial) {
            creditCard.anotherInstallments = this.voucherAerial.anotherInstallments.toString();
            creditCard.cardType = this.voucherAerial.cardType;
            creditCard.cardTypeDescription = this.voucherAerial.cardTypeDescription;
            creditCard.firstPayment = this.voucherAerial.firstPayment;
            creditCard.installments = this.voucherAerial.installments;
            creditCard.lastFourCard = this.voucherAerial.lastFourCard;
            creditCard.nextPayment = this.voucherAerial.nextPayment;
        }
        else if (this.isHotel) {
            creditCard.anotherInstallments = (Number(this.voucherHotel.payment.installmentCount) - 1).toString();
            creditCard.cardType = this.voucherHotel.payment.cardBank;
            creditCard.cardTypeDescription = this.voucherHotel.payment.cardBank;
            creditCard.firstPayment = this.voucherHotel.payment.firstPaymentValue;
            creditCard.installments = this.voucherHotel.payment.installmentCount;
            creditCard.lastFourCard = this.voucherHotel.payment.lastFour;
            creditCard.nextPayment = this.voucherHotel.payment.nextPaymentValue;
        }
        else if (this.isPackage) {
            creditCard.anotherInstallments = this.voucherAerial.anotherInstallments.toString();
            creditCard.cardType = this.voucherAerial.cardType;
            creditCard.cardTypeDescription = this.voucherAerial.cardTypeDescription;
            creditCard.firstPayment = this.voucherAerial.firstPayment;
            creditCard.installments = this.voucherAerial.installments;
            creditCard.lastFourCard = this.voucherAerial.lastFourCard;
            creditCard.nextPayment = this.voucherAerial.nextPayment;
        }
        return creditCard;
    }
    get paymentBank() {
        if (this.voucherHotel?.paymentBank) {
            return this.voucherHotel?.paymentBank;
        }
        else if (this.voucherAerial?.paymentBank) {
            return this.voucherAerial?.paymentBank;
        }
        else {
            return "Erro ao buscar banco";
        }
    }
}
class OrderVoucherCreditCard {
}
var OrderVoucherProduct;
(function (OrderVoucherProduct) {
    OrderVoucherProduct[OrderVoucherProduct["AERIAL"] = 0] = "AERIAL";
    OrderVoucherProduct[OrderVoucherProduct["HOTEL"] = 1] = "HOTEL";
    OrderVoucherProduct[OrderVoucherProduct["PACKAGE"] = 2] = "PACKAGE";
})(OrderVoucherProduct || (OrderVoucherProduct = {}));
var OrderVoucherPaymentForm;
(function (OrderVoucherPaymentForm) {
    OrderVoucherPaymentForm["CREDIT_CARD"] = "CREDIT_CARD";
    OrderVoucherPaymentForm["DEPOSIT"] = "DEPOSIT";
    OrderVoucherPaymentForm["TRANSFER"] = "TRANSFER";
    OrderVoucherPaymentForm["SAFETYPAY_TRANSFER"] = "SAFETYPAY_TRANSFER";
    OrderVoucherPaymentForm["SAFETYPAY_LOTTERY"] = "SAFETYPAY_LOTTERY";
    OrderVoucherPaymentForm["BILLED"] = "BILLED";
    OrderVoucherPaymentForm["SAFETYPAY_PIX"] = "SAFETYPAY_PIX";
    OrderVoucherPaymentForm["PAYMEE_PIX"] = "PAYMEE_PIX";
})(OrderVoucherPaymentForm || (OrderVoucherPaymentForm = {}));

class AerialCheckoutPayment {
    toApi() {
        return JSON.parse(JSON.stringify(this));
    }
}

class HotelCheckoutPayment {
    constructor() {
        this.isAerial = false;
    }
    toApi() {
        return {
            isAerial: this.isAerial,
            hotelReservationDate: this.hotelReservationDate.format(MOMENT_FORMATS.API_DATE),
            totalPrice: this.totalPrice
        };
    }
}

var CHECKOUT_PAYMENT_FORMS;
(function (CHECKOUT_PAYMENT_FORMS) {
    CHECKOUT_PAYMENT_FORMS["creditCard"] = "Cart\u00E3o de Cr\u00E9dito";
    CHECKOUT_PAYMENT_FORMS["pix"] = "Transfer\u00EAncia PIX";
    CHECKOUT_PAYMENT_FORMS["bankTransfer"] = "Transfer\u00EAncia banc\u00E1ria";
    CHECKOUT_PAYMENT_FORMS["cash"] = "Dinheiro";
})(CHECKOUT_PAYMENT_FORMS || (CHECKOUT_PAYMENT_FORMS = {}));
var ZupperPaymentForm;
(function (ZupperPaymentForm) {
    ZupperPaymentForm[ZupperPaymentForm["CREDIT_CARD"] = 0] = "CREDIT_CARD";
    ZupperPaymentForm[ZupperPaymentForm["PIX"] = 1] = "PIX";
    ZupperPaymentForm[ZupperPaymentForm["BANK_TRANSFER"] = 2] = "BANK_TRANSFER";
    ZupperPaymentForm[ZupperPaymentForm["CASH"] = 3] = "CASH";
})(ZupperPaymentForm || (ZupperPaymentForm = {}));

class CheckoutPayment extends ApiResource {
    constructor(paymentForm) {
        super();
        this.paymentForm = paymentForm;
        this.paymentFormName = CHECKOUT_PAYMENT_FORMS[paymentForm];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (['bankTransfer', 'cash'].includes(this.paymentForm) && Array.isArray(apiData['options'])) {
            this.options = apiData['options'].map(x => {
                const model = new BankOption();
                model.fromApi(x);
                return model;
            });
        }
        else if (this.paymentForm === 'creditCard') {
            if (Array.isArray(apiData['options'])) {
                this.options = apiData['options'].map(x => {
                    const model = new CardCompanyOption();
                    model.fromApi(x);
                    return model;
                });
            }
            else {
                this.options = Object.keys(apiData['options']).map(x => {
                    const model = new CardCompanyOption();
                    model.fromApi(apiData['options'][x]);
                    return model;
                });
            }
        }
    }
    getApiDatetimeFields() {
        return ['displayOnCheckoutFrom', 'displayOnCheckoutUntil', 'payUntil'];
    }
}
class BankOption extends ApiResource {
    constructor() {
        super(...arguments);
        this.bankLogos = [];
        this.tooltips = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['bankLogos'])) {
            this.bankLogos = apiData['bankLogos'].map(x => {
                const model = new ImageLogoBank();
                model.fromApi(x);
                return model;
            });
        }
        this.tooltips = apiData['tooltips'] ?? [];
        this.accountValidationInfo = this.initObject(apiData, 'accountValidationInfo', new AccountValidationInfo());
    }
}
class CardCompanyOption extends ApiResource {
    constructor() {
        super(...arguments);
        this.allowedInstallments = [];
        this.installmentsValues = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        Object.keys(apiData['installmentsValues']).forEach(x => {
            apiData['installmentsValues'][x].forEach((i) => {
                const model = new InstallmentValue();
                model.fromApi(i);
                this.installmentsValues.push(model);
            });
        });
    }
}
class ImageLogoBank extends ApiResource {
    getApiNumericFields() {
        return ['sizeX', 'sizeY'];
    }
}
class InstallmentValue extends ApiResource {
    getApiNumericFields() {
        return ['firstPayment', 'nextPayments', 'appliedTax', 'fee', 'installmentRuleId', 'minFareValue', 'minInstallmentValue'];
    }
    getApiBooleanFields() {
        return ['mergeInstallment'];
    }
}
class AccountValidationInfo extends ApiResource {
    getApiNumericFields() {
        return ['agencySize', 'agencyDvSize', 'accountSize', 'accountDvSize'];
    }
}

class ApiPackagePriceResponse extends ApiResource {
    fromApi(apiData, meta = null) {
        this.aerial = apiData['aerial'];
        this.hotel = this.initObject(apiData, 'hotel', new HotelPriceResponseModel());
        this.packageTotalValue = apiData['packageTotalValue'] ?? apiData['totalPackage'];
        this.meta = meta;
        this.totalPackage = apiData['totalPackage'] ?? apiData['packageTotalValue'];
    }
}

const CREDIT_CARD_CONFIG = [
    {
        cardAbbreviation: 'AX',
        cardCompany: 'American Express',
        cardMask: '0000 000000 00000',
        color: '#108168',
        booCvvMex: true,
        regex: /^3[47]{1}/
    },
    {
        cardAbbreviation: 'DC',
        cardCompany: 'Diners Club',
        cardMask: '0000 000000 0000',
        color: '#666',
        booCvvMex: false,
        regex: /^3(?:0[0-5]|[68]){1}/
    },
    {
        cardAbbreviation: 'MC',
        cardCompany: 'Mastercard',
        cardMask: '0000 0000 0000 0000',
        color: '#F64F49',
        booCvvMex: false,
        regex: /^(([5][\s-]*)([1-7][\s-]*)(\d[\s-]*){14})|2[\s-]*(?:2[\s-]*(?:2[\s-]*[1-9]|[3-9][\s-]*\d)|[3-6][\s-]*\d[\s-]*\d|7[\s-]*(?:[01][\s-]*\d|2[\s-]*0[\s-]*))(\d[\s-]*){12}$/
    },
    {
        cardAbbreviation: 'VI',
        cardCompany: 'Visa',
        cardMask: '0000 0000 0000 0000',
        color: '#004E8C',
        booCvvMex: false,
        regex: /^4/
    },
    {
        cardAbbreviation: 'HC',
        cardCompany: 'Hipercard',
        cardMask: '0000 0000 0000 0000',
        color: '#B4141C',
        booCvvMex: false,
        regex: /^606282/
    },
    {
        cardAbbreviation: 'ELO',
        cardCompany: 'Elo',
        cardMask: '0000 0000 0000 0000',
        color: '#000',
        booCvvMex: false,
        regex: /^(40117[8-9]|431274|438935|451416|457393|45763[1-2]|506(699|7[0-6][0-9]|77[0-8])|509\d{3}|504175|627780|636297|636368|65003[1-3]|6500(3[5-9]|4[0-9]|5[0-1])|6504(0[5-9]|[1-3][0-9])|650(4[8-9][0-9]|5[0-2][0-9]|53[0-8])|6505(4[1-9]|[5-8][0-9]|9[0-8])|6507(0[0-9]|1[0-8])|65072[0-7]|6509(0[1-9]|1[0-9]|20)|6516(5[2-9]|[6-7][0-9])|6550([0-1][0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/
    }
];

class ApiAddressResponse extends ApiResource {
}

class ApiAerialFamiliesBaseFareResponse extends ApiResource {
}
class CancellationOrMarkdown extends ApiResource {
}
class Refund extends ApiResource {
}

class AbstractPaymentRequest {
    constructor() {
        this.hasInsurance = false;
        this.insuranceValue = 0;
        this.specialCheckout = false;
    }
}

class BankTransferPaymentRequest extends AbstractPaymentRequest {
    constructor() {
        super(...arguments);
        this.paymentForm = 'TRANSFER';
        this.payments = null;
    }
}

class CashPaymentRequest extends AbstractPaymentRequest {
    constructor() {
        super(...arguments);
        this.paymentForm = 'LOTTERY';
        this.payments = null;
    }
}

class CreditCardPaymentRequest extends AbstractPaymentRequest {
    constructor() {
        super(...arguments);
        this.paymentForm = 'CREDIT_CARD';
        this.payments = [];
    }
}
class CreditCardPaymentDetails extends CreditCardPaymentModel {
    constructor(buyer, cardInfo, installments) {
        super();
        this.billCity = buyer?.billCity;
        this.billComplement = buyer?.billComplement;
        this.billCountry = buyer?.billCountry;
        this.billDistrict = buyer?.billDistrict;
        this.billPhone = buyer?.billPhone;
        this.billPhone2 = buyer?.billPhone2 ?? buyer?.billPhone;
        this.billPostalCode = buyer?.billPostalCode;
        this.billState = buyer?.billState;
        this.billStreetName = buyer?.billStreetName;
        this.billStreetNumber = buyer?.billStreetNumber;
        this.cardHolderDocument = buyer?.document;
        this.cardBank = cardInfo?.cardBank;
        this.cardExpirationMonth = cardInfo?.cardExpirationMonth;
        this.cardExpirationYear = cardInfo?.cardExpirationYear;
        this.cardHolderName = cardInfo?.cardHolderName;
        this.cardNumber = cardInfo?.cardNumber;
        this.securityCode = cardInfo?.securityCode;
        this.firstInstallmentValue =
            installments?.firstInstallmentValue;
        this.installmentCount = installments?.installmentCount;
        this.remainingInstallmentValue =
            installments?.remainingInstallmentValue;
        this.installmentRuleId = installments?.installmentRuleId;
        this.cardFee = 0;
    }
}

class PixPaymentRequest extends AbstractPaymentRequest {
    constructor() {
        super(...arguments);
        this.paymentForm = 'PIX';
        this.payments = null;
    }
}

class PaymentInformation {
    constructor(input) {
        const nameObj = input?.fullName?.split(' ', 2) ?? [];
        this.chargeAmount = input?.chargeAmount;
        this.expirationTime = 120;
        this.payerEmail = input?.email;
        this.firstName = nameObj[0] ?? '';
        this.lastName = nameObj[1] ?? '';
        this.bankAccount = input?.bankAccount ?? null;
        this.bankAgency = input?.bankAgency ?? null;
        this.bankId = input?.bankId ?? null;
        this.document = input?.document ?? null;
        this.phone = input?.phone ?? null;
        this.phoneType = input?.phoneType ?? null;
    }
}

class CheckoutPaymentFormsRequestModel {
    constructor() {
        this.credentials = [];
        this.orderId = null;
        this.isInsurance = false;
        this.insuranceValue = 0;
        this.specialCheckout = false;
    }
    toApi() {
        return {
            service: this.service,
            credentials: this.credentials,
            aerial: this.aerial,
            hotel: this.hotel?.toApi(),
            orderId: this.orderId,
            specialCheckout: this.specialCheckout,
            insuranceValue: this.insuranceValue,
            productInsuranceId: this.productInsuranceId
        };
    }
}
class CheckoutPaymentFormsAerialRequestModel {
    constructor() {
        this.slices = [];
        this.isInsurance = false;
        this.nothingPending = false;
    }
    fromPriceResult(priceResult) {
        this.duValue = priceResult.duValue ?? 0;
        this.du2Value = priceResult.du2Value ?? 0;
        this.totalAirportTaxesPrice = priceResult.totalAirportTaxesPrice ?? 0;
        this.totalFarePrice = priceResult.totalFarePrice ?? 0;
        this.totalIncentiveValue = priceResult.totalIncentiveValue ?? 0;
    }
}
class CheckoutPaymentFormsHotelRequestModel {
    constructor() {
        this.isInsurance = false;
        this.nothingPending = false;
    }
    toApi() {
        return {
            farePrice: this.farePrice,
            taxPrice: this.taxPrice,
            source: this.source,
            feePrice: this.feePrice,
            hotelReservationDate: this.hotelReservationDate.format(MOMENT_FORMATS.API_DATE),
            cancelingPoliceStart: this.cancelingPoliceStart.format(MOMENT_FORMATS.API_DATE)
        };
    }
}

var PAYMENT_CHANNEL;
(function (PAYMENT_CHANNEL) {
    PAYMENT_CHANNEL["ZUPPER"] = "Zupper";
    PAYMENT_CHANNEL["SUPPLIER"] = "Fornecedor";
})(PAYMENT_CHANNEL || (PAYMENT_CHANNEL = {}));

class BasePaymentResponse extends ApiResource {
    constructor() {
        super(...arguments);
        this.paymentLocations = [];
        this.payableAmounts = [];
        this.howToPaySteps = [];
        this.paymentsInstructions = [];
        this.whereToPay = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['payableAmounts'])) {
            this.payableAmounts = apiData['payableAmounts'].map(x => {
                return Number(x['amount']['value']);
            });
        }
        if (Array.isArray(apiData['paymentLocations'])) {
            this.paymentLocations = apiData['paymentLocations'].map(x => {
                const model = new PaymentLocation();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['howToPaySteps'])) {
            this.howToPaySteps = apiData['howToPaySteps'].map(x => {
                const model = new HowToPayStep();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['paymentsInstructions'])) {
            this.paymentsInstructions = apiData['paymentsInstructions'].map(x => {
                const model = new PaymentInstruction();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['whereToPay'])) {
            this.whereToPay = apiData['whereToPay'];
        }
    }
    getApiDatetimeFields() {
        return ['responseDatetime', 'paymentExpirationDatetimeUtc'];
    }
}
class PaymentLocation extends ApiResource {
    constructor() {
        super(...arguments);
        this.paymentInstructions = [];
        this.howToPaySteps = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['paymentInstructions'])) {
            this.paymentInstructions = apiData['paymentInstructions'].map(x => {
                const model = new PaymentInstruction();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['howtoPaySteps'])) {
            this.howToPaySteps = apiData['howtoPaySteps'].map(x => {
                const model = new HowToPayStep();
                model.fromApi(x);
                return model;
            });
        }
    }
}
class PaymentInstruction extends ApiResource {
}
class HowToPayStep extends ApiResource {
    getApiNumericFields() {
        return ['stepNumber'];
    }
}

class ApiAerialBookResponse extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
        if (!!apiData['reservation']) {
            this.reservation = this.initObject(apiData, 'reservation', new ApiAerialReservationResponse());
        }
    }
    getApiNumericFields() {
        return ['paymentStatus', 'totalWithDiscount', 'discount'];
    }
}
class ApiAerialBookFullResponse extends ApiResource {
    constructor() {
        super(...arguments);
        this.response = [];
        this.airports = [];
        this.airlines = [];
    }
    fromApi(apiData) {
        if (Array.isArray(apiData['result'])) {
            this.response = apiData['result'].map(x => {
                const model = new ApiAerialBookResponse();
                model.fromApi(x);
                return model;
            });
        }
        if (apiData['meta'].hasOwnProperty('airports')) {
            this.airports = Object.keys(apiData['meta']['airports']).map(airportCode => {
                const model = new ApiAirport();
                model.fromApi(apiData['meta']['airports'][airportCode]);
                return model;
            });
        }
        if (apiData['meta'].hasOwnProperty('airlines') && Array.isArray(apiData['meta']['airlines'])) {
            this.airlines = apiData['meta']['airlines'].map(x => {
                const model = new ApiAirline();
                model.color = x['color'] ?? null;
                model.iataCode = x['iataCode'] ?? null;
                model.logoUrl = x['logoUrl'] ?? null;
                model.name = x['name'];
                return model;
            });
        }
    }
}
class ApiAerialReservationResponse extends ApiResource {
    constructor() {
        super(...arguments);
        this.minors = [];
        this.passengers = [];
        this.slices = [];
    }
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['passengers'])) {
            this.passengers = apiData['passengers'].map(x => {
                const model = new ApiAerialPassengerBook();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['minors'])) {
            this.minors = apiData['minors'].map(x => {
                const model = new MinorPassenger();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['slices'])) {
            this.slices = apiData['slices'].map(x => {
                const model = new ApiAerialSliceBook();
                model.fromApi(x);
                return model;
            });
        }
    }
    getApiDatetimeFields() {
        return ['expirationDate', 'priceExpirationDate'];
    }
    getApiNumericFields() {
        return ['du2Value', 'duValue', 'totalAirportTaxes', 'totalCreditCardFee', 'totalFarePrice', 'totalIncentiveValue', 'totalPrice'];
    }
}

class ApiPackageBookResponse extends ApiResource {
    fromApi(apiData, meta = null) {
        super.fromApi(apiData);
        const objAerial = {
            result: apiData['aerial'],
            meta: !!meta ? meta['aerial'] : null
        };
        // this.aerial = this.initObject(objAerial, "aerial", new ApiAerialBookResponse) as ApiAerialBookResponse[];
        if (Array.isArray(objAerial.result)) {
            this.aerial = objAerial.result.map(x => {
                const model = new ApiAerialBookResponse();
                model.fromApi(x);
                return model;
            });
        }
        this.hotel = new HotelBookingConfirmation();
        this.hotel.fromApi(apiData['hotel']);
    }
}

class ApiResponse {
}

class PaymentValidateAccountRequest {
}

class PaymentValidateTokenRequest {
}

class ApiHotelDeeplinkResponse extends ApiResource {
    constructor() {
        super();
        this.rooms = [];
        this.hotel = new HotelResponseModel();
    }
}
class ApiHotelDeeplinkRoomResponse extends ApiResource {
    constructor() {
        super();
    }
}

class ApiBookingError {
    constructor(type = API_BOOKING_ERROR_TYPE.UNKNOWN, message, body) {
        this.type = type;
        this.message = message;
        this.body = body;
    }
}
var API_BOOKING_ERROR_TYPE;
(function (API_BOOKING_ERROR_TYPE) {
    API_BOOKING_ERROR_TYPE[API_BOOKING_ERROR_TYPE["UNKNOWN"] = 1] = "UNKNOWN";
    API_BOOKING_ERROR_TYPE[API_BOOKING_ERROR_TYPE["VALIDATION"] = 2] = "VALIDATION";
    API_BOOKING_ERROR_TYPE[API_BOOKING_ERROR_TYPE["UNAVAILABLE"] = 3] = "UNAVAILABLE";
})(API_BOOKING_ERROR_TYPE || (API_BOOKING_ERROR_TYPE = {}));

class OrderPriceResult extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
}

class OrderPayer extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
}

class ApiOfferField extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
    getApiBooleanFields() {
        return ['isLocked'];
    }
}

class ApiOfferImage extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
    getApiBooleanFields() {
        return ['isMainImage'];
    }
    getApiNumericFields() {
        return ['imagePosition'];
    }
}

class ApiFilterModel {
}
class AirlineRulesModel {
}
class CreditCardRulesModel extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['minFareValue'])) {
            this.minFareValue = apiData['minFareValue'].map(x => {
                const model = new CreditCardRulesValueModel();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['minInstallmentValue'])) {
            this.minInstallmentValue = apiData['minInstallmentValue'].map(x => {
                const model = new CreditCardRulesValueModel();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['hasCardTax'])) {
            this.hasCardTax = apiData['hasCardTax'].map(x => {
                return x;
            });
        }
        if (Array.isArray(apiData['allowedInstallments'])) {
            this.allowedInstallments = apiData['allowedInstallments'].map(x => {
                return x;
            });
        }
    }
}
class CreditCardRulesValueModel extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
}
class AirportInfoModel {
}
class FilterDataModel {
}
class Trip1Model {
}
class FilterAirlinesModel {
}
class FilterOptions {
    constructor() {
        this.stopQuantities = [];
        this.price = null;
        this.minimalPrice = 0;
        this.maximumPrice = 0;
        this.airlines = [];
        this.airports = [];
        this.timeDeparture = [];
        this.timeArrival = [];
        this.filterDuration = [];
    }
}
class FilterTime {
}
class FilterDuration {
    constructor() {
        this.minimalDuration = 0;
        this.maximumDuration = 0;
        this.minimalDurationSelected = 0;
        this.maximumDurationSelected = 0;
    }
}
class BaggageModel {
    constructor(freeBaggage = false, paidBaggage = false) {
        this.freeBaggage = freeBaggage;
        this.paidBaggage = paidBaggage;
    }
}

class ApiOfferItem extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['images'])) {
            this.images = apiData['images'].map(x => {
                const model = new ApiOfferImage();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['fields'])) {
            this.fields = apiData['fields'].map(x => {
                const model = new ApiOfferField();
                model.fromApi(x);
                return model;
            });
        }
        if (Array.isArray(apiData['creditRules'])) {
            this.creditRules = apiData['creditRules'].map(x => {
                const model = new CreditCardRulesModel();
                model.fromApi(x);
                return model;
            });
        }
    }
    getApiNumericFields() {
        return ['id', 'offerLabelId', 'productId', 'price', 'offerVersionId'];
    }
    getApiBooleanFields() {
        return ['status'];
    }
    getApiDatetimeFields() {
        return ['createdAt', 'updatedAt'];
    }
}

class ApiOfferLabel extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
    getApiBooleanFields() {
        return ['status'];
    }
}

class ApiOfferBlockItem extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
        this.offer = this.initObject(apiData, "offer", new ApiOfferItem);
        this.label = this.initObject(apiData, "label", new ApiOfferLabel);
    }
    getApiNumericFields() {
        return ['itemPosition', 'offerId', 'offerLabelId'];
    }
}

class ApiOfferBlock extends ApiResource {
    fromApi(apiData, meta = null) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['items'])) {
            this.items = apiData['items'].map(x => {
                const model = new ApiOfferBlockItem();
                model.fromApi(x);
                return model;
            });
            this.items.sort((a, b) => (a.itemPosition > b.itemPosition) ? 1 : ((b.itemPosition > a.itemPosition) ? -1 : 0));
        }
    }
    getApiNumericFields() {
        return ['id', 'blockPosition', 'styleType'];
    }
}

class ApiOffer extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
        if (Array.isArray(apiData['blocks'])) {
            this.blocks = apiData['blocks'].map(x => {
                const model = new ApiOfferBlock();
                model.fromApi(x);
                return model;
            });
        }
    }
    getApiBooleanFields() {
        return ['status'];
    }
    getApiNumericFields() {
        return ['id'];
    }
}

class CreditCardValidationRequest {
    constructor() {
        this.isInsuranceRequest = false;
    }
}

class ApiConfiguration extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
        if (apiData.attributes) {
            this.attributes = new ConfigurationAttributes();
            this.attributes.fromApi(apiData.attributes);
        }
    }
}
class ConfigurationAttributes {
    fromApi(apiData) {
        this.name = apiData.name;
        this.description = apiData.description;
        this.value = apiData.value;
        this.configurationCategoryId = apiData.configurationCategoryId;
        this.configurationParentId = apiData.configurationParentId;
        if (apiData.configurations && Array.isArray(apiData.configurations)) {
            this.configurations = apiData.configurations.map((x) => {
                const model = new ConfigurationAttributes();
                model.fromApi(x);
                return model;
            });
        }
    }
}

var WEBSITE_VIEWPORT;
(function (WEBSITE_VIEWPORT) {
    WEBSITE_VIEWPORT["DESKTOP"] = "DESKTOP";
    WEBSITE_VIEWPORT["MOBILE"] = "MOBILE";
})(WEBSITE_VIEWPORT || (WEBSITE_VIEWPORT = {}));
var WEBSITE_PAGE;
(function (WEBSITE_PAGE) {
    WEBSITE_PAGE["HOME"] = "HOME";
    WEBSITE_PAGE["RESULTS"] = "RESULTADOS";
    WEBSITE_PAGE["CHECKOUT"] = "CHECKOUT";
    WEBSITE_PAGE["THANKS"] = "THANKS";
    WEBSITE_PAGE["AERIAL_HOME"] = "AERIAL HOME";
    WEBSITE_PAGE["AERIAL_RESULTS"] = "AERIAL RESULTS";
    WEBSITE_PAGE["HOTEL_HOME"] = "HOTEL HOME";
    WEBSITE_PAGE["HOTEL_RESULTS"] = "HOTEL RESULTS";
    WEBSITE_PAGE["HOTEL_ROOM_SELECTION"] = "HOTEL ROOM SELECTION";
    WEBSITE_PAGE["PACKAGES_HOME"] = "PACKAGES HOME";
    WEBSITE_PAGE["PACKAGES_RESULTS"] = "PACKAGES RESULTS";
    WEBSITE_PAGE["PACKAGES_ROOM_SELECTION"] = "PACKAGES ROOM SELECTION";
})(WEBSITE_PAGE || (WEBSITE_PAGE = {}));

class InvoiceDataResponseModel extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
}

class ZupperDataModule {
    static forRoot(environment, apiBaseUrl) {
        return {
            ngModule: ZupperDataModule,
            providers: [
                { provide: 'env', useValue: environment },
            ],
        };
    }
}
ZupperDataModule.ɵfac = function ZupperDataModule_Factory(t) { return new (t || ZupperDataModule)(); };
ZupperDataModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ZupperDataModule });
ZupperDataModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ZupperDataModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [],
                exports: []
            }]
    }], null, null); })();

class ApiBaseService {
    constructor() {
        this._apiBaseUrl = '';
        this._apiPriceUrl = '';
        this._apiBookUrl = '';
        this._urlAerial = '';
        this._urlHotel = '';
        this._urlPackages = '';
        this._externalConfigUrl = '';
        this._zupperBlogFeedUrl = '';
    }
    /**
     * Sets a common URL to be used in all API requests
     * @param url The environment-based API base URL
     */
    setBaseUrl(url) {
        this._apiBaseUrl = url;
    }
    /**
     * @returns <string> The base API URL.
     */
    getBaseUrl() {
        return this._apiBaseUrl;
    }
    getApiPriceUrl() {
        return this._apiPriceUrl;
    }
    setApiPriceUrl(value) {
        this._apiPriceUrl = value;
    }
    getApiBookUrl() {
        return this._apiBookUrl;
    }
    setApiBookUrl(value) {
        this._apiBookUrl = value;
    }
    getExternalConfigUrl() {
        return this._externalConfigUrl;
    }
    setExternalConfigUrl(value) {
        this._externalConfigUrl = value;
    }
    /**
     * Sets the RSS URL used to fetch Zupper Blog posts content
     * @param url The RSS URL
     */
    setZupperBlogFeedUrl(url) {
        this._zupperBlogFeedUrl = url;
    }
    /**
     * @returns <string> The Zupper Blog RSS URL.
     */
    getZupperBlogFeedUrl() {
        return this._zupperBlogFeedUrl;
    }
    getUrlAerial() {
        return this._urlAerial;
    }
    setUrlAerial(value) {
        this._urlAerial = value;
    }
    getUrlHotel() {
        return this._urlHotel;
    }
    setUrlHotel(value) {
        this._urlHotel = value;
    }
    getUrlPackages() {
        return this._urlPackages;
    }
    setUrlPackages(value) {
        this._urlPackages = value;
    }
}
ApiBaseService.ɵfac = function ApiBaseService_Factory(t) { return new (t || ApiBaseService)(); };
ApiBaseService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiBaseService, factory: ApiBaseService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiBaseService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class ApiLoginService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this._isRunning = false;
        this._serviceUrl = apiBaseService.getBaseUrl() + '/rest/v2/session/login';
    }
    getToken() {
        if (!this._isRunning) {
            this._subject = new Subject();
            this._isRunning = true;
            this.getObservable()
                .pipe(map((resp) => {
                // TokenSetterService.set(resp['result']['sessionId']);
                return resp['result']['sessionId'];
            }), share()).subscribe(token => this._subject.next(token), () => null, () => {
                this._subject.complete();
                this._isRunning = false;
            });
        }
        return this._subject.asObservable();
    }
    getObservable() {
        return this.http.get(this._serviceUrl, {
            headers: { authExempt: "true" },
        });
    }
}
ApiLoginService.ɵfac = function ApiLoginService_Factory(t) { return new (t || ApiLoginService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiLoginService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiLoginService, factory: ApiLoginService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiLoginService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiAddressService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl = apiBaseService.getBaseUrl() + '/rest/v2/address/search';
    }
    getAddress(zipCode) {
        const params = {
            'zipCode': zipCode
        };
        return this.http.get(this.serviceUrl, { params: params })
            .pipe(map((res) => res), catchError(error => throwError(() => new Error(error.message || error))));
    }
    getTypedAddress(zipCode) {
        const params = {
            'zipCode': zipCode
        };
        return this.http.get(this.serviceUrl, { params: params })
            .pipe(catchError(error => throwError(() => new Error(error.message || error))), map((res) => {
            if (res.hasOwnProperty('success') && res['success'] === true) {
                const model = new ApiAddressResponse();
                model.fromApi(res['result']);
                return model;
            }
            throw Error('API Error');
        }));
    }
}
ApiAddressService.ɵfac = function ApiAddressService_Factory(t) { return new (t || ApiAddressService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiAddressService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiAddressService, factory: ApiAddressService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiAddressService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiAerialSourceService {
    /* Keep the return as Observable just in case we change the rules about how the sources will be fetched */
    load(airports) {
        return of([
            AerialSourceEnum.Latam,
            AerialSourceEnum.Azul,
            AerialSourceEnum.Gol,
            AerialSourceEnum.Sabre
        ]);
    }
}
ApiAerialSourceService.ɵfac = function ApiAerialSourceService_Factory(t) { return new (t || ApiAerialSourceService)(); };
ApiAerialSourceService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiAerialSourceService, factory: ApiAerialSourceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiAerialSourceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class ApiAerialDeepLinkService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.data = {};
        this.serviceUrl = apiBaseService.getBaseUrl() + '/rest/v2/aerial/deep-link-search';
    }
    get(key) {
        const headers = new HttpHeaders();
        let params = new HttpParams();
        params = params.append('key', key);
        return this.http.get(this.serviceUrl, { headers: headers, params: params })
            .pipe(map((res) => {
            if (res.success) {
                return res;
            }
            throw Error('Unable to process the request');
        }), retry({ count: 2, delay: 1000 }), catchError(() => {
            throw Error('Unable to process the request');
        }));
    }
}
ApiAerialDeepLinkService.ɵfac = function ApiAerialDeepLinkService_Factory(t) { return new (t || ApiAerialDeepLinkService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiAerialDeepLinkService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiAerialDeepLinkService, factory: ApiAerialDeepLinkService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiAerialDeepLinkService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiAirportSearchService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl = apiBaseService.getBaseUrl();
    }
    run(term) {
        return this.http
            .get(this.serviceUrl + '/rest/v2/city', {
            params: { term: term, withAirports: 'true' },
        })
            .pipe(map((response) => {
            if (response.hasOwnProperty('result') &&
                _.isArray(response['result'])) {
                return response['result'].map((airport) => {
                    const model = new AirportModel();
                    model.id = airport['id'];
                    model.airportCode = airport['airport_code'];
                    model.city = airport['city'];
                    model.country = airport['country'];
                    model.latitude = airport['latitude'];
                    model.longitude = airport['longitude'];
                    model.description = airport['description'];
                    model.region = airport['region'];
                    return model;
                });
            }
        }));
    }
    availableAirports(param) {
        return this.http.get(this.serviceUrl + '/rest/v2/city', { params: { term: param, withAirports: 'true' } });
    }
    typedAvailableAirports(param) {
        return this.http.get(this.serviceUrl + '/rest/v2/city', { params: { term: param, withAirports: 'true' } }).pipe(map(response => {
            if (response.success && Array.isArray(response.result)) {
                return response.result.map(r => {
                    const model = new ApiAirport();
                    model.fromApi(r);
                    return model;
                });
            }
            throw Error('Unable to parse airport data');
        }));
    }
}
ApiAirportSearchService.ɵfac = function ApiAirportSearchService_Factory(t) { return new (t || ApiAirportSearchService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiAirportSearchService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiAirportSearchService, factory: ApiAirportSearchService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiAirportSearchService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiFlightSearchService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl = apiBaseService.getBaseUrl() + '/rest/v2/aerial/search';
    }
    run(request, forceLogin = false, isMultiCias = false) {
        if (!isMultiCias) {
            return this.http.post(this.serviceUrl, request);
        }
        else {
            request.type = 'oneWay';
            const request2 = this.deepCopy(request);
            let aRequests = [];
            delete request2.slices;
            request.slices.map(slice => {
                const req = this.deepCopy(request2);
                req['slices'] = [slice];
                aRequests.push(this.http.post(this.serviceUrl, req));
            });
            return forkJoin(aRequests);
        }
    }
    deepCopy(o) {
        var copy = o, k;
        if (o && typeof o === 'object') {
            copy = Object.prototype.toString.call(o) === '[object Array]' ? [] : {};
            for (k in o) {
                copy[k] = this.deepCopy(o[k]);
            }
        }
        return copy;
    }
}
ApiFlightSearchService.ɵfac = function ApiFlightSearchService_Factory(t) { return new (t || ApiFlightSearchService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiFlightSearchService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiFlightSearchService, factory: ApiFlightSearchService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiFlightSearchService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiTokenRepositoryService {
    constructor(loginService) {
        this.loginService = loginService;
    }
    get(forceLogin = false) {
        if (forceLogin) {
            return this.fetch();
        }
        const current = sessionStorage.getItem('apiToken');
        if (_.isString(current)) {
            const data = JSON.parse(current);
            const expiration = moment$3(data['expiration']);
            if (expiration.isBefore(moment$3.utc(Date.now()))) {
                return this.fetch();
            }
            else {
                return of(data['token']);
            }
        }
        else {
            return this.fetch();
        }
    }
    fetch() {
        return this.loginService.getToken();
    }
}
ApiTokenRepositoryService.ɵfac = function ApiTokenRepositoryService_Factory(t) { return new (t || ApiTokenRepositoryService)(i0.ɵɵinject(ApiLoginService)); };
ApiTokenRepositoryService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiTokenRepositoryService, factory: ApiTokenRepositoryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiTokenRepositoryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiLoginService }]; }, null); })();

class ApiAerialFamiliesBasefareService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.serviceUrl = `${env.apiUrl}/rest/v2/airline/`;
    }
    run(query) {
        let parameters = new HttpParams();
        if (query) {
            for (const i of Object.keys(query)) {
                parameters = parameters.append(i, query[i]);
            }
        }
        return this.http.get(this.serviceUrl + 'base-fare-families', { params: parameters });
    }
    getFamilyDetails(query) {
        let parameters = new HttpParams();
        for (const i of Object.keys(query)) {
            parameters = parameters.append(i, query[i]);
        }
        return this.http
            .get(this.serviceUrl + 'family-details', {
            params: parameters,
        })
            .pipe(map((res) => res['result']), retry({ count: 2, delay: 1000 }), catchError(() => {
            throw Error('Unable to process the request');
        }));
    }
    getUnaccompaniedMinorInformation(iata) {
        let parameters = new HttpParams();
        parameters = parameters.append('iata_code', iata);
        return this.http
            .get(this.serviceUrl + 'search', { params: parameters })
            .pipe(map((res) => res['result']));
    }
}
ApiAerialFamiliesBasefareService.ɵfac = function ApiAerialFamiliesBasefareService_Factory(t) { return new (t || ApiAerialFamiliesBasefareService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject('env')); };
ApiAerialFamiliesBasefareService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiAerialFamiliesBasefareService, factory: ApiAerialFamiliesBasefareService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiAerialFamiliesBasefareService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

class ApiAerialPriceService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.serviceUrl = `${env.apiPriceUrl}/rest/v2/aerial/price`;
    }
    price(request) {
        return this.http.post(this.serviceUrl, request);
    }
    priceSpecial(orderId, customerSessionId) {
        const params = new HttpParams()
            .set('orderId', orderId.toString())
            .set('customerSessionId', customerSessionId);
        return this.http.get(`${this.env.apiPriceUrl}/rest/v2/order/details`, { params })
            .pipe(map(res => {
            let apiResponse = new ApiResponse();
            apiResponse.meta = res['meta']['aerial'];
            apiResponse.result = res['result']['aerial'];
            apiResponse.success = res['success'];
            apiResponse.error = res['error'];
            return apiResponse;
        }));
    }
}
ApiAerialPriceService.ɵfac = function ApiAerialPriceService_Factory(t) { return new (t || ApiAerialPriceService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject('env')); };
ApiAerialPriceService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiAerialPriceService, factory: ApiAerialPriceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiAerialPriceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

class ApiTestimonialsService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.url = apiBaseService.getBaseUrl() + '/rest/v2/testimonials';
    }
    get() {
        return this.http.get(this.url)
            .pipe(map$1((response) => {
            const result = [];
            if (response.hasOwnProperty('success') && response['success'] === true && _.isArray(response['result'])) {
                for (let i = 0; i < response['result'].length; i++) {
                    const item = new TestimonialModel();
                    item.id = response['result'][i]['id'];
                    item.from = response['result'][i]['testimonial_from'];
                    item.order = parseInt(response['result'][i]['sort_by'], 10);
                    item.content = response['result'][i]['content'];
                    result.push(item);
                }
            }
            return result;
        }), share$1(), retry$1({ count: 5, delay: 1000 }), catchError$1(this.handleError));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
ApiTestimonialsService.ɵfac = function ApiTestimonialsService_Factory(t) { return new (t || ApiTestimonialsService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiTestimonialsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiTestimonialsService, factory: ApiTestimonialsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiTestimonialsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class AerialBookingService {
    constructor(http, apiBaseService, env) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.env = env;
        this.serviceUrl = apiBaseService.getApiBookUrl() + '/rest/v2/ticket/book';
        this.serviceUrlPayment = apiBaseService.getBaseUrl() + '/rest/v2/order/payment';
    }
    setDataResponse(data) {
        localStorage.setItem('response_book', JSON.stringify(data));
    }
    getDataResponse() {
        return JSON.parse(localStorage.getItem('response_book'));
    }
    setDataResponseError(data) {
        localStorage.setItem('response_book_error', JSON.stringify(data));
    }
    getDataResponseError() {
        return JSON.parse(localStorage.getItem('response_book_error'));
    }
    clearStorage() {
        const items = [
            'request_book',
            'response_search',
            // 'response_book', // Utilizado na tela de obrigado
            'price_param',
            'response_book_error',
            'checkout_param'
        ];
        for (const item of items) {
            localStorage.removeItem(item);
        }
    }
    setDataRequest(data) {
        localStorage.setItem('request_book', JSON.stringify(data));
    }
    getDataRequest() {
        return JSON.parse(localStorage.getItem('request_book'));
    }
    get(mokfile) {
        return this.http.get(`/assets/mock/${mokfile}.json`)
            .pipe(map((res) => res), catchError(error => throwError(() => new Error(error))));
    }
    safetyPay(orderId, paymentForm) {
        const body = {
            'orderId': orderId,
            'paymentForm': paymentForm,
            'payments': null
        };
        return this.http.post(this.serviceUrlPayment, body)
            .pipe(map((res) => res), catchError(error => throwError(() => new Error(error.message || error))));
    }
    book(body) {
        return this.http.post(this.serviceUrl, body)
            .pipe(timeout(this.env.apiTimeout.seconds), map((res) => res), catchError(error => {
            return throwError(() => error);
        }));
    }
    typedBooking(request) {
        return this.http.post(this.serviceUrl, request.toApi()).pipe(catchError((errorResponse) => {
            const error = errorResponse.error;
            if (Array.isArray(error.error) && error.error[0] === 'DisponibilidadeEsgotada') {
                const errorObj = new ApiBookingError(API_BOOKING_ERROR_TYPE.UNAVAILABLE, error.error[0], error.error);
                errorObj.message = error.error[0];
                return throwError(() => errorObj);
            }
            else {
                const errorObj = new ApiBookingError(API_BOOKING_ERROR_TYPE.UNKNOWN, error?.error ? error.error[0] : undefined, error.error);
                return throwError(() => errorObj);
            }
        }), map((response) => {
            if (response.hasOwnProperty('success') && response.hasOwnProperty('result')) {
                if (Array.isArray(response['result']) && response['result'].length > 0) {
                    const model = new ApiAerialBookFullResponse();
                    model.fromApi(response);
                    return model;
                }
            }
            const error = new ApiBookingError(API_BOOKING_ERROR_TYPE.UNKNOWN, 'API Error', response);
            throw error;
        }));
    }
}
AerialBookingService.ɵfac = function AerialBookingService_Factory(t) { return new (t || AerialBookingService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService), i0.ɵɵinject('env')); };
AerialBookingService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AerialBookingService, factory: AerialBookingService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AerialBookingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

class AerialStorageSearchService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl = apiBaseService.getBaseUrl() + '/rest/v2/aerial/search';
    }
    getSearch() {
        return new Promise((resolve, reject) => {
            this.postSearch().subscribe((item) => {
                resolve(item);
            }, (error) => {
                reject(error);
            });
        });
    }
    postSearch() {
        const parm = this.getParam();
        return this.http.post(this.serviceUrl, parm)
            .pipe(map((res) => res), catchError(error => throwError(() => new Error(error.message || error))));
    }
    getParam() {
        const parm = JSON.parse(localStorage.getItem('checkout_param'));
        const new_parm = {
            type: parm.request.type,
            adultQty: parm.request.adultQty,
            childrenQty: parm.request.childrenQty,
            infantQty: parm.request.infantQty,
            slices: parm.request.slices,
            grouped: false,
            forceCacheRefresh: true,
            limit: 1
        };
        return new_parm;
    }
}
AerialStorageSearchService.ɵfac = function AerialStorageSearchService_Factory(t) { return new (t || AerialStorageSearchService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
AerialStorageSearchService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AerialStorageSearchService, factory: AerialStorageSearchService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AerialStorageSearchService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class AerialPriceService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl = apiBaseService.getApiPriceUrl() + '/rest/v2/aerial/price';
    }
    getContent() {
        return this.content;
    }
    setContent(content) {
        this.content = new Price(content);
    }
    postPrice() {
        return new Promise((resolve, reject) => {
            const parm = this.getParm();
            this.getPrice(parm).subscribe((item) => {
                this.setContent(item);
                resolve(item);
            }, (error) => {
                reject(error);
            });
        });
    }
    getPrice(parm) {
        return this.http.post(this.serviceUrl, parm)
            .pipe(map((res) => res), catchError(error => throwError(error.message || error)));
    }
    setCheckoutParam(item) {
        // Ordena o resultado pela data de embarque para nao dar erro no DSG
        if (item && item['result'] && item['result'].length && item['result'][0].slices) {
            item['result'][0].slices.sort(function (a, b) {
                if (a.departureDate > b.departureDate) {
                    return 1;
                }
                if (a.departureDate < b.departureDate) {
                    return -1;
                }
                return 0;
            });
        }
        localStorage.setItem('checkout_param', JSON.stringify(item));
    }
    getParm() {
        const new_parm = JSON.parse(localStorage.getItem('checkout_param'));
        if (new_parm) {
            new_parm.result[0]['passengers'] = this.getpassengers(new_parm.meta.request);
        }
        return new_parm.result[0];
    }
    getpassengers(parm) {
        const passengers = [];
        const adultQty = parm.adultQty;
        const childrenQty = parm.childrenQty;
        const infantQty = parm.infantQty;
        if (adultQty >= 1) {
            for (let i = 0; i < adultQty; i++) {
                passengers.push(this.createpassengers('ADT'));
            }
        }
        if (childrenQty >= 1) {
            for (let i = 0; i < childrenQty; i++) {
                passengers.push(this.createpassengers('CHD'));
            }
        }
        if (infantQty >= 1) {
            for (let i = 0; i < infantQty; i++) {
                passengers.push(this.createpassengers('INF'));
            }
        }
        return passengers;
    }
    createpassengers(type) {
        return {
            'firstName': null,
            'lastName': null,
            'type': type,
            'gender': null,
            'birthDate': null,
            'email': null,
            'cpf': null,
            'rg': null
        };
    }
}
AerialPriceService.ɵfac = function AerialPriceService_Factory(t) { return new (t || AerialPriceService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
AerialPriceService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AerialPriceService, factory: AerialPriceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AerialPriceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class AppSettingsService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.url = apiBaseService.getExternalConfigUrl();
    }
    get() {
        return this.http.get(this.url)
            .pipe(map(response => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                const model = new AppSettings();
                model.activateWebsiteLogs = response['result']['activateWebsiteLogs'];
            }
            else {
                return false;
            }
        }));
    }
}
AppSettingsService.ɵfac = function AppSettingsService_Factory(t) { return new (t || AppSettingsService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
AppSettingsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AppSettingsService, factory: AppSettingsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppSettingsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ZupperBlogService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
    }
    getLatest() {
        return this.http.get(this.apiBaseService.getZupperBlogFeedUrl(), {
            headers: new HttpHeaders()
                .set('authExempt', 'true')
                .set('Content-Type', 'application/xml+rss'),
            responseType: 'text'
        })
            .pipe(map$1((response) => {
            const rssJson = converter.xml2js(response, { compact: true });
            const result = [];
            rssJson['rss']['channel']['item'].forEach(element => {
                const item = new ZupperBlogEntry();
                item.title = element['title']['_text'];
                item.url = element['link']['_text'];
                item.link = element['link']['_text'];
                item.imageUrl = this.parserImg(element['description']['_cdata']);
                result.push(item);
            });
            return result;
        }));
    }
    parserImg(html) {
        let htmlParser = new DOMParser;
        let htmlDoc = htmlParser.parseFromString(html, 'text/html');
        let imgs = htmlDoc.getElementsByTagName('img');
        return imgs.item(0).getAttribute('src');
    }
}
ZupperBlogService.ɵfac = function ZupperBlogService_Factory(t) { return new (t || ZupperBlogService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ZupperBlogService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ZupperBlogService, factory: ZupperBlogService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ZupperBlogService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiBannerService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.url = apiBaseService.getBaseUrl() + '/rest/v2/power-messaging';
    }
    getBanners(type, location, product = null) {
        const headers = new HttpHeaders();
        let params = new HttpParams();
        params = params.set('type', type);
        params = params.set('location', location);
        if (!!product) {
            params = params.set('product', product);
        }
        return this.http.get(this.url, { headers: headers, params: params })
            .pipe(map$1(response => {
            const result = [];
            if (response.hasOwnProperty('success') && response['success'] === true) {
                response['result'].forEach(element => {
                    const model = new BannerModel();
                    model.path = element['path'];
                    model.url = element['url'];
                    model.image = element['image'];
                    model.type = element['type'];
                    model.location = element['location'];
                    model.gaEvent = element['gaEvent'];
                    model.hover = element['hover'];
                    model.fullPath = element['fullPath'];
                    model.product = element['product'] ?? null;
                    model.imageMobile = element['imageMobile'] ?? null;
                    model.order = parseInt(element['order'], 10);
                    result.push(model);
                });
                return result;
            }
            else {
                return [];
            }
        }), 
        /*map(banners => {
          if (!banners.length) {
            return [this._testBanner()];
          }
        }),*/
        retry$1({ count: 5, delay: 1000 }), catchError$1(this.handleError));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
ApiBannerService.ɵfac = function ApiBannerService_Factory(t) { return new (t || ApiBannerService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiBannerService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiBannerService, factory: ApiBannerService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiBannerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

const moment$2 = moment$3;
class ApiAerialPromotionsService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.url = apiBaseService.getBaseUrl() + '/rest/v2/promotions';
    }
    getAll() {
        const headers = new HttpHeaders();
        return this.http.get(this.url, { headers: headers })
            .pipe(map$1(response => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                const result = [];
                response['result'].forEach(item => {
                    const model = new ApiAerialPromo();
                    model.guid = Guid.create().toString(); // needed in order to have non-numeric ids for carousels
                    model.id = item['id'];
                    model.enabled = item['enabled'];
                    model.endDate = moment$2(item['endDate']);
                    model.imageUrl = item['imageUrl'];
                    model.maxInstallments = parseInt(item['maxInstallments'], 10);
                    model.order = parseInt(item['sortBy'], 10);
                    model.peopleCurrentTotal = parseInt(item['peopleCurrentTotal'], 10);
                    model.peopleMax = parseInt(item['peopleMax'], 10);
                    model.peopleNeeded = parseInt(item['peopleNeeded'], 10);
                    model.perPersonPrice = parseFloat(item['perPersonPrice']);
                    model.points = parseInt(item['points'], 10);
                    model.promotionType = item['promotionType'];
                    model.startDate = moment$2(item['startDate']);
                    model.status = parseInt(item['status'], 10);
                    model.taxes = parseFloat(item['taxes']);
                    model.title = item['promotionTitle'];
                    model.totalFare = parseFloat(item['totalFare']);
                    if (item.hasOwnProperty('slices') && _.isArray(item['slices'])) {
                        item['slices'].forEach(s => {
                            const slice = new ApiAerialPromoSlice();
                            slice.arrivalDate = moment$2(s['arriveDatetime'], MOMENT_FORMATS.API_DATETIME);
                            slice.departureDate = moment$2(s['departDatetime'], MOMENT_FORMATS.API_DATETIME);
                            slice.originAirportCode = s['originAirportCode'];
                            slice.destinationAirportCode = s['destinationAirportCode'];
                            if (s['duration'] !== null && s['duration'].indexOf(':') > -1) {
                                const splitted = s['duration'].split(':');
                                slice.duration = moment$2.duration({ hours: parseInt(splitted[0], 10), minutes: parseInt(splitted[1], 10) });
                            }
                            else {
                                slice.duration = moment$2.duration(slice.arrivalDate.diff(slice.departureDate));
                            }
                            slice.flightNumber = s['flightNumber'];
                            slice.id = s['id'];
                            slice.marketingAirline = s['marketingAirline'];
                            model.slices.push(slice);
                        });
                    }
                    result.push(model);
                });
                return result;
            }
            else {
                return [];
            }
        }), retry$1({ count: 5, delay: 1000 }), catchError$1(this.handleError));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
ApiAerialPromotionsService.ɵfac = function ApiAerialPromotionsService_Factory(t) { return new (t || ApiAerialPromotionsService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiAerialPromotionsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiAerialPromotionsService, factory: ApiAerialPromotionsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiAerialPromotionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

const moment$1 = moment$3;
class ApiHotelPromotionsService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.url = apiBaseService.getBaseUrl() + '/rest/v2/promotions';
    }
    getAll() {
        const headers = new HttpHeaders();
        headers.set('authExempt', 'true');
        return this.http.get(this.url, { headers: headers })
            .pipe(map$1(response => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                const result = [];
                response['result'].forEach(item => {
                    const model = new ApiAerialPromo();
                    model.guid = Guid.create().toString(); // needed in order to have non-numeric ids for carousels
                    model.id = item['id'];
                    model.enabled = item['enabled'];
                    model.endDate = moment$1(item['endDate']);
                    model.imageUrl = item['imageUrl'];
                    model.maxInstallments = parseInt(item['maxInstallments'], 10);
                    model.order = parseInt(item['sortBy'], 10);
                    model.peopleCurrentTotal = parseInt(item['peopleCurrentTotal'], 10);
                    model.peopleMax = parseInt(item['peopleMax'], 10);
                    model.peopleNeeded = parseInt(item['peopleNeeded'], 10);
                    model.perPersonPrice = parseFloat(item['perPersonPrice']);
                    model.points = parseInt(item['points'], 10);
                    model.promotionType = item['promotionType'];
                    model.startDate = moment$1(item['startDate']);
                    model.status = parseInt(item['status'], 10);
                    model.taxes = parseFloat(item['taxes']);
                    model.title = item['promotionTitle'];
                    model.totalFare = parseFloat(item['totalFare']);
                    if (item.hasOwnProperty('slices') && _.isArray(item['slices'])) {
                        item['slices'].forEach(s => {
                            const slice = new ApiAerialPromoSlice();
                            slice.arrivalDate = moment$1(s['arriveDatetime'], MOMENT_FORMATS.API_DATETIME);
                            slice.departureDate = moment$1(s['departDatetime'], MOMENT_FORMATS.API_DATETIME);
                            slice.originAirportCode = s['originAirportCode'];
                            slice.destinationAirportCode = s['destinationAirportCode'];
                            if (s['duration'] !== null && s['duration'].indexOf(':') > -1) {
                                const splitted = s['duration'].split(':');
                                slice.duration = moment$1.duration({ hours: parseInt(splitted[0], 10), minutes: parseInt(splitted[1], 10) });
                            }
                            else {
                                slice.duration = moment$1.duration(slice.arrivalDate.diff(slice.departureDate));
                            }
                            slice.flightNumber = s['flightNumber'];
                            slice.id = s['id'];
                            slice.marketingAirline = s['marketingAirline'];
                            model.slices.push(slice);
                        });
                    }
                    result.push(model);
                });
                return result;
            }
            else {
                return [];
            }
        }), retry$1({ count: 5, delay: 1000 }), catchError$1(this.handleError));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
ApiHotelPromotionsService.ɵfac = function ApiHotelPromotionsService_Factory(t) { return new (t || ApiHotelPromotionsService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiHotelPromotionsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiHotelPromotionsService, factory: ApiHotelPromotionsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiHotelPromotionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

const moment = moment$3;
class ApiAerialGeolocationIpService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl = apiBaseService.getBaseUrl() + "/rest/v2/airport/geo-search";
    }
    get() {
        return this.http.get(this.serviceUrl).pipe(map$1((response) => {
            var result = new ApiAerialGeolocation();
            if (response.hasOwnProperty("success") && response["success"] === true && isObject(response["result"])) {
                result = response["result"];
            }
            return result;
        }), retry$1({ count: 5, delay: 1000 }), catchError$1(this.handleError));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error("An error occurred:", error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(() => new Error("Something bad happened; please try again later."));
    }
}
ApiAerialGeolocationIpService.ɵfac = function ApiAerialGeolocationIpService_Factory(t) { return new (t || ApiAerialGeolocationIpService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiAerialGeolocationIpService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiAerialGeolocationIpService, factory: ApiAerialGeolocationIpService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiAerialGeolocationIpService, [{
        type: Injectable,
        args: [{
                providedIn: "root",
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiCampaignService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.url = apiBaseService.getBaseUrl() + '/rest/v2/setting/campaign';
    }
    getCampaignData(utmSource, utmCampaign, utmMedium) {
        let params = (new HttpParams())
            .set('utmSource', utmSource)
            .set('utmCampaign', utmCampaign)
            .set('utmMedium', utmMedium);
        let response = this.http.get(this.url, { params: params })
            .pipe(map$1(response => {
            let result = [];
            if (response.hasOwnProperty('success') && response['success'] === true) {
                response['result'].forEach(element => {
                    let campaignModel = new ApiCampaignModel;
                    campaignModel.name = element.name;
                    campaignModel.utmSource = element.utmSource;
                    campaignModel.utmCampaign = element.utmCampaign;
                    campaignModel.utmMedium = element.utmMedium;
                    campaignModel.credentialGroup = element.credentialGroup;
                    campaignModel.createdDate = element.createdDate.date;
                    campaignModel.modifiedDate = element.modifiedDate.date;
                    result.push(campaignModel);
                });
            }
            return result;
        }));
        return response;
    }
}
ApiCampaignService.ɵfac = function ApiCampaignService_Factory(t) { return new (t || ApiCampaignService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiCampaignService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiCampaignService, factory: ApiCampaignService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiCampaignService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiCorporateService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.url = apiBaseService.getBaseUrl() + '/rest/v2/corporate';
    }
    get(corporateName) {
        let params = (new HttpParams())
            .set('corporateName', corporateName);
        return this.http.get(this.url, { params: params }).pipe(map$1(response => {
            let result = null;
            if (response.hasOwnProperty('success') && response['success'] === true) {
                let campaignModel = new ApiCorporateModel(response['result']);
                result = campaignModel;
            }
            return result;
        }), 
        //retryWhen(err => { return err.pipe(delay(1000), take(5)) }),
        catchError$1(error => {
            console.log(error);
            return EMPTY;
        }), share$1());
    }
}
ApiCorporateService.ɵfac = function ApiCorporateService_Factory(t) { return new (t || ApiCorporateService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiCorporateService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiCorporateService, factory: ApiCorporateService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiCorporateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiCorporateLoginService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.url = apiBaseService.getBaseUrl() + '/rest/v2/corporate/login';
    }
    login(username, password, corporateId) {
        return this.http.post(this.url, {
            'username': username,
            'password': password,
            'corporateId': corporateId
        }).pipe(map$1(response => {
            let result = null;
            if (response.hasOwnProperty('success') && response['success'] === true) {
                let campaignModel = new ApiCorporateLoginModel(response['result']);
                result = campaignModel;
            }
            return result;
        }));
    }
}
ApiCorporateLoginService.ɵfac = function ApiCorporateLoginService_Factory(t) { return new (t || ApiCorporateLoginService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiCorporateLoginService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiCorporateLoginService, factory: ApiCorporateLoginService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiCorporateLoginService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class RdstationNewsletterService {
    constructor(http) {
        this.http = http;
        this.serviceUrl = "https://api.rd.services/platform/conversions?api_key=3131112d56d41d15559bc81446a9fbf7";
    }
    send(newsletterModel) {
        return this.http.post(this.serviceUrl, newsletterModel)
            .pipe(map$1((res) => res), retry$1({ count: 2, delay: 1000 }), catchError$1(this.handleError));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error("An error occurred:", error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(() => new Error("Something bad happened; please try again later."));
    }
}
RdstationNewsletterService.ɵfac = function RdstationNewsletterService_Factory(t) { return new (t || RdstationNewsletterService)(i0.ɵɵinject(i1.HttpClient)); };
RdstationNewsletterService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RdstationNewsletterService, factory: RdstationNewsletterService.ɵfac, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RdstationNewsletterService, [{
        type: Injectable,
        args: [{
                providedIn: "root",
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class ApiPackageSearchService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl =
            apiBaseService.getBaseUrl() + '/rest/v2/travelPackage/search';
    }
    run(request, forceLogin = false) {
        return this.http.post(this.serviceUrl, request.toJSON());
    }
}
ApiPackageSearchService.ɵfac = function ApiPackageSearchService_Factory(t) { return new (t || ApiPackageSearchService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiPackageSearchService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiPackageSearchService, factory: ApiPackageSearchService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiPackageSearchService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiCustomerService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.basicReturnMessage = 'Houve um problema durante sua solicitação. Tente novamente mais tarde';
        this.serviceUrl = apiBaseService.getBaseUrl() + '/rest/v2/customer';
        this.serviceUrlOrder = apiBaseService.getBaseUrl() + '/rest/v2/order';
        this.emailServiceUrl = apiBaseService.getBaseUrl() + '/rest/v2/mail';
    }
    customerLogin(request) {
        const url = this.serviceUrl + '/auth';
        return this.http.post(url, [request, { 'provider': 'e-mail' }]).pipe(map$1((response) => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                const customerSessionId = response['result']['customerSessionId'];
                const expiration = response['result']['expiration']['date'];
                const expirationItem = {
                    item: customerSessionId,
                    expiration: moment$3(expiration, moment$3.HTML5_FMT.DATETIME_LOCAL_MS)
                };
                return expirationItem;
            }
            else {
                throw new Error(this.basicReturnMessage);
            }
        }));
    }
    getCustomer(customerSessionId, provider) {
        let params = new HttpParams({ fromObject: { customerSessionId: customerSessionId } });
        return this.http.get(this.serviceUrl, { params: params }).pipe(map$1((response) => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                if (!response['result'].hasOwnProperty('provider')) {
                    response["result"]["provider"] = provider ?? null;
                }
                const model = new ApiCustomer();
                model.fromApi(response['result']);
                return model;
            }
            else {
                throw new Error(this.basicReturnMessage);
            }
        }));
    }
    putCustomer(customerSessionId, customer) {
        const body = {
            customerSessionId: customerSessionId,
            ...this._convertCustomerForUpdate(customer)
        };
        return this.http.put(this.serviceUrl, body).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            return response.hasOwnProperty('success') && response['success'] === true;
        }));
    }
    validateEmail(email) {
        return this.http.post(`${this.serviceUrl}/email-exists`, { email: email }).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            if (response.hasOwnProperty('result') && !!response['result'].hasOwnProperty('emailExists')) {
                if (response['result']['emailExists'] == "true" || response['result']['emailExists'] === true) {
                    return true;
                }
            }
            return false;
        }));
    }
    forgotPassword(email) {
        const url = `${this.serviceUrl}/password-recovery`;
        const data = { email: email };
        return this.http.post(url, data).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            return response.hasOwnProperty('success') && response['success'] === true;
        }));
    }
    sendNewCustomerEmail(email) {
        const url = `${this.serviceUrl}/register-email`;
        const data = { email: email };
        return this.http.post(url, data).pipe(catchError$1((err) => {
            let error = {
                ...err,
                message: this.basicReturnMessage
            };
            return throwError(() => error);
        }), map$1((response) => {
            return response.hasOwnProperty('success') && response['success'] === true;
        }));
    }
    sendPasswordCreationLink(email) {
        const url = `${this.emailServiceUrl}/send-password-creation`;
        const data = { email: email };
        return this.http.post(url, data).pipe(catchError$1((error) => {
            //TODO: send to sentry
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            return response.hasOwnProperty('success') && response['success'] === true;
        }));
    }
    firebaseGoogleLogin(idToken) {
        const url = `${this.serviceUrl}/firebase-auth`;
        const data = { idToken: idToken, 'provider': 'google' };
        return this.http.post(url, data).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            return this._handleAuthResponse(response);
        }));
    }
    kontikSSOLogin(accessToken, partnerId) {
        const url = `${this.serviceUrl}/firebase-auth`;
        const data = { idToken: accessToken, 'partnerId': partnerId, 'provider': 'sso' };
        return this.http.post(url, data).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            return this._handleAuthResponse(response);
        }));
    }
    facebookLogin(accessToken) {
        const url = `${this.serviceUrl}/firebase-auth`;
        const data = { idToken: accessToken, 'provider': 'facebook' };
        return this.http.post(url, data).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1(response => {
            return this._handleAuthResponse(response);
        }));
    }
    customerOrders(customerSessionId, filter) {
        if (!customerSessionId) {
            return throwError(() => new Error('Não há usuário logado'));
        }
        const url = `${this.serviceUrl}/orders?customerSessionId=${customerSessionId}`;
        return this.http.get(url).pipe(catchError$1((error) => {
            if (error instanceof HttpErrorResponse) {
                const errorResponse = new ApiCustomerOrdersError();
                errorResponse.isApi = true;
                if (error.status === 401 || error.status === 403) {
                    errorResponse.isUnauthorized = true;
                }
                return throwError(() => errorResponse);
            }
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            if (response.hasOwnProperty('result')) {
                const responseModel = new ApiCustomerOrdersResponse();
                responseModel.orders = response['result'].map(r => {
                    const model = new CustomerOrders();
                    model.fromApi(r);
                    return model;
                });
                if (response.hasOwnProperty('meta') && response['meta'].hasOwnProperty('airports')) {
                    responseModel.airports = response['meta']['airports'].map(x => {
                        const model = new ApiAirport();
                        model.fromApi(x);
                        return model;
                    });
                }
                if (response.hasOwnProperty('meta') && response['meta'].hasOwnProperty('airlines')) {
                    responseModel.airlines = response['meta']['airlines'].map(x => {
                        const model = new ApiAirline();
                        model.fromApi(x);
                        return model;
                    });
                }
                if (response.hasOwnProperty('meta') && response['meta'].hasOwnProperty('destinations')) {
                    responseModel.destinations = response['meta']['destinations'].map(x => {
                        const model = new ApiDestination();
                        model.fromApi(x);
                        // IMPORTANT: this line adds the airport city image to the object for easy retrieval, but the images will also be saved separately later on
                        responseModel.airports.filter(a => a.city === model.city).forEach(a => a.imageUrl = model.imageUrl);
                        return model;
                    });
                }
                return responseModel;
            }
            throw Error('Erro ao obter informações da API');
        }), map$1((x) => {
            if (!filter || filter.situation.length === 0) {
                return x;
            }
            else {
                x.orders = x.orders.filter(o => {
                    let found = false;
                    if (!filter.term || filter.term.length === 0) {
                        return true;
                    }
                    else if (filter.term === o.orderId) {
                        return found = true;
                    }
                    found = o.reservations.aerial.some(a => {
                        const foundPassengers = a.passengers.some(p => this._isStringInObject(filter.term, p));
                        const locator = a.locator.includes(filter.term);
                        return foundPassengers || locator;
                    });
                    if (!found) {
                        found = o.reservations.hotel.some(h => {
                            const guests = h.guests.some(g => this._isStringInObject(filter.term, g));
                            const locator = h.providerLocator.includes(filter.term);
                            const others = this._isStringInObject(filter.term, h, ['hotelCity', 'hotelAddress', 'hotelCountry', 'hotelName']);
                            return guests || locator || others;
                        });
                    }
                    return found;
                });
                return x;
            }
        }));
    }
    validatePasswordResetKey(key) {
        const url = `${this.serviceUrl}/validate-key`;
        const data = {
            key: key
        };
        return this.http.post(url, data).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            if (response.hasOwnProperty('success')) {
                return response['success'];
            }
            throw Error('Erro ao obter informações da API');
        }));
    }
    validateAccountCreateToken(token) {
        const url = `${this.serviceUrl}/validate-email-token`;
        let data = new HttpParams();
        data = data.set('token', token);
        return this.http.get(url, { params: data }).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                if (response['result'].hasOwnProperty('validToken') && response['result']['validToken'] === false) {
                    throw Error('O link não é válido ou está expirado.');
                }
                else if (response['result'].hasOwnProperty('email')) {
                    return response['result']['email'];
                }
            }
            throw Error('Erro ao obter informações da API');
        }));
    }
    createPassword(email, password, token) {
        const data = {
            email: email,
            password: password,
            token: token,
            passwordConfirmation: password
        };
        return this.http.post(this.serviceUrl, data).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((result) => {
            return result.hasOwnProperty('success') && result.success === true;
        }));
    }
    resetPassword(key, password) {
        const url = `${this.serviceUrl}/password-reset`;
        const data = {
            key: key,
            newPassword: password,
            newPasswordConfirmation: password
        };
        return this.http.post(url, data).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            if (response.hasOwnProperty('success')) {
                return response['success'];
            }
            throw Error('Erro ao obter informações da API');
        }));
    }
    updatePassword(customerSessionId, body) {
        const url = `${this.serviceUrl}/password`;
        const data = {
            customerSessionId: customerSessionId,
            ...body
        };
        return this.http.put(url, data).pipe(catchError$1((responseError) => {
            const defaultMessage = this.basicReturnMessage;
            return throwError(() => new Error(responseError?.error?.error ?? defaultMessage));
        }), map$1((response) => {
            if (response.hasOwnProperty('success')) {
                return response['success'];
            }
            throw Error('Erro ao obter informações da API');
        }));
    }
    pictureUpload(customerSessionId, file) {
        const url = `${this.serviceUrl}/picture_upload`;
        const formData = new FormData();
        formData.append('customerSessionId', customerSessionId);
        formData.append('image', file, file.name);
        return this.http.post(url, formData).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            if (response.hasOwnProperty('success')) {
                return response['result'];
            }
            throw Error('Erro ao obter informações da API');
        }));
    }
    getOrderFareRules(customerSessionId, orderId) {
        const url = this.apiBaseService.getBaseUrl() + '/rest/v2/order';
        let params = new HttpParams();
        params = params.set('orderId', orderId.toString());
        params = params.set('customerSessionId', customerSessionId);
        return this.http.get(url, { params: params }).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1(response => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                try {
                    return response['result'][0]['aerial'].map(a => a['fareRules']);
                }
                catch (err) {
                    throw new Error('Erro ao obter regras tarifárias do pedido.');
                }
            }
        }));
    }
    orderExists(customerSessionId, orderId) {
        const filter = new CustomerOrdersFilters();
        return this.customerOrders(customerSessionId, filter).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            return response.orders.find(o => o.orderId === orderId);
        }));
    }
    logout(customerSessionId, sessionId) {
        const url = `${this.serviceUrl}/auth`;
        let options = {
            body: {
                customerSessionId: customerSessionId,
                sessionId: sessionId
            }
        };
        return this.http.request('DELETE', url, options).pipe(map$1(response => {
            return response.hasOwnProperty('success') && !!response['success'];
        }));
    }
    cancelOrder(customerSessionId, orderId) {
        const body = {
            orderId: orderId,
            customerSessionId: customerSessionId
        };
        const options = {
            body: body
        };
        const url = `${this.apiBaseService.getBaseUrl()}/rest/v2/order`;
        return this.http.request('delete', url, options)
            .pipe(catchError$1((error) => {
            if (error?.status === 404) {
                return of({ success: false });
            }
            else if (error?.error?.error?.message === 'The requested order cannot be canceled.') {
                return throwError(() => new Error('order_cancel_not_permitted'));
            }
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            if (response?.['success'] === true) {
                return true;
            }
            return false;
        }));
    }
    ngOnDestroy() {
    }
    _handleAuthResponse(response) {
        if (response.hasOwnProperty('success') && response['success'] === true) {
            const customerSessionId = response['result']['customerSessionId'];
            const expiration = response['result']['expiration']['date'];
            const expirationItem = {
                item: customerSessionId,
                expiration: moment$3(expiration, moment$3.HTML5_FMT.DATETIME_LOCAL_MS)
            };
            return expirationItem;
        }
    }
    _isStringInObject(text, obj, lookupProperties = []) {
        const iterable = lookupProperties.length === 0 ? Object.keys(obj) : lookupProperties;
        for (let i = 0; i < iterable.length; i++) {
            const key = iterable[i];
            if (_.isString(obj[key]) && obj[key].toLowerCase().indexOf(text.toLowerCase()) != -1)
                return true;
        }
        return false;
    }
    _convertCustomerForUpdate(customer) {
        let addresses = [];
        if (customer.addressProfile) {
            customer.addressProfile.isBilling = false;
            addresses.push(customer.addressProfile);
        }
        else if (customer.addressBilling) {
            customer.addressBilling.isProfile = false;
            addresses.push(customer.addressBilling);
        }
        return {
            id: customer.id,
            email: customer.email,
            cpf: customer.cpf,
            firstName: customer.firstName,
            lastName: customer.lastName,
            activated: customer.activated,
            username: customer.username,
            creditCards: customer.creditCards,
            addresses: addresses,
            branding: customer.branding
        };
    }
    printVoucher(key) {
        const url = `${this.serviceUrlOrder}/print-voucher?key=${key}`;
        return this.http.get(url).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            if (response.hasOwnProperty('success')) {
                const model = new OrderVoucher();
                model.fromApi(response['result']);
                return model;
            }
            throw Error('Erro ao obter informações da API');
        })).toPromise();
    }
}
ApiCustomerService.ɵfac = function ApiCustomerService_Factory(t) { return new (t || ApiCustomerService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiCustomerService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiCustomerService, factory: ApiCustomerService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiCustomerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();
class ApiCustomerOrdersError {
}

class ApiEmailService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.basicReturnMessage = 'Houve um problema durante sua solicitação. Tente novamente mais tarde';
        this.serviceUrl = apiBaseService.getBaseUrl() + '/rest/v2/mail';
    }
    sentEmail(body) {
        return this.http.post(`${this.serviceUrl}/send`, body).pipe(catchError$1((error) => {
            console.log(error);
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            console.log(response);
            // if (response.hasOwnProperty('result') && !!response['result'].hasOwnProperty('emailExists')) {
            //   if (response['result']['emailExists'] == "true" || response['result']['emailExists'] === true) {
            //     return true;
            //   }
            // }
            return false;
        }));
    }
    forgotPassword(email) {
        const url = `${this.serviceUrl}/password-recovery`;
        const data = { email: email };
        return this.http.post(url, data).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            return response.hasOwnProperty('success') && response['success'] === true;
        }));
    }
    sendNewCustomerEmail(email) {
        const url = `${this.serviceUrl}/register-email`;
        const data = { email: email };
        return this.http.post(url, data).pipe(catchError$1((error) => {
            return throwError(() => new Error(this.basicReturnMessage));
        }), map$1((response) => {
            return response.hasOwnProperty('success') && response['success'] === true;
        }));
    }
}
ApiEmailService.ɵfac = function ApiEmailService_Factory(t) { return new (t || ApiEmailService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiEmailService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiEmailService, factory: ApiEmailService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiEmailService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiPaymentService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.serviceUrl = `${env.apiUrl}/rest/v2/payment/payment-forms`;
        this.orderPaymentUrl = `${env.apiUrl}/rest/v2/order/payment`;
        this.validateAccountUrl = `${env.apiUrl}/rest/v2/payment/validate-accounts`;
        this.verifyTokenUrl = `${env.apiUrl}/rest/v2/payment/validate-key`;
        this.validateCreditCardUrl = `${env.apiUrl}/rest/v2/payment/validate-credit-card`;
    }
    payments(body) {
        return this.http.post(this.serviceUrl, body.toApi()).pipe(map$1(data => {
            const checkoutPayments = [];
            for (const i of Object.keys(CHECKOUT_PAYMENT_FORMS)) {
                const model = new CheckoutPayment(i);
                model.fromApi(data['result'][i]);
                checkoutPayments.push(model);
            }
            return checkoutPayments;
        }));
    }
    orderPayment(request) {
        return this.http.post(this.orderPaymentUrl, request).pipe(retry$1(request.specialCheckout ? 0 : 3), map$1(response => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                if (request.paymentForm === 'CREDIT_CARD') {
                    return true;
                }
                else {
                    const model = new BasePaymentResponse();
                    model.fromApi(response['result'][0]);
                    return model;
                }
            }
            else {
                throw Error('API Error');
            }
        }));
    }
    validateAccounts(request) {
        return this.http.post(this.validateAccountUrl, request).pipe(map$1(response => {
            if (!!response['success'] && !!response['result'].hasOwnProperty('isValidAccount')) {
                return response['result']['isValidAccount'];
            }
            return false;
        }));
    }
    validateToken(token) {
        return this.http.post(this.verifyTokenUrl, token).pipe(map$1(response => {
            if (!!response['success'] && !!response['result'].hasOwnProperty('validKey')) {
                return response['result']['orderId'];
            }
            return null;
        }));
    }
    validateCreditCard(request) {
        return this.http.post(this.validateCreditCardUrl, request).pipe(map$1(response => {
            return response['success'];
        }));
    }
}
ApiPaymentService.ɵfac = function ApiPaymentService_Factory(t) { return new (t || ApiPaymentService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject('env')); };
ApiPaymentService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiPaymentService, factory: ApiPaymentService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiPaymentService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

class ApiInvoiceService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl = apiBaseService.getBaseUrl() + '/rest/v2/order/invoice-data';
    }
    sendData(request) {
        return this.http.post(this.serviceUrl, request)
            .pipe(map((res) => res), retry({ count: 2, delay: 1000 }), catchError(this.handleError));
    }
    updateData(request) {
        return this.http.put(this.serviceUrl, request)
            .pipe(map((res) => res), retry({ count: 2, delay: 1000 }), catchError(this.handleError));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
ApiInvoiceService.ɵfac = function ApiInvoiceService_Factory(t) { return new (t || ApiInvoiceService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiInvoiceService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiInvoiceService, factory: ApiInvoiceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiInvoiceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiHotelCheckoutService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl = apiBaseService.getBaseUrl() + '/rest/v2/hotel';
    }
    availableHotels(searchFields) {
        const url = `${this.serviceUrl}/search`;
        return this.http.post(url, searchFields)
            .pipe(map$1((response) => {
            if (response.hasOwnProperty('success') && response['success'] == true) {
                const model = new HotelResponseModel();
                model.fromApi(response['result']);
                return model;
            }
            else {
                throwError(() => new Error('API Error'));
            }
        }), retry$1({ count: 2, delay: 1000 }), catchError$1((err) => this.handleError(err)));
    }
    searchRooms(selectedHotel) {
        return this.http.post(this.serviceUrl + '/search-room', selectedHotel.toApiRequest())
            .pipe(map$1((response) => {
            const model = new HotelRoomResponseModel();
            model.fromApi(response?.['result'] ?? {});
            return model;
        }), retry$1({ count: 2, delay: 1000 }), catchError$1(this.handleError));
    }
    hotelPrice(pricing) {
        return this.http.post(this.serviceUrl + '/price', pricing.toApi())
            .pipe(map$1((response) => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                const model = new HotelPriceResponseModel();
                model.fromApi(response['result']);
                return model;
            }
            throw Error('API Error');
        }), retry$1({ count: 2, delay: 1000 }), catchError$1(this.handleError));
    }
    bookRequest(book) {
        return this.http.post(this.serviceUrl + '/book', book)
            .pipe(map$1(res => Object.assign(new DefaultResponseModel, res)), retry$1({ count: 2, delay: 1000 }), catchError$1(this.handleError));
    }
    typedBooking(request) {
        return this.http.post(this.serviceUrl + '/book', request.toApi()).pipe(map$1(response => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                const model = new HotelBookingConfirmation();
                model.fromApi(response['result']);
                return model;
            }
            const error = new ApiBookingError(API_BOOKING_ERROR_TYPE.UNKNOWN, 'API Error', response);
            throw error;
        }), retry$1(3), catchError$1((errorResponse) => {
            const error = errorResponse.error;
            const errorObj = new ApiBookingError(API_BOOKING_ERROR_TYPE.UNKNOWN, error?.error ? error.error[0] : undefined, error.error);
            return throwError(() => errorObj);
        }));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
ApiHotelCheckoutService.ɵfac = function ApiHotelCheckoutService_Factory(t) { return new (t || ApiHotelCheckoutService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiHotelCheckoutService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiHotelCheckoutService, factory: ApiHotelCheckoutService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiHotelCheckoutService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiCityService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl = `${this.apiBaseService.getBaseUrl()}/rest/v2/city`;
    }
    searchCity(brokerCode) {
        return this.http.get(this.serviceUrl, { params: { brokerCode } })
            .pipe(map$1((response) => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                const model = new AvailableCitiesModel();
                model.fromApi(response['result']);
                return model;
            }
            else {
                throw Error('API Error');
            }
        }), retry$1({ count: 2, delay: 1000 }), catchError$1(this.handleError));
    }
    searchCityDSG(dsgCode) {
        return this.http.get(this.serviceUrl, { params: { dsgCode } })
            .pipe(map$1((response) => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                const model = new AvailableCitiesModel();
                model.fromApi(response['result']);
                return model;
            }
            else {
                throw Error('API Error');
            }
        }), retry$1({ count: 2, delay: 1000 }), catchError$1(this.handleError));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
ApiCityService.ɵfac = function ApiCityService_Factory(t) { return new (t || ApiCityService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiCityService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiCityService, factory: ApiCityService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiCityService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiCartService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.serviceUrl = `${env.apiUrl}/rest/v2/cart`;
    }
    abandonCart(request) {
        return this.http.post(`${this.serviceUrl}/abandonment`, request).pipe(retry$1({ count: 2, delay: 1000 }), catchError$1(this.handleError));
    }
    updateCart(id, destinationCity, email, phone) {
        return this.http.put(`${this.serviceUrl}/abandonment`, { id, destinationCity, email, phone }).pipe(retryWhen(err => { return err.pipe(delay(1000), take(2)); }), catchError$1(this.handleError));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
ApiCartService.ɵfac = function ApiCartService_Factory(t) { return new (t || ApiCartService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject('env')); };
ApiCartService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiCartService, factory: ApiCartService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiCartService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

class PackageBookingService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl = apiBaseService.getApiBookUrl() + '/rest/v2/travelPackage/book';
    }
    typedBooking(request) {
        return this.http.post(this.serviceUrl, request.toApi()).pipe(catchError$1((errorResponse) => {
            const error = errorResponse.error;
            const errorObj = new ApiBookingError(API_BOOKING_ERROR_TYPE.UNKNOWN, error?.error ? error.error[0] : undefined, error.error);
            return throwError(() => errorObj);
        }), retry$1(3), map$1((response) => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                const model = new ApiPackageBookResponse();
                model.fromApi(response['result'], response['meta']);
                return model;
            }
            const error = new ApiBookingError(API_BOOKING_ERROR_TYPE.UNKNOWN, 'API Error', response);
            throw error;
        }));
    }
}
PackageBookingService.ɵfac = function PackageBookingService_Factory(t) { return new (t || PackageBookingService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
PackageBookingService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PackageBookingService, factory: PackageBookingService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PackageBookingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiJuniperHotelSearchService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl = apiBaseService.getBaseUrl() + '/rest/v3/hotel/info';
    }
    getHotel(sourceCode) {
        return this.http.get(this.serviceUrl, { params: { sourceCode } })
            .pipe(map((response) => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                const model = new JuniperHotelResponseModel();
                model.fromApi(response['result']);
                return model;
            }
            else {
                throw Error('API Error');
            }
        }), catchError(this.handleError));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError('Something bad happened; please try again later.');
    }
}
ApiJuniperHotelSearchService.ɵfac = function ApiJuniperHotelSearchService_Factory(t) { return new (t || ApiJuniperHotelSearchService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiJuniperHotelSearchService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiJuniperHotelSearchService, factory: ApiJuniperHotelSearchService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiJuniperHotelSearchService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiJuniperHotelPriceResponseModel extends HotelPriceResponseModel {
    fromApi(apiData) {
        super.fromApi(apiData);
        this.pensionType = new JuniperHotelRoomPensionType();
        this.pensionType.fromApi(apiData['pensionType']);
        this.price = new JuniperHotelRoomPrice();
        this.price.fromApi(apiData['price']);
        if (Array.isArray(apiData['rooms'])) {
            this.rooms = apiData['rooms'].map((x) => {
                const model = new JuniperHotelRoom();
                model.fromApi(x);
                return model;
            });
        }
        else if (!apiData['rooms']) {
            this.rooms = [];
        }
        if (Array.isArray(apiData['hotelComments'])) {
            this.hotelComments = apiData['hotelComments'].map((x) => {
                const model = new JuniperHotelComments();
                model.fromApi(x);
                return model;
            });
        }
        else if (!apiData['hotelComments']) {
            this.hotelComments = [];
        }
        this.cancellationPolicy = new JuniperHotelRoomCancellationPolicy();
        this.cancellationPolicy.fromApi(apiData['cancellationPolicy']);
    }
    getApiDatetimeFields() {
        return ['bookingCodeExpiration', 'checkIn', 'checkOut'];
    }
}
class JuniperHotelComments extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
    }
}

class ApiHotelDeepLinkService {
    constructor(http, apiBaseService, juniperHotelSearchService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.juniperHotelSearchService = juniperHotelSearchService;
        this.serviceUrl =
            apiBaseService.getBaseUrl() + '/rest/v3/hotel/deepLinkCheckout';
        this.serviceSearchRoomUrl =
            apiBaseService.getBaseUrl() +
                '/rest/v3/hotel/deepLinkSearchRooms';
    }
    get(key) {
        const headers = new HttpHeaders();
        let params = new HttpParams();
        params = params.append('data', key);
        return this.http
            .get(this.serviceUrl, { headers: headers, params: params })
            .pipe(switchMap((res) => {
            return this.juniperHotelSearchService
                .getHotel(res.result.sourceCode)
                .pipe(map$1((hotel) => {
                let model = new ApiJuniperHotelPriceResponseModel();
                model = res.result;
                model.hotel = hotel;
                return model;
            }), catchError$1((error) => throwError(error.message || error)));
        }), retry$1({ count: 2, delay: 1000 }), catchError$1(() => {
            throw Error('Unable to process the request');
        }));
    }
    getSearchRoom(key) {
        const headers = new HttpHeaders();
        let params = new HttpParams();
        params = params.append('data', key);
        return this.http
            .get(this.serviceSearchRoomUrl, { headers: headers, params: params })
            .pipe(switchMap((res) => {
            if (res['success']) {
                return this.juniperHotelSearchService
                    .getHotel(res.result[0].sourceCode)
                    .pipe(map$1((hotel) => {
                    res.result.forEach((item) => {
                        item.hotel = hotel;
                    });
                    return res.result;
                }), catchError$1((error) => throwError(error.message || error)));
            }
            else {
                throw new Error('Unable to parse from API');
            }
        }), retryWhen((err) => err.pipe(delay(1000), take(2))), catchError$1((error) => throwError(error.message || error)));
    }
}
ApiHotelDeepLinkService.ɵfac = function ApiHotelDeepLinkService_Factory(t) { return new (t || ApiHotelDeepLinkService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService), i0.ɵɵinject(ApiJuniperHotelSearchService)); };
ApiHotelDeepLinkService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiHotelDeepLinkService, factory: ApiHotelDeepLinkService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiHotelDeepLinkService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }, { type: ApiJuniperHotelSearchService }]; }, null); })();

class ApiOrderPriceService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.serviceUrl = `${env.apiPriceUrl}/rest/v2/order/details`;
    }
    price(orderId, customerSessionId) {
        const params = new HttpParams()
            .set('orderId', orderId.toString())
            .set('customerSessionId', customerSessionId);
        return this.http.get(this.serviceUrl, { params }).pipe(map$1((response) => {
            if (!!response.result.aerial && Array.isArray(response.result.aerial.slices)) {
                response.result.aerial.slices.map(slice => {
                    if (!Array.isArray(slice.baseFares)) {
                        slice.baseFares = [slice.baseFares];
                    }
                    return slice;
                });
            }
            if (response.hasOwnProperty('success') && response['success']) {
                const invoiceDataModel = new InvoiceDataResponseModel();
                invoiceDataModel.fromApi(response.result.invoiceData);
                response.result.invoiceData = invoiceDataModel;
            }
            return response;
        }));
    }
    priceAerial(orderId, customerSessionId) {
        return this.price(orderId, customerSessionId)
            .pipe(map$1(res => {
            let apiResponse = new ApiResponse();
            apiResponse.meta = res.meta.aerial;
            apiResponse.result = res.result.aerial;
            apiResponse.success = res.success;
            apiResponse.error = res.error;
            return apiResponse;
        }));
    }
    priceHotel(orderId, customerSessionId) {
        return this.price(orderId, customerSessionId)
            .pipe(map$1(res => {
            if (res.hasOwnProperty('success') && res['success'] === true) {
                const model = new HotelPriceResponseModel();
                model.fromApi(res.result.hotel);
                return model;
            }
            throw Error('API Error');
        }), retry$1({ count: 2, delay: 1000 }), catchError$1(this.handleError));
    }
    priceBookDetails(orderId, customerSessionId) {
        const params = new HttpParams()
            .set('orderId', orderId.toString())
            .set('customerSessionId', customerSessionId);
        return this.http.get(`${this.env.apiPriceUrl}/rest/v2/order/book-details`, { params })
            .pipe(map$1((response) => {
            return response.result;
        }, catchError$1(this.handleError)));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
ApiOrderPriceService.ɵfac = function ApiOrderPriceService_Factory(t) { return new (t || ApiOrderPriceService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject('env')); };
ApiOrderPriceService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiOrderPriceService, factory: ApiOrderPriceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiOrderPriceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

class ApiOfferService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.loadingSubject$ = new BehaviorSubject(false);
        this.offerSubject$ = new BehaviorSubject(null);
        this.airportsSubject$ = new BehaviorSubject([]);
        this._serviceUrl = `${env.apiUrl}/rest/v2/offers`;
    }
    offers(product) {
        this.loadingSubject$.next(true);
        this.http.get(`${this._serviceUrl}?product=${product}`).pipe(map$1(res => {
            return res;
        }), catchError$1((error) => {
            console.error(error.message, error);
            return of(null);
        }), finalize(() => this.loadingSubject$.next(false))).subscribe((res) => {
            if (!!res) {
                const model = new ApiOffer();
                model.fromApi(res['result']);
                this.offerSubject$.next(model);
                this.airportsSubject$.next(res['meta']['cities']);
            }
        });
    }
    ;
}
ApiOfferService.ɵfac = function ApiOfferService_Factory(t) { return new (t || ApiOfferService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject('env')); };
ApiOfferService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiOfferService, factory: ApiOfferService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiOfferService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

class ApiContentConfigurationService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this._serviceUrl = `${env.apiUrl}/rest/v2/app-settings`;
    }
    getConfiguration() {
        return this.http.get(`${this._serviceUrl}/configurations`).pipe(map((response) => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                const result = response['result'];
                return [...result].map((item) => {
                    const model = new ApiConfiguration();
                    model.fromApi(item);
                    return model;
                });
            }
            else {
                throw Error('API Error');
            }
        }));
    }
}
ApiContentConfigurationService.ɵfac = function ApiContentConfigurationService_Factory(t) { return new (t || ApiContentConfigurationService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject('env')); };
ApiContentConfigurationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiContentConfigurationService, factory: ApiContentConfigurationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiContentConfigurationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

var DataLayerCustomDimensions;
(function (DataLayerCustomDimensions) {
    DataLayerCustomDimensions["MentionedBrand"] = "mentionedBrand";
    DataLayerCustomDimensions["PageCategory"] = "pageCategory";
    DataLayerCustomDimensions["WordsCount"] = "wordsCount";
    DataLayerCustomDimensions["Something"] = "";
})(DataLayerCustomDimensions || (DataLayerCustomDimensions = {}));

class DataLayerService {
    constructor() {
        this._constantDimensions = {};
        this._generateEmptyDimensionsSet();
        // this._constantDimensions = [] // Get here dimensions that need to be sent at every push;
    }
    set dimensions(someDimensions) {
        Object.keys(DataLayerCustomDimensions).map(key => DataLayerCustomDimensions[key])
            .forEach(key => {
            this._currentSet[key] = someDimensions[key] || this._constantDimensions[key];
        });
    }
    trigger() {
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
        window.dataLayer.push(this._currentSet);
    }
    _generateEmptyDimensionsSet() {
        this._currentSet = {
            [DataLayerCustomDimensions.MentionedBrand]: undefined,
            [DataLayerCustomDimensions.PageCategory]: undefined,
            [DataLayerCustomDimensions.WordsCount]: undefined,
            [DataLayerCustomDimensions.Something]: undefined,
        };
    }
}
DataLayerService.ɵfac = function DataLayerService_Factory(t) { return new (t || DataLayerService)(); };
DataLayerService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DataLayerService, factory: DataLayerService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataLayerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

var DataLayerThanks;
(function (DataLayerThanks) {
    DataLayerThanks["event"] = "event";
    DataLayerThanks["number"] = "number";
    DataLayerThanks["airline"] = "airline";
    DataLayerThanks["discount"] = "discount";
    DataLayerThanks["duValue"] = "duValue";
    DataLayerThanks["du2Value"] = "du2Value";
    DataLayerThanks["totalAirportTaxes"] = "totalAirportTaxes";
    DataLayerThanks["totalCreditCardFee"] = "totalCreditCardFee";
    DataLayerThanks["totalFarePrice"] = "totalFarePrice";
    DataLayerThanks["totalIncentiveValue"] = "totalIncentiveValue";
    DataLayerThanks["totalPrice"] = "totalPrice";
    DataLayerThanks["totalWithDiscount"] = "totalWithDiscount";
    DataLayerThanks["type"] = "type";
})(DataLayerThanks || (DataLayerThanks = {}));

class DataLayerThanksService {
    constructor() {
        this._constantDimensions = {};
        this._generateEmptyDimensionsSet();
        // this._constantDimensions = [] // Get here dimensions that need to be sent at every push;
    }
    set dimensions(someDimensions) {
        Object.keys(DataLayerThanks)
            .map(key => DataLayerThanks[key])
            .forEach(key => {
            this._currentSet[key] =
                someDimensions[key] || this._constantDimensions[key];
        });
    }
    trigger() {
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
        window.dataLayer.push(this._currentSet);
    }
    _generateEmptyDimensionsSet() {
        this._currentSet = {
            [DataLayerThanks.event]: undefined,
            [DataLayerThanks.number]: undefined,
            [DataLayerThanks.discount]: undefined,
            [DataLayerThanks.duValue]: undefined,
            [DataLayerThanks.du2Value]: undefined,
            [DataLayerThanks.airline]: undefined,
            [DataLayerThanks.type]: undefined,
            [DataLayerThanks.totalWithDiscount]: undefined,
            [DataLayerThanks.totalPrice]: undefined,
            [DataLayerThanks.totalIncentiveValue]: undefined,
            [DataLayerThanks.totalFarePrice]: undefined,
            [DataLayerThanks.totalCreditCardFee]: undefined,
            [DataLayerThanks.totalAirportTaxes]: undefined
        };
    }
}
DataLayerThanksService.ɵfac = function DataLayerThanksService_Factory(t) { return new (t || DataLayerThanksService)(); };
DataLayerThanksService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DataLayerThanksService, factory: DataLayerThanksService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataLayerThanksService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

var DataLayerCheckout;
(function (DataLayerCheckout) {
    // Something = '',
    DataLayerCheckout["event"] = "event";
    DataLayerCheckout["adultQuantity"] = "adultQuantity";
    DataLayerCheckout["childQuantity"] = "childQuantity";
    DataLayerCheckout["infantQuantity"] = "infantQuantity";
    DataLayerCheckout["departureDate"] = "departureDate";
    DataLayerCheckout["returnDate"] = "returnDate";
    DataLayerCheckout["originAirport"] = "originAirport";
    DataLayerCheckout["originCountry"] = "originCountry";
    DataLayerCheckout["destinationAirport"] = "destinationAirport";
    DataLayerCheckout["destinationCountry"] = "destinationCountry";
    //tripType = 'tripType', // (National, International)
    DataLayerCheckout["tripType"] = "tripType";
    DataLayerCheckout["airlineName"] = "airlineName";
    //TravelingDays = 'TravelingDays',
    DataLayerCheckout["orderId"] = "orderId";
    DataLayerCheckout["customerName"] = "customerName";
    DataLayerCheckout["customerEmail"] = "customerEmail";
    DataLayerCheckout["customerPhone"] = "customerPhone";
    DataLayerCheckout["duValue"] = "duValue";
    DataLayerCheckout["du2Value"] = "du2Value";
    DataLayerCheckout["totalAirportTaxes"] = "totalAirportTaxes";
    DataLayerCheckout["totalCreditCardFee"] = "totalCreditCardFee";
    DataLayerCheckout["totalFarePrice"] = "totalFarePrice";
    DataLayerCheckout["totalIncentiveValue"] = "totalIncentiveValue";
    DataLayerCheckout["totalPrice"] = "totalPrice";
    DataLayerCheckout["totalWithTax"] = "totalWithTax";
    DataLayerCheckout["chosenFamilyName"] = "chosenFamilyName";
    DataLayerCheckout["upsellValue"] = "upsellValue";
})(DataLayerCheckout || (DataLayerCheckout = {}));

class DataLayerCheckoutService {
    constructor() {
        this._constantDimensions = {};
        this._generateEmptyDimensionsSet();
        // this._constantDimensions = [] // Get here dimensions that need to be sent at every push;
    }
    set dimensions(someDimensions) {
        Object.keys(DataLayerCheckout).map(key => DataLayerCheckout[key])
            .forEach(key => {
            this._currentSet[key] = someDimensions[key] || this._constantDimensions[key];
        });
    }
    trigger() {
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
        window.dataLayer.push(this._currentSet);
    }
    _generateEmptyDimensionsSet() {
        this._currentSet = {
            [DataLayerCheckout.event]: undefined,
            [DataLayerCheckout.adultQuantity]: undefined,
            [DataLayerCheckout.childQuantity]: undefined,
            [DataLayerCheckout.infantQuantity]: undefined,
            [DataLayerCheckout.departureDate]: undefined,
            [DataLayerCheckout.returnDate]: undefined,
            [DataLayerCheckout.originAirport]: undefined,
            [DataLayerCheckout.originCountry]: undefined,
            [DataLayerCheckout.destinationAirport]: undefined,
            [DataLayerCheckout.destinationCountry]: undefined,
            //[DataLayerCheckout.tripType]: undefined,
            [DataLayerCheckout.tripType]: undefined,
            [DataLayerCheckout.airlineName]: undefined,
            //[DataLayerCheckout.TravelingDays]: undefined,
            [DataLayerCheckout.orderId]: undefined,
            [DataLayerCheckout.customerName]: undefined,
            [DataLayerCheckout.customerEmail]: undefined,
            [DataLayerCheckout.customerPhone]: undefined,
            [DataLayerCheckout.duValue]: undefined,
            [DataLayerCheckout.du2Value]: undefined,
            [DataLayerCheckout.totalAirportTaxes]: undefined,
            [DataLayerCheckout.totalWithTax]: undefined,
            [DataLayerCheckout.totalPrice]: undefined,
            [DataLayerCheckout.totalFarePrice]: undefined,
            [DataLayerCheckout.totalCreditCardFee]: undefined,
            [DataLayerCheckout.totalIncentiveValue]: undefined,
            [DataLayerCheckout.chosenFamilyName]: undefined,
            [DataLayerCheckout.upsellValue]: undefined
        };
    }
}
DataLayerCheckoutService.ɵfac = function DataLayerCheckoutService_Factory(t) { return new (t || DataLayerCheckoutService)(); };
DataLayerCheckoutService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DataLayerCheckoutService, factory: DataLayerCheckoutService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataLayerCheckoutService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class AnalyticsService {
    constructor(_dataLayerCustomDimensions, _dataLayerCheckout, _dataLayerThanks, _router, route) {
        this._dataLayerCustomDimensions = _dataLayerCustomDimensions;
        this._dataLayerCheckout = _dataLayerCheckout;
        this._dataLayerThanks = _dataLayerThanks;
        this._router = _router;
        this.route = route;
    }
    pageView() {
        window.dataLayer.push({
            event: 'pageview',
            pagePath: this._router.url
        });
    }
    session() {
        let token = null;
        try {
            let tokenData = JSON.parse(localStorage.getItem('token') || '{}');
            if (tokenData.token) {
                token = tokenData.token;
            }
        }
        catch (e) {
            token = null;
        }
        if (token !== null && token !== '') {
            try {
                const helper = new JwtHelperService();
                const decoded = helper.decodeToken(token);
                const sessionId = decoded['jti'];
                if (sessionId !== null) {
                    window.dataLayer.push({
                        event: 'session',
                        id: sessionId
                    });
                }
            }
            catch (e) {
            }
        }
    }
    pageViewCheckout(someDimensions, overridePath) {
        this._dataLayerCheckout.dimensions = someDimensions;
        this._dataLayerCheckout.trigger();
    }
    addTransThanks(someDimensions, overridePath) {
        this._dataLayerThanks.dimensions = someDimensions;
        this._dataLayerThanks.trigger();
    }
    _getPassengers(obj) {
        let retorno = [];
        if (obj && obj.hasOwnProperty('result')) {
            if (obj.result.hasOwnProperty('passengers')) {
                retorno = obj.result.passengers;
            }
            else if (obj.result instanceof Array && obj.result[0].hasOwnProperty('reservation')
                && obj.result[0].reservation.hasOwnProperty('passengers')) {
                retorno = obj.result[0].reservation.passengers;
            }
        }
        return retorno;
    }
    _getSlices(obj) {
        let retorno = [];
        if (obj && obj.hasOwnProperty('result')) {
            if (obj.result.hasOwnProperty('slices')) {
                retorno = obj.result.slices;
            }
            else if (obj.result instanceof Array &&
                obj.result[0].hasOwnProperty('reservation') &&
                obj.result[0].reservation.hasOwnProperty('slices')) {
                retorno = obj.result[0].reservation.slices;
            }
        }
        return retorno;
    }
    setPageViewCheckout(priceContent) {
        const someObject = {
            [DataLayerCheckout.event]: "pageData",
            [DataLayerCheckout.adultQuantity]: undefined,
            [DataLayerCheckout.orderId]: undefined,
            [DataLayerCheckout.childQuantity]: undefined,
            [DataLayerCheckout.infantQuantity]: undefined,
            [DataLayerCheckout.departureDate]: undefined,
            [DataLayerCheckout.returnDate]: undefined,
            [DataLayerCheckout.originAirport]: undefined,
            [DataLayerCheckout.originCountry]: undefined,
            [DataLayerCheckout.destinationAirport]: undefined,
            [DataLayerCheckout.destinationCountry]: undefined,
            //[DataLayerCheckout.tripType]: 'National',
            [DataLayerCheckout.tripType]: undefined,
            [DataLayerCheckout.airlineName]: undefined,
            //[DataLayerCheckout.TravelingDays]: undefined,
            [DataLayerCheckout.duValue]: undefined,
            [DataLayerCheckout.du2Value]: undefined,
            [DataLayerCheckout.totalAirportTaxes]: undefined,
            [DataLayerCheckout.totalWithTax]: undefined,
            [DataLayerCheckout.totalPrice]: undefined,
            [DataLayerCheckout.totalFarePrice]: undefined,
            [DataLayerCheckout.totalCreditCardFee]: undefined,
            [DataLayerCheckout.totalIncentiveValue]: undefined,
            [DataLayerCheckout.chosenFamilyName]: undefined,
            [DataLayerCheckout.upsellValue]: undefined,
        };
        const passengers = this._getPassengers(priceContent);
        let total_adt = 0;
        let total_chd = 0;
        let total_inf = 0;
        passengers.map(item => {
            total_adt += (item.type === 'ADT' ? 1 : 0);
            total_chd += (item.type === 'CHD' ? 1 : 0);
            total_inf += (item.type === 'INF' ? 1 : 0);
        });
        someObject[DataLayerCheckout.customerEmail] = passengers[0].email;
        someObject[DataLayerCheckout.customerName] = passengers[0].firstName ?
            `${passengers[0].firstName} ${passengers[0].lastName}` : undefined;
        someObject[DataLayerCheckout.customerPhone] = passengers[0].phoneAreaCode ?
            `${passengers[0].phoneAreaCode}${passengers[0].phoneNumber}` : undefined;
        const slices = this._getSlices(priceContent);
        // TODO: No response do booke precisa colocar preencher o conteudo da propriedade  direction
        // slices.map(item => {
        const firstItem = slices[0];
        // if (item['direction'] === 'going' && !someObject[DataLayerCheckout.departureDate]) {
        someObject[DataLayerCheckout.departureDate] = firstItem['departureDate'];
        someObject[DataLayerCheckout.originAirport] = firstItem['origin'];
        someObject[DataLayerCheckout.destinationAirport] = firstItem['destination'];
        // }
        const lastItem = slices.slice(-1)[0];
        // if (item['direction'] === 'return' && !someObject[DataLayerCheckout.returnDate]) {
        if (lastItem) {
            someObject[DataLayerCheckout.returnDate] = lastItem['departureDate'];
        }
        // }
        // });
        let resultContent;
        if (priceContent.result instanceof Array && priceContent.result[0].hasOwnProperty('type')) {
            resultContent = priceContent.result[0];
        }
        else {
            resultContent = priceContent.result;
        }
        someObject[DataLayerCheckout.orderId] = resultContent.hasOwnProperty('orderId') ? resultContent.orderId : undefined;
        someObject[DataLayerCheckout.tripType] = resultContent['type'];
        someObject[DataLayerCheckout.airlineName] = resultContent['airline'] instanceof Array
            ? resultContent['airline'].join() : resultContent['airline'];
        someObject[DataLayerCheckout.adultQuantity] = total_adt.toString();
        someObject[DataLayerCheckout.childQuantity] = total_chd.toString();
        someObject[DataLayerCheckout.infantQuantity] = total_inf.toString();
        //someObject[DataLayerCheckout.tripType] = total_inf.toString();
        someObject[DataLayerCheckout.originCountry] = priceContent.meta.airports[someObject[DataLayerCheckout.originAirport]]['country'];
        if (someObject[DataLayerCheckout.destinationAirport]) {
            someObject[DataLayerCheckout.destinationCountry] =
                priceContent.meta.airports[someObject[DataLayerCheckout.destinationAirport]]['country'];
            // tslint:disable-next-line: max-line-length
            // someObject[DataLayerCheckout.tripType] = someObject[DataLayerCheckout.originCountry] !== someObject[DataLayerCheckout.destinationCountry]
            //   ? 'International' : 'National';
        }
        // if (someObject[DataLayerCheckout.departureDate] && someObject[DataLayerCheckout.returnDate]) {
        //   someObject[DataLayerCheckout.TravelingDays] = <string><unknown>this.diffDates(
        //     new Date(someObject[DataLayerCheckout.departureDate]),
        //     new Date(someObject[DataLayerCheckout.returnDate])
        //   );
        // }
        someObject[DataLayerCheckout.duValue] = resultContent.hasOwnProperty("reservation")
            ? resultContent['reservation']['duValue'].toFixed(2)
            : resultContent['duValue'].toFixed(2);
        someObject[DataLayerCheckout.du2Value] = resultContent.hasOwnProperty("reservation")
            ? resultContent["reservation"]["du2Value"].toFixed(2)
            : resultContent['du2Value'].toFixed(2);
        someObject[DataLayerCheckout.totalAirportTaxes] = resultContent.hasOwnProperty("reservation")
            ? resultContent["reservation"]['totalAirportTaxes']
            : resultContent['totalAirportTaxesPrice'];
        someObject[DataLayerCheckout.totalWithTax] = resultContent['totalWithTax'];
        someObject[DataLayerCheckout.totalPrice] = resultContent.hasOwnProperty("reservation")
            ? resultContent["reservation"]["totalPrice"]
            : resultContent["totalPrice"];
        someObject[DataLayerCheckout.totalFarePrice] = resultContent.hasOwnProperty("reservation")
            ? resultContent["reservation"]['totalFarePrice']
            : resultContent['totalFarePrice'];
        someObject[DataLayerCheckout.totalCreditCardFee] = resultContent.hasOwnProperty("reservation")
            ? resultContent["reservation"]['totalCreditCardFee'].toFixed(2)
            : resultContent['totalCreditCardFee'].toFixed(2);
        someObject[DataLayerCheckout.totalIncentiveValue] = resultContent.hasOwnProperty("reservation")
            ? resultContent["reservation"]["totalIncentiveValue"].toFixed(2)
            : resultContent["totalIncentiveValue"].toFixed(2);
        someObject[DataLayerCheckout.chosenFamilyName] = slices[0]['baseFares'][0]['family'];
        sessionStorage.getItem("upsellPrice")
            ? someObject[DataLayerCheckout.upsellValue] = parseInt(JSON.parse(sessionStorage.getItem("upsellPrice")))
            : someObject[DataLayerCheckout.upsellValue] = 0;
        this.pageViewCheckout(someObject);
        return someObject;
    }
    diffDates(date1, date2) {
        const diffTime = Math.abs(date2.getTime() - date1.getTime());
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }
    getParamsUTM() {
        return JSON.parse(localStorage.getItem('utm_storage'));
    }
}
AnalyticsService.ɵfac = function AnalyticsService_Factory(t) { return new (t || AnalyticsService)(i0.ɵɵinject(DataLayerService), i0.ɵɵinject(DataLayerCheckoutService), i0.ɵɵinject(DataLayerThanksService), i0.ɵɵinject(i4.Router), i0.ɵɵinject(i4.ActivatedRoute)); };
AnalyticsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AnalyticsService, factory: AnalyticsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AnalyticsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DataLayerService }, { type: DataLayerCheckoutService }, { type: DataLayerThanksService }, { type: i4.Router }, { type: i4.ActivatedRoute }]; }, null); })();

class TokenInterceptor {
    constructor(http, analytics, apiBaseService) {
        this.http = http;
        this.analytics = analytics;
        this.apiBaseService = apiBaseService;
        this.refreshTokenInProgress = false;
        this.token = null;
        this.expiration = null;
        this.retryToken = 0;
        this.serviceUrl = this.apiBaseService.getBaseUrl();
    }
    intercept(request, next) {
        // if this is a login request or any other request that shouldn't have an authentication
        this.retryToken = 0;
        if (request.url.includes('session/login') ||
            request.headers.get('authExempt') == 'true') {
            const modifiedHeaders = request.headers.delete('authExempt');
            const newRequest = new HttpRequest(request.method, request.url, request.body, {
                headers: modifiedHeaders,
                reportProgress: request.reportProgress,
                params: request.params,
                responseType: request.responseType,
                withCredentials: request.withCredentials,
            });
            return next.handle(newRequest);
        }
        // get token data from storage if available
        this.extractToken();
        // if there is a token from the storage, validate its expiration
        if (this.token) {
            try {
                const helper = new JwtHelperService();
                const decoded = helper.decodeToken(this.token);
                const sessionId = decoded['jti'];
                const tokenExpiry = moment$3(this.expiration);
                let isExpired = helper.isTokenExpired(this.token);
                if (!decoded || isExpired || sessionId == null) {
                    this.token = null;
                }
            }
            catch (e) {
                this.token = null;
            }
        }
        // if there is no valid token, get a new one
        if (!this.token) {
            if (!this.refreshTokenInProgress) {
                return from(this.refreshTokenAsync()).pipe(switchMap((v) => {
                    return this._handle(next, request);
                }));
            }
        }
        else {
            return this._handle(next, request);
        }
    }
    _handle(next, request) {
        this.retryToken++;
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${this.token}`,
            },
        });
        return next.handle(request).pipe(catchError$1((error) => {
            if (error && error.status == 403 && this.retryToken <= 3) {
                localStorage.removeItem('token');
                return from(this.refreshTokenAsync()).pipe(switchMap((v) => {
                    this.extractToken();
                    return this._handle(next, request);
                }));
            }
            if (error && error.status == 500) {
                throw error;
            }
            return throwError(error);
        }));
    }
    async refreshTokenAsync() {
        try {
            return await this.http
                .get(this.serviceUrl + '/rest/v2/session/login')
                .pipe(tap((data) => {
                const expiration = moment$3(data['result']['expiration']['date']);
                const tokenSaveData = {
                    token: data['result']['token'],
                    expiry: expiration,
                };
                localStorage.setItem('token', JSON.stringify(tokenSaveData));
                this.token = data['result']['token'];
                this.analytics.session();
            }))
                .toPromise();
        }
        catch (error) {
            if (error.constructor.name === 'HttpErrorResponse') {
                error.error.Message + ' (' + error.message + ')';
                error = error.error;
                Sentry.captureMessage(error.originalError || error.error || error);
            }
            else if (error instanceof RangeError) {
                Sentry.captureException(error);
            }
            return Promise.reject(error);
        }
    }
    refreshToken(request, next) {
        try {
            this.http
                .get(this.serviceUrl + '/rest/v2/session/login')
                .subscribe((data) => {
                const expiration = moment$3(data['result']['expiration']['date']);
                const tokenSaveData = {
                    token: data['result']['token'],
                    expiry: expiration,
                };
                localStorage.setItem('token', JSON.stringify(tokenSaveData));
                this.token = data['result']['token'];
                this.analytics.session();
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${data['result']['token']}`,
                    },
                });
                return next.handle(request);
            });
        }
        catch (error) {
            if (error.constructor.name === 'HttpErrorResponse') {
                error.error.Message + ' (' + error.message + ')';
                error = error.error;
                Sentry.captureMessage(error.originalError || error.error || error);
            }
            else if (error instanceof RangeError) {
                Sentry.captureException(error);
            }
            else {
                console.log(error);
                return null;
            }
        }
    }
    extractToken() {
        try {
            let tokenData = JSON.parse(localStorage.getItem('token') || '{}');
            if (tokenData.token) {
                this.token = tokenData.token;
                this.expiration = tokenData.expiry;
            }
        }
        catch (e) {
            this.token = null;
            this.expiration = null;
        }
    }
}
TokenInterceptor.ɵfac = function TokenInterceptor_Factory(t) { return new (t || TokenInterceptor)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(AnalyticsService), i0.ɵɵinject(ApiBaseService)); };
TokenInterceptor.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TokenInterceptor, factory: TokenInterceptor.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TokenInterceptor, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }, { type: AnalyticsService }, { type: ApiBaseService }]; }, null); })();

class LocationService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
    }
    getCountry() {
        return this.http.get(`assets/json/country.json`);
    }
}
LocationService.ɵfac = function LocationService_Factory(t) { return new (t || LocationService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject('env')); };
LocationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LocationService, factory: LocationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

class AerialAirlineService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.airlines = [];
        this.cache = new Map();
        this.serviceUrl = `${env.apiUrl}/rest/v2/airline/`;
    }
    airlineIndex(iata) {
        if (this.cache.has(iata)) {
            return this.cache.get(iata);
        }
        const request = this.http.get(`${this.serviceUrl}index`, { params: { cia: iata } })
            .pipe(map((res) => res['result'][0]), tap$1(airline => this.airlines.push(airline)), retry({ count: 2, delay: 1000 }), catchError(() => {
            throw Error('Unable to process the request');
        }), shareReplay(1));
        this.cache.set(iata, request);
        return request;
    }
}
AerialAirlineService.ɵfac = function AerialAirlineService_Factory(t) { return new (t || AerialAirlineService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject('env')); };
AerialAirlineService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AerialAirlineService, factory: AerialAirlineService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AerialAirlineService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

//
class ApiTravelPackageService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl = apiBaseService.getBaseUrl() + '/rest/v2/travelPackage/price';
    }
    packagePrice(request) {
        return this.http.post(this.serviceUrl, request).pipe(map$1(response => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                const model = new ApiPackagePriceResponse();
                model.fromApi(response['result'], response['meta']);
                return model;
            }
            throw Error('API Error');
        }), catchError$1(this.handleError));
    }
    pricing(requestTravel) {
        return this.http.post(this.serviceUrl, requestTravel).pipe(map$1(response => {
            let result = null;
            if (response.hasOwnProperty('success') && response['success'] === true) {
                result = (response);
            }
            return result;
        }), retry$1({ count: 2, delay: 1000 }), catchError$1(error => {
            console.log(error);
            return EMPTY;
        }), share$1());
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
ApiTravelPackageService.ɵfac = function ApiTravelPackageService_Factory(t) { return new (t || ApiTravelPackageService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiTravelPackageService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiTravelPackageService, factory: ApiTravelPackageService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiTravelPackageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiJuniperHotelRoomService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl =
            apiBaseService.getBaseUrl() + '/rest/v3/hotel/searchRoom';
    }
    getRooms(request) {
        return this.http.post(this.serviceUrl, request.toApiRequest()).pipe(map((response) => {
            if (response.hasOwnProperty('success') &&
                response['success'] === true) {
                const hotelOptions = response['result'].map((x) => {
                    const model = new ApiJuniperHotelRoomSearchResponseModel();
                    model.fromApi(x);
                    return model;
                });
                return hotelOptions;
            }
            else {
                throw Error('API Error');
            }
        }), catchError(this.handleError));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError('Something bad happened; please try again later.');
    }
}
ApiJuniperHotelRoomService.ɵfac = function ApiJuniperHotelRoomService_Factory(t) { return new (t || ApiJuniperHotelRoomService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiJuniperHotelRoomService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiJuniperHotelRoomService, factory: ApiJuniperHotelRoomService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiJuniperHotelRoomService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiJuniperHotelRoomSearchRequestModel extends ApiResource {
    constructor() {
        super();
        this.rooms = [];
        this.checkInDate = null;
        this.checkOutDate = null;
        this.sourceCode = null;
    }
    toApiRequest() {
        return {
            rooms: this.rooms,
            checkInDate: this.checkInDate.format(MOMENT_FORMATS.API_DATE),
            checkOutDate: this.checkOutDate.format(MOMENT_FORMATS.API_DATE),
            sourceCode: this.sourceCode
        };
    }
}
class JuniperHotelRoomGuestModel {
    constructor() {
        this.childAges = [];
    }
}

class ApiJuniperHotelPriceService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl = apiBaseService.getBaseUrl() + '/rest/v3/hotel';
    }
    hotelPrice(pricing) {
        return this.http.post(this.serviceUrl + '/price', pricing.toApiRequest())
            .pipe(map$1((response) => {
            if (response.hasOwnProperty('success') && response['success'] === true) {
                const model = new ApiJuniperHotelPriceResponseModel();
                model.fromApi(response['result']);
                return model;
            }
            throw Error('API Error');
        }), retry$1({ count: 2, delay: 1000 }), catchError$1(this.handleError));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError('Something bad happened; please try again later.');
    }
}
ApiJuniperHotelPriceService.ɵfac = function ApiJuniperHotelPriceService_Factory(t) { return new (t || ApiJuniperHotelPriceService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiJuniperHotelPriceService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiJuniperHotelPriceService, factory: ApiJuniperHotelPriceService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiJuniperHotelPriceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiJuniperHotelPriceRequestModel extends ApiResource {
    constructor() {
        super();
        this.price = new JuniperHotelRoomPrice();
        this.checkIn = null;
        this.checkOut = null;
        this.sourceCode = null;
        this.ratePlanCode = null;
        this.rooms = [];
    }
    toApiRequest() {
        return {
            checkInDate: this.checkIn.format(MOMENT_FORMATS.API_DATE),
            checkOutDate: this.checkOut.format(MOMENT_FORMATS.API_DATE),
            sourceCode: this.sourceCode,
            ratePlanCode: this.ratePlanCode,
            price: this.price,
            rooms: this.rooms
        };
    }
}

class ApiJuniperHotelBookResponseModel extends ApiResource {
    fromApi(apiData) {
        super.fromApi(apiData);
        this.price = new JuniperHotelRoomPrice();
        this.price.fromApi(apiData['price']);
        this.pensionType = new JuniperHotelRoomPensionType();
        this.pensionType.fromApi(apiData['pensionType']);
        if (Array.isArray(apiData['rooms'])) {
            this.rooms = apiData['rooms'].map((x) => {
                const model = new JuniperHotelRoom();
                model.fromApi(x);
                return model;
            });
        }
        else if (!apiData['rooms']) {
            this.rooms = [];
        }
        this.hotelInfo = new JuniperHotelResponseModel();
        this.hotelInfo.fromApi(apiData['hotelInfo']);
        this.cancellationPolicy = new JuniperHotelRoomCancellationPolicy();
        this.cancellationPolicy.fromApi(apiData['cancellationPolicy']);
    }
    getApiDatetimeFields() {
        return ['checkIn', 'checkOut'];
    }
}
class HotelBookStatus {
}

class ApiJuniperHotelBookService {
    constructor(http, apiBaseService) {
        this.http = http;
        this.apiBaseService = apiBaseService;
        this.serviceUrl = apiBaseService.getBaseUrl() + '/rest/v3/hotel';
    }
    hotelBooking(data) {
        return this.http
            .post(this.serviceUrl + '/book', data)
            .pipe(map$1((response) => {
            if (response.hasOwnProperty('success') &&
                response['success'] === true) {
                const model = new ApiJuniperHotelBookResponseModel();
                model.fromApi(response['result']);
                return model;
            }
            throw Error('API Error');
        }), retry$1({ count: 2, delay: 1000 }), catchError$1(this.handleError));
    }
    handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError('Something bad happened; please try again later.');
    }
}
ApiJuniperHotelBookService.ɵfac = function ApiJuniperHotelBookService_Factory(t) { return new (t || ApiJuniperHotelBookService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApiBaseService)); };
ApiJuniperHotelBookService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApiJuniperHotelBookService, factory: ApiJuniperHotelBookService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ApiJuniperHotelBookService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: i1.HttpClient }, { type: ApiBaseService }]; }, null); })();

class ApiJuniperHotelBookRequestModel extends ApiResource {
    constructor() {
        super();
        this.contactName = null;
        this.contactPhone = null;
        this.checkIn = null;
        this.checkOut = null;
        this.sourceCode = null;
        this.bookingCode = null;
        this.price = new JuniperHotelRoomPrice();
        this.rooms = [];
    }
    toApiRequest() {
        return {
            checkIn: this.checkIn.format(MOMENT_FORMATS.API_DATE),
            checkOut: this.checkOut.format(MOMENT_FORMATS.API_DATE),
            sourceCode: this.sourceCode,
            bookingCode: this.bookingCode,
            price: this.price,
            rooms: this.rooms,
            contactName: this.contactName,
            contactPhone: this.contactPhone,
        };
    }
}
class JuniperBookRooms {
}
;

/*
 * Public API Surface of zupper-data
 */
// models

/**
 * Generated bundle index. Do not edit.
 */

export { API_BOOKING_ERROR_TYPE, AbstractPaymentRequest, AccountValidationInfo, AddressJuniper, AerialAirlineService, AerialBookingService, AerialCheckoutPayment, AerialOrder, AerialOrderFlightSegment, AerialOrderPassenger, AerialOrderPricing, AerialOrderSlice, AerialPriceService, AerialPriceSummary, AerialSourceEnum, AerialStorageSearchService, AirlineModel, AirlineRules, Airlines, Airport, AirportModel, AnalyticsService, ApiAddress, ApiAddressResponse, ApiAddressService, ApiAerialBaseFares, ApiAerialBaseFaresBook, ApiAerialBookErrorSentryRequest, ApiAerialBookFullResponse, ApiAerialBookRequest, ApiAerialBookResponse, ApiAerialBookSentry, ApiAerialDeepLinkService, ApiAerialFamiliesBaseFareRequest, ApiAerialFamiliesBaseFareResponse, ApiAerialFamiliesBasefareService, ApiAerialFamilyItem, ApiAerialGeolocation, ApiAerialGeolocationIpService, ApiAerialPassenger, ApiAerialPassengerBook, ApiAerialPricePassengerRequest, ApiAerialPriceRequest, ApiAerialPriceService, ApiAerialPromo, ApiAerialPromoSlice, ApiAerialPromotionsService, ApiAerialReservationResponse, ApiAerialSegment, ApiAerialSegmentBook, ApiAerialSlice, ApiAerialSliceBook, ApiAerialSourceService, ApiAirline, ApiAirlineMinor, ApiAirport, ApiAirportSearchService, ApiBannerService, ApiBaseModel, ApiBaseService, ApiBookingError, ApiCampaignModel, ApiCampaignService, ApiCartService, ApiCityService, ApiConfiguration, ApiContentConfigurationService, ApiCorporateLoginModel, ApiCorporateLoginService, ApiCorporateModel, ApiCorporateService, ApiCustomer, ApiCustomerLoginRequest, ApiCustomerOrdersError, ApiCustomerOrdersResponse, ApiCustomerService, ApiDestination, ApiEmailService, ApiFlightClass, ApiFlightDirectionEnum, ApiFlightRequest, ApiFlightSearchService, ApiFlightSlice, ApiFlightType, ApiHotelBookErrorSentryRequest, ApiHotelCheckoutService, ApiHotelDeepLinkService, ApiHotelDeeplinkResponse, ApiHotelDeeplinkRoomResponse, ApiHotelPromotionsService, ApiHotelRequest, ApiImage, ApiInvoiceService, ApiJuniperHotelBookRequestModel, ApiJuniperHotelBookResponseModel, ApiJuniperHotelBookService, ApiJuniperHotelPriceRequestModel, ApiJuniperHotelPriceResponseModel, ApiJuniperHotelPriceService, ApiJuniperHotelRoomSearchRequestModel, ApiJuniperHotelRoomSearchResponseModel, ApiJuniperHotelRoomService, ApiJuniperHotelSearchService, ApiLoginService, ApiOffer, ApiOfferBlockItem, ApiOfferField, ApiOfferLabel, ApiOfferService, ApiOrderPriceService, ApiPackageBookRequest, ApiPackageBookResponse, ApiPackagePriceRequest, ApiPackagePriceResponse, ApiPackageRequest, ApiPackageSearchService, ApiPaymentService, ApiResponse, ApiTestimonialsService, ApiTokenRepositoryService, ApiTravelPackageModel, ApiTravelPackageService, AppSettings, AppSettingsService, AutoInitializable, AvailableCitiesModel, BankOption, BankTransferPaymentRequest, BannerModel, BaseFare, BasePaymentResponse, BookRequestHotelModel, BookingConfirmation, BookingDetails, BookingResume, Branding, CHECKOUT_PAYMENT_FORMS, COMBINED_SOURCES, CREDIT_CARD_CONFIG, CancellationOrMarkdown, CardCompanyOption, CashPaymentRequest, ChangePaymentMethod, CheckoutPayment, CheckoutPaymentFormsAerialRequestModel, CheckoutPaymentFormsHotelRequestModel, CheckoutPaymentFormsRequestModel, ConfigurationAttributes, CreditCard, CreditCardPaymentDetails, CreditCardPaymentRequest, CreditCardValidationRequest, CustomerOrderCreditCard, CustomerOrders, CustomerOrdersFilters, DefaultResponseModel, DescriptionHotelJuniper, FlightResultModel, GroupedFamiliesBasefare, GroupedFamiliesDetails, GroupedFlightBasefare, GroupedFlightMapper, GroupedFlightSegment, GroupedFlightSlice, GroupedFlightSliceDirection, GuestPriceResponse, HOTEL_CONTACT_TYPES, HOTEL_FEATURES, HotelAddressModel, HotelBestPriceModel, HotelBillingMethodEnum, HotelBookRequestModel, HotelBookStatus, HotelBookingConfirmation, HotelBookingHotelInfo, HotelBookingRoomInfo, HotelCancellingPolicyModel, HotelCategories, HotelChainModel, HotelCheckoutPayment, HotelContactsModel, HotelCurrencyModel, HotelDistrict, HotelFareModel, HotelFilterData, HotelGuaranteeMethodEnum, HotelGuestModel, HotelImages, HotelInterestPoint, HotelMainImage, HotelOrder, HotelOrderGuest, HotelOrderQuotation, HotelPaymentMethodEnum, HotelPensionTypeEnum, HotelPriceResponseModel, HotelPriceSummary, HotelPricingModel, HotelQuotationsModel, HotelResponseModel, HotelResultFilters, HotelRoomGuestModel, HotelRoomModel, HotelRoomQuotationModel, HotelRoomResponseModel, HotelRoomsSearchRequestModel, HotelValue, HowToPayStep, ImageLogoBank, ImagesHotelJuniper, InstallmentValue, InstallmentsModel, InterestPointsHotelJuniper, InvoiceDataRequest, InvoiceDataResponseModel, JuniperBookRooms, JuniperHotelComments, JuniperHotelGuest, JuniperHotelPensionType, JuniperHotelResponseModel, JuniperHotelRoom, JuniperHotelRoomCancellationPolicy, JuniperHotelRoomGuestModel, JuniperHotelRoomOccupancy, JuniperHotelRoomPensionType, JuniperHotelRoomPolicyRules, JuniperHotelRoomPrice, JuniperRoomImages, LastAccess, LocationService, LoginModel, MOMENT_FORMATS, MainImageJuniper, MinorData, MinorPassenger, OrderPayer, OrderPriceResult, OrderReservations, OrderVoucher, OrderVoucherAerial, OrderVoucherAerialAirport, OrderVoucherAerialSegment, OrderVoucherCreditCard, OrderVoucherHotel, OrderVoucherHotelGuest, OrderVoucherHotelInformation, OrderVoucherPassenger, OrderVoucherPayment, OrderVoucherPaymentForm, OrderVoucherProduct, OrderVoucherRoom, PAYMENT_CHANNEL, PAYMENT_FORM, PENSION_TYPES_AND_DESCRIPTION$2 as PENSION_TYPES_AND_DESCRIPTION, PackageBookingService, PackagePriceSummary, PaginatedResource, Passenger, PaymentInformation, PaymentInstruction, PaymentInstructions, PaymentLocation, PaymentOption, PaymentValidateAccountRequest, PaymentValidateTokenRequest, PensionType, PensionTypeCodes$2 as PensionTypeCodes, PixPaymentRequest, Price, PriceResult, PricedHotelModel, RdstationNewsletterModel, RdstationNewsletterPayload, RdstationNewsletterService, Refund, RoomOptions, RoomSearchModel, SITUATION, SITUATION_KEY, Segments, Situation, Slices, TestimonialModel, TokenInterceptor, UnaccompaniedMinorExtraServiceEnum, WEBSITE_PAGE, WEBSITE_VIEWPORT, WithGuid, ZupperBlogEntry, ZupperBlogService, ZupperDataModule, ZupperPaymentForm, pensionTypesText };
